// Generated V1 TypeScript client for the JacqOS Web Studio cloud API.
// Source: runtime/jacqos-contracts::web_studio_cloud_api. Do not edit by hand.

export const WEB_STUDIO_CLOUD_API_OPERATION_CONTRACT_VERSION =
  "jacqos-web-studio-cloud-api:v1" as const;

export const WEB_STUDIO_CLOUD_API_GENERATED_ARTIFACT_PROVENANCE = {
  "artifact_id": "schema-catalog",
  "generator_version": "jacqos.web_studio.generator.v1",
  "generator_source": "runtime/jacqos-contracts::web_studio_cloud_api",
  "source_contract": "runtime/jacqos-contracts::CloudApiContractSet::web_studio_replacement_contract",
  "source_contract_digest": "sha256:fbc289d60f6836af9843a826f89e617e07977d11c4821947809109d5fb6b8c1d",
  "parity_matrix_digest": "sha256:d5e6068b08af637f64652fd70e48cf5ea11cf32086d9a388ed586d1c74890789",
  "deterministic_inputs": [
    "openspec/changes/archive/2026-06-26-plan-typescript-web-studio-implementation/parity-matrix.md",
    "openspec/specs/studio-*",
    "runtime/jacqos-contracts::CloudApiContractSet::web_studio_replacement_contract"
  ],
  "reproducible": true,
  "redaction_state": "public_metadata_only"
} as const;

export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonValue[] | { [key: string]: JsonValue };
export type JsonObject = { [key: string]: JsonValue };

export interface WebStudioActor {
  actorId: string;
  actorKind: string;
  displayName?: string;
}

export interface WebStudioTarget {
  accountId: string;
  organizationId: string;
  projectId: string;
  workspaceId: string;
  environmentId: string;
  lineageId?: string;
  activationId?: string;
}

export interface WebStudioAuthorityMetadata {
  authorityKind: string;
  runtimeRole: string;
  authorityEvidenceDigest: string;
  evaluatorDigest?: string;
  packageDigest?: string;
  lineageId?: string;
  activationId?: string;
}

export interface WebStudioCompatibilityMetadata {
  contractVersion: string;
  runtimeStatus: string;
  actionAvailabilityDigest: string;
  routeAvailabilityDigest: string;
  minimumRequiredContract?: string;
  stale?: boolean;
}

export interface WebStudioGeneratedArtifactProvenance {
  artifactId: string;
  generatorVersion: string;
  generatorSource: string;
  sourceContract: string;
  sourceContractDigest: string;
  parityMatrixDigest: string;
  deterministicInputs: string[];
  reproducible: boolean;
  redactionState: string;
}

export interface WebStudioActionAvailabilityEntry {
  action: string;
  state: string;
  label: string;
  disabledReason: string;
  diagnosticCode?: string;
}

export interface WebStudioActionAvailabilityReport {
  rows: WebStudioActionAvailabilityEntry[];
}

export interface WebStudioSignInAction {
  actionId: string;
  operationId: string;
  method: "GET" | "POST";
  route: string;
  kind: string;
  label: string;
}

export interface WebStudioSignInAvailability {
  availability: "available" | "provider_unconfigured" | "guidance_only";
  actions: WebStudioSignInAction[];
  diagnosticCode: string | null;
  guidance: string | null;
}

export interface WebStudioSignInStart {
  status: "code_sent";
  provider: string;
  email: string;
  expiresIn: number;
}

export interface WebStudioSignInComplete {
  status: "authenticated";
  provider: string;
  subjectId: string;
  organizationId: string;
  expiresIn: number;
}

export interface WebStudioSignOutResult {
  status: "signed_out";
  revoked: boolean;
  logoutUrl?: string;
}

export interface WebStudioDiagnostic {
  code: string;
  category: "validation" | "authorization" | "compatibility" | "stale_state" | "redaction" | "rate_limit" | "availability" | "backend_execution" | "stream" | "deployment_gate";
  severity: "info" | "warning" | "error";
  retryability: "retryable" | "refresh_required" | "not_retryable";
  message: string;
  remediationTarget?: string;
  refreshTarget?: string;
  correlationId: string;
  requestId?: string;
  scope?: JsonObject;
  evidenceRefs?: string[];
  redactionState: string;
  source?: string;
}

export interface WebStudioRouteAvailabilityEntry {
  operationId: string;
  routeTemplate: string;
  method: "GET" | "POST";
  presentationModelId?: string;
  availabilityState: "enabled_preview" | "enabled_default" | "disabled_until_backend_receipt_contract" | "disabled_incident" | "maintenance" | "unsupported";
  actionFamily?: string;
  generatedContractIdentity: string;
  requiredForPreview?: boolean;
  requiredForDefault?: boolean;
  diagnosticCode: string;
  disablementEvidenceRequired?: boolean;
  redactionState: string;
}

export interface WebStudioRouteAvailabilityManifest {
  schemaVersion: "jacqos.contracts.v1";
  manifestVersion: "jacqos.web_studio.availability_manifest.v1";
  generatorVersion?: string;
  buildId: string;
  generatedContractIdentity: string;
  parityManifestIdentity: string;
  schemaCatalogDigest: string;
  parityMatrixDigest: string;
  artifactProvenance: WebStudioGeneratedArtifactProvenance;
  origin: string;
  environment: string;
  tenantScope: string;
  runtimeAuthority: string;
  operationRoutes: { [operation: string]: WebStudioRouteAvailabilityEntry };
  disabledDiagnostics?: string[];
  redactionState: string;
}

export interface WebStudioPresentationRow {
  rowId: string;
  label: string;
  status: string;
  displayOrder: number;
  groupId?: string;
  valueSummary?: string;
  count?: number;
  provenanceSeedId?: string;
  semanticPlane?: string;
  displayTimestamp?: string;
  disabledReason?: string;
  diagnosticCode?: string;
  redactionState?: string;
}

export interface WebStudioResponseIdentity {
  generatedScopeDigest: string;
  routeStateDigest: string;
  operationContractIdentity: string;
  snapshotIdentity: string;
  sectionDigests?: JsonObject;
  freshnessExpiresAt: string;
  cachePolicy: string;
  correlationId: string;
  redactionState: string;
}

export interface WebStudioCachePolicy {
  cacheControl: string;
  serviceWorkerCacheable: boolean;
  sharedCacheable: boolean;
  staticAssetCacheable?: boolean;
  authority: string;
  redactionState: string;
}

export interface WebStudioFreshnessMetadata {
  buildId: string;
  generatedContractIdentity: string;
  selectedScopeDigest: string;
  routeStateDigest: string;
  factsPlaneSnapshotDigest?: string;
  provenanceSeedDigest?: string;
  cursorExpiresAt?: string;
  actionAvailabilityDigest: string;
  expiresAt: string;
  stale: boolean;
  redactionState: string;
}

export interface WebStudioCollectionState {
  snapshotId: string;
  cursor?: string;
  nextCursor?: string;
  pageToken?: string;
  defaultPageSize: number;
  maxPageSize: number;
  cursorExpiresAt?: string;
  payloadSizeBudgetBytes: number;
  latencyBudgetMs: number;
  totalCount?: number;
  countSemantics: string;
  truncated?: boolean;
  truncationDiagnostic?: WebStudioDiagnostic;
  partialResultSemantics: string;
  streamBackpressure: string;
  stale?: boolean;
  staleCursorDiagnostic?: WebStudioDiagnostic;
  filterDescriptors?: WebStudioPresentationRow[];
  groupDescriptors?: WebStudioPresentationRow[];
  redactionState: string;
}

export interface WebStudioRouteState {
  routeStateId: string;
  requestedContextDigest?: string;
  authorizationState: string;
  workspaceId?: string;
  environmentId?: string;
  lineageId?: string;
  activationId?: string;
  semanticPlane?: string;
  activityRowId?: string;
  provenanceSeedId?: string;
  commandId?: string;
  supportSnapshotId?: string;
  shellReference?: string;
  inspectorContext?: string;
  activityLens?: string;
  replaySubMode?: string;
  exportKind?: string;
  mutationContextDigest?: string;
  notFoundReason?: string;
  diagnostic?: WebStudioDiagnostic;
  redactionState: string;
}

export interface WebStudioPresentationModel {
  presentationModelId: string;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  filters?: WebStudioPresentationRow[];
  groups?: WebStudioPresentationRow[];
  summary?: JsonObject;
}

export interface WebStudioPresentationSection {
  sectionId: string;
  label: string;
  sectionOrder: number;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  filters?: WebStudioPresentationRow[];
  groups?: WebStudioPresentationRow[];
  diagnostics?: WebStudioDiagnostic[];
  summary?: JsonObject;
  sectionDigest: string;
  redactionState: string;
}

export interface WebStudioProvenanceSeedMetadata {
  seedId: string;
  seedKind: string;
  rowId: string;
  lineageId?: string;
  activationId?: string;
  evaluatorDigest?: string;
  packageDigest?: string;
  evidenceDigest: string;
  availability: string;
  redactionState: string;
}

export interface WebStudioFactsPlaneSnapshot {
  semanticPlane: "facts";
  lineageId: string;
  worldviewId?: string;
  activationId: string;
  evaluatorDigest: string;
  packageDigest: string;
  snapshotCursor?: string;
  evidenceDigest: string;
  redactionPolicy?: string;
  rowCountSemantics: string;
  rows: WebStudioPresentationRow[];
  sections: WebStudioPresentationSection[];
  collection: WebStudioCollectionState;
  filters?: WebStudioPresentationRow[];
  groups?: WebStudioPresentationRow[];
  diagnostics?: WebStudioDiagnostic[];
  provenanceSeeds: WebStudioProvenanceSeedMetadata[];
  redactionState: string;
}

export interface WebStudioEvidence {
  evidenceId: string;
  evidenceDigest: string;
  receiptDigest?: string;
}

export interface WebStudioReceipt {
  receiptId: string;
  receiptDigest: string;
  terminalState: string;
  auditDigest?: string;
}

export interface WebStudioExpectedState {
  targetDigest: string;
  activationId?: string;
  lineageHead?: string;
  version?: string;
}

export interface WebStudioGraphNode {
  nodeId: string;
  kind: string;
  label: string;
  rawStableId?: string;
  redacted?: boolean;
}

export interface WebStudioGraphEdge {
  edgeId: string;
  sourceNodeId: string;
  targetNodeId: string;
  kind: string;
  provenanceRef?: string;
}

export interface WebStudioProvenanceGraph {
  graphId: string;
  nodes: WebStudioGraphNode[];
  edges: WebStudioGraphEdge[];
  rawStableIds?: string[];
  redactionState: string;
  lineageId?: string;
  activationId?: string;
  evaluatorDigest?: string;
  packageDigest?: string;
}

export type WebStudioPathParams = { [key: string]: string | number | boolean | undefined };
export interface WebStudioQueryParams {
  cursor?: string;
  limit?: number;
  viewId?: string;
  scope?: string;
  shellReference?: string;
  inspectorContext?: string;
  activityLens?: string;
  replaySubMode?: string;
  exportKind?: string;
  provenanceSeedId?: string;
  commandId?: string;
  supportSnapshotId?: string;
  mutationContextDigest?: string;
  [key: string]: string | number | boolean | undefined;
}
export type WebStudioBody = { [key: string]: JsonValue | undefined };

export interface AuthenticateParams extends WebStudioPathParams {}
export interface AuthenticateQuery extends WebStudioQueryParams {}
export interface AuthenticateBody extends WebStudioBody {}
export interface AuthenticateData {
  operationId: "authenticate";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  signInComplete?: WebStudioSignInComplete;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface AuthenticateDiagnostic {
  operation: "authenticate";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface AuthenticateEvidence extends WebStudioEvidence {}
export interface AuthenticateReceipt extends WebStudioReceipt {}
export interface AuthenticateUnavailableAction {
  operation: "authenticate";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface AuthenticateRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "authenticate";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: AuthenticateParams;
  query?: AuthenticateQuery;
  body?: AuthenticateBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface AuthenticateResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "authenticate";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: AuthenticateData;
  diagnostics: AuthenticateDiagnostic[];
  evidence: AuthenticateEvidence;
  receipt?: AuthenticateReceipt;
}

export interface AuthenticateStartParams extends WebStudioPathParams {}
export interface AuthenticateStartQuery extends WebStudioQueryParams {}
export interface AuthenticateStartBody extends WebStudioBody {}
export interface AuthenticateStartData {
  operationId: "authenticate_start";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  signInStart?: WebStudioSignInStart;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface AuthenticateStartDiagnostic {
  operation: "authenticate_start";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate_start";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface AuthenticateStartEvidence extends WebStudioEvidence {}
export interface AuthenticateStartReceipt extends WebStudioReceipt {}
export interface AuthenticateStartUnavailableAction {
  operation: "authenticate_start";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate_start";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface AuthenticateStartRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "authenticate_start";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate_start";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: AuthenticateStartParams;
  query?: AuthenticateStartQuery;
  body?: AuthenticateStartBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface AuthenticateStartResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "authenticate_start";
  operationContract: "jacqos-web-studio-cloud-api:v1/authenticate_start";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: AuthenticateStartData;
  diagnostics: AuthenticateStartDiagnostic[];
  evidence: AuthenticateStartEvidence;
  receipt?: AuthenticateStartReceipt;
}

export interface SignOutParams extends WebStudioPathParams {}
export interface SignOutQuery extends WebStudioQueryParams {}
export interface SignOutBody extends WebStudioBody {}
export interface SignOutData {
  operationId: "sign_out";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  signOut?: WebStudioSignOutResult;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface SignOutDiagnostic {
  operation: "sign_out";
  operationContract: "jacqos-web-studio-cloud-api:v1/sign_out";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SignOutEvidence extends WebStudioEvidence {}
export interface SignOutReceipt extends WebStudioReceipt {}
export interface SignOutUnavailableAction {
  operation: "sign_out";
  operationContract: "jacqos-web-studio-cloud-api:v1/sign_out";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SignOutRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "sign_out";
  operationContract: "jacqos-web-studio-cloud-api:v1/sign_out";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SignOutParams;
  query?: SignOutQuery;
  body?: SignOutBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SignOutResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "sign_out";
  operationContract: "jacqos-web-studio-cloud-api:v1/sign_out";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SignOutData;
  diagnostics: SignOutDiagnostic[];
  evidence: SignOutEvidence;
  receipt?: SignOutReceipt;
}

export interface SelectWorkspaceEnvironmentParams extends WebStudioPathParams {}
export interface SelectWorkspaceEnvironmentQuery extends WebStudioQueryParams {}
export interface SelectWorkspaceEnvironmentBody extends WebStudioBody {}
export interface SelectWorkspaceEnvironmentData {
  operationId: "select_workspace_environment";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface SelectWorkspaceEnvironmentDiagnostic {
  operation: "select_workspace_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace_environment";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SelectWorkspaceEnvironmentEvidence extends WebStudioEvidence {}
export interface SelectWorkspaceEnvironmentReceipt extends WebStudioReceipt {}
export interface SelectWorkspaceEnvironmentUnavailableAction {
  operation: "select_workspace_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace_environment";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SelectWorkspaceEnvironmentRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_workspace_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace_environment";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SelectWorkspaceEnvironmentParams;
  query?: SelectWorkspaceEnvironmentQuery;
  body?: SelectWorkspaceEnvironmentBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SelectWorkspaceEnvironmentResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_workspace_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace_environment";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SelectWorkspaceEnvironmentData;
  diagnostics: SelectWorkspaceEnvironmentDiagnostic[];
  evidence: SelectWorkspaceEnvironmentEvidence;
  receipt?: SelectWorkspaceEnvironmentReceipt;
}

export interface ReadIdentityParams extends WebStudioPathParams {}
export interface ReadIdentityQuery extends WebStudioQueryParams {}
export interface ReadIdentityBody extends WebStudioBody {}
export interface ReadIdentityData {
  operationId: "read_identity";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface ReadIdentityDiagnostic {
  operation: "read_identity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_identity";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadIdentityEvidence extends WebStudioEvidence {}
export interface ReadIdentityReceipt extends WebStudioReceipt {}
export interface ReadIdentityUnavailableAction {
  operation: "read_identity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_identity";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadIdentityRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_identity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_identity";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadIdentityParams;
  query?: ReadIdentityQuery;
  body?: ReadIdentityBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadIdentityResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_identity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_identity";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadIdentityData;
  diagnostics: ReadIdentityDiagnostic[];
  evidence: ReadIdentityEvidence;
  receipt?: ReadIdentityReceipt;
}

export interface SelectAppEnvironmentParams extends WebStudioPathParams {}
export interface SelectAppEnvironmentQuery extends WebStudioQueryParams {}
export interface SelectAppEnvironmentBody extends WebStudioBody {}
export interface SelectAppEnvironmentData {
  operationId: "select_app_environment";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  profileRows?: WebStudioPresentationRow[];
  organizationRows?: WebStudioPresentationRow[];
}
export interface SelectAppEnvironmentDiagnostic {
  operation: "select_app_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_app_environment";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SelectAppEnvironmentEvidence extends WebStudioEvidence {}
export interface SelectAppEnvironmentReceipt extends WebStudioReceipt {}
export interface SelectAppEnvironmentUnavailableAction {
  operation: "select_app_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_app_environment";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SelectAppEnvironmentRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_app_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_app_environment";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SelectAppEnvironmentParams;
  query?: SelectAppEnvironmentQuery;
  body?: SelectAppEnvironmentBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SelectAppEnvironmentResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_app_environment";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_app_environment";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SelectAppEnvironmentData;
  diagnostics: SelectAppEnvironmentDiagnostic[];
  evidence: SelectAppEnvironmentEvidence;
  receipt?: SelectAppEnvironmentReceipt;
}

export interface ReadWorkspaceCatalogParams extends WebStudioPathParams {}
export interface ReadWorkspaceCatalogQuery extends WebStudioQueryParams {}
export interface ReadWorkspaceCatalogBody extends WebStudioBody {}
export interface ReadWorkspaceCatalogData {
  operationId: "read_workspace_catalog";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  workspaceRows?: WebStudioPresentationRow[];
  templateRows?: WebStudioPresentationRow[];
  worldviewRows?: WebStudioPresentationRow[];
  environmentRows?: WebStudioPresentationRow[];
  readTarget?: string;
  appendTarget?: string;
  transitionState?: string;
  signedCatalogIdentity?: string;
}
export interface ReadWorkspaceCatalogDiagnostic {
  operation: "read_workspace_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workspace_catalog";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadWorkspaceCatalogEvidence extends WebStudioEvidence {}
export interface ReadWorkspaceCatalogReceipt extends WebStudioReceipt {}
export interface ReadWorkspaceCatalogUnavailableAction {
  operation: "read_workspace_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workspace_catalog";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadWorkspaceCatalogRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_workspace_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workspace_catalog";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadWorkspaceCatalogParams;
  query?: ReadWorkspaceCatalogQuery;
  body?: ReadWorkspaceCatalogBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadWorkspaceCatalogResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_workspace_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workspace_catalog";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadWorkspaceCatalogData;
  diagnostics: ReadWorkspaceCatalogDiagnostic[];
  evidence: ReadWorkspaceCatalogEvidence;
  receipt?: ReadWorkspaceCatalogReceipt;
}

export interface ReadTemplateCatalogParams extends WebStudioPathParams {}
export interface ReadTemplateCatalogQuery extends WebStudioQueryParams {}
export interface ReadTemplateCatalogBody extends WebStudioBody {}
export interface ReadTemplateCatalogData {
  operationId: "read_template_catalog";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  workspaceRows?: WebStudioPresentationRow[];
  templateRows?: WebStudioPresentationRow[];
  worldviewRows?: WebStudioPresentationRow[];
  environmentRows?: WebStudioPresentationRow[];
  readTarget?: string;
  appendTarget?: string;
  transitionState?: string;
  signedCatalogIdentity?: string;
}
export interface ReadTemplateCatalogDiagnostic {
  operation: "read_template_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_template_catalog";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadTemplateCatalogEvidence extends WebStudioEvidence {}
export interface ReadTemplateCatalogReceipt extends WebStudioReceipt {}
export interface ReadTemplateCatalogUnavailableAction {
  operation: "read_template_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_template_catalog";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadTemplateCatalogRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_template_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_template_catalog";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadTemplateCatalogParams;
  query?: ReadTemplateCatalogQuery;
  body?: ReadTemplateCatalogBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadTemplateCatalogResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_template_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_template_catalog";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadTemplateCatalogData;
  diagnostics: ReadTemplateCatalogDiagnostic[];
  evidence: ReadTemplateCatalogEvidence;
  receipt?: ReadTemplateCatalogReceipt;
}

export interface CreateWorkspaceFromTemplateParams extends WebStudioPathParams {}
export interface CreateWorkspaceFromTemplateQuery extends WebStudioQueryParams {}
export interface CreateWorkspaceFromTemplateBody extends WebStudioBody {}
export interface CreateWorkspaceFromTemplateData {
  operationId: "create_workspace_from_template";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  workspaceRows?: WebStudioPresentationRow[];
  templateRows?: WebStudioPresentationRow[];
  worldviewRows?: WebStudioPresentationRow[];
  environmentRows?: WebStudioPresentationRow[];
  readTarget?: string;
  appendTarget?: string;
  transitionState?: string;
  signedCatalogIdentity?: string;
}
export interface CreateWorkspaceFromTemplateDiagnostic {
  operation: "create_workspace_from_template";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface CreateWorkspaceFromTemplateEvidence extends WebStudioEvidence {}
export interface CreateWorkspaceFromTemplateReceipt extends WebStudioReceipt {}
export interface CreateWorkspaceFromTemplateUnavailableAction {
  operation: "create_workspace_from_template";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface CreateWorkspaceFromTemplateRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "create_workspace_from_template";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: CreateWorkspaceFromTemplateParams;
  query?: CreateWorkspaceFromTemplateQuery;
  body?: CreateWorkspaceFromTemplateBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface CreateWorkspaceFromTemplateResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "create_workspace_from_template";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: CreateWorkspaceFromTemplateData;
  diagnostics: CreateWorkspaceFromTemplateDiagnostic[];
  evidence: CreateWorkspaceFromTemplateEvidence;
  receipt?: CreateWorkspaceFromTemplateReceipt;
}
export interface CreateWorkspaceFromTemplateStreamEvent {
  operation: "create_workspace_from_template";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: CreateWorkspaceFromTemplateData;
  diagnostic?: CreateWorkspaceFromTemplateDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface SelectWorkspaceParams extends WebStudioPathParams {}
export interface SelectWorkspaceQuery extends WebStudioQueryParams {}
export interface SelectWorkspaceBody extends WebStudioBody {}
export interface SelectWorkspaceData {
  operationId: "select_workspace";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  workspaceRows?: WebStudioPresentationRow[];
  templateRows?: WebStudioPresentationRow[];
  worldviewRows?: WebStudioPresentationRow[];
  environmentRows?: WebStudioPresentationRow[];
  readTarget?: string;
  appendTarget?: string;
  transitionState?: string;
  signedCatalogIdentity?: string;
}
export interface SelectWorkspaceDiagnostic {
  operation: "select_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SelectWorkspaceEvidence extends WebStudioEvidence {}
export interface SelectWorkspaceReceipt extends WebStudioReceipt {}
export interface SelectWorkspaceUnavailableAction {
  operation: "select_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SelectWorkspaceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SelectWorkspaceParams;
  query?: SelectWorkspaceQuery;
  body?: SelectWorkspaceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SelectWorkspaceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SelectWorkspaceData;
  diagnostics: SelectWorkspaceDiagnostic[];
  evidence: SelectWorkspaceEvidence;
  receipt?: SelectWorkspaceReceipt;
}

export interface SelectWorldviewParams extends WebStudioPathParams {}
export interface SelectWorldviewQuery extends WebStudioQueryParams {}
export interface SelectWorldviewBody extends WebStudioBody {}
export interface SelectWorldviewData {
  operationId: "select_worldview";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  workspaceRows?: WebStudioPresentationRow[];
  templateRows?: WebStudioPresentationRow[];
  worldviewRows?: WebStudioPresentationRow[];
  environmentRows?: WebStudioPresentationRow[];
  readTarget?: string;
  appendTarget?: string;
  transitionState?: string;
  signedCatalogIdentity?: string;
}
export interface SelectWorldviewDiagnostic {
  operation: "select_worldview";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_worldview";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SelectWorldviewEvidence extends WebStudioEvidence {}
export interface SelectWorldviewReceipt extends WebStudioReceipt {}
export interface SelectWorldviewUnavailableAction {
  operation: "select_worldview";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_worldview";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SelectWorldviewRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_worldview";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_worldview";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SelectWorldviewParams;
  query?: SelectWorldviewQuery;
  body?: SelectWorldviewBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SelectWorldviewResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "select_worldview";
  operationContract: "jacqos-web-studio-cloud-api:v1/select_worldview";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SelectWorldviewData;
  diagnostics: SelectWorldviewDiagnostic[];
  evidence: SelectWorldviewEvidence;
  receipt?: SelectWorldviewReceipt;
}

export interface InspectSourceBundleParams extends WebStudioPathParams {}
export interface InspectSourceBundleQuery extends WebStudioQueryParams {}
export interface InspectSourceBundleBody extends WebStudioBody {}
export interface InspectSourceBundleData {
  operationId: "inspect_source_bundle";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface InspectSourceBundleDiagnostic {
  operation: "inspect_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_source_bundle";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface InspectSourceBundleEvidence extends WebStudioEvidence {}
export interface InspectSourceBundleReceipt extends WebStudioReceipt {}
export interface InspectSourceBundleUnavailableAction {
  operation: "inspect_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_source_bundle";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface InspectSourceBundleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_source_bundle";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: InspectSourceBundleParams;
  query?: InspectSourceBundleQuery;
  body?: InspectSourceBundleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface InspectSourceBundleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_source_bundle";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: InspectSourceBundleData;
  diagnostics: InspectSourceBundleDiagnostic[];
  evidence: InspectSourceBundleEvidence;
  receipt?: InspectSourceBundleReceipt;
}

export interface UploadSourceBundleParams extends WebStudioPathParams {}
export interface UploadSourceBundleQuery extends WebStudioQueryParams {}
export interface UploadSourceBundleBody extends WebStudioBody {}
export interface UploadSourceBundleData {
  operationId: "upload_source_bundle";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface UploadSourceBundleDiagnostic {
  operation: "upload_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UploadSourceBundleEvidence extends WebStudioEvidence {}
export interface UploadSourceBundleReceipt extends WebStudioReceipt {}
export interface UploadSourceBundleUnavailableAction {
  operation: "upload_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UploadSourceBundleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upload_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UploadSourceBundleParams;
  query?: UploadSourceBundleQuery;
  body?: UploadSourceBundleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UploadSourceBundleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upload_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UploadSourceBundleData;
  diagnostics: UploadSourceBundleDiagnostic[];
  evidence: UploadSourceBundleEvidence;
  receipt?: UploadSourceBundleReceipt;
}
export interface UploadSourceBundleStreamEvent {
  operation: "upload_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UploadSourceBundleData;
  diagnostic?: UploadSourceBundleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReuseSourceBundleParams extends WebStudioPathParams {}
export interface ReuseSourceBundleQuery extends WebStudioQueryParams {}
export interface ReuseSourceBundleBody extends WebStudioBody {}
export interface ReuseSourceBundleData {
  operationId: "reuse_source_bundle";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface ReuseSourceBundleDiagnostic {
  operation: "reuse_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReuseSourceBundleEvidence extends WebStudioEvidence {}
export interface ReuseSourceBundleReceipt extends WebStudioReceipt {}
export interface ReuseSourceBundleUnavailableAction {
  operation: "reuse_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReuseSourceBundleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reuse_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReuseSourceBundleParams;
  query?: ReuseSourceBundleQuery;
  body?: ReuseSourceBundleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReuseSourceBundleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reuse_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReuseSourceBundleData;
  diagnostics: ReuseSourceBundleDiagnostic[];
  evidence: ReuseSourceBundleEvidence;
  receipt?: ReuseSourceBundleReceipt;
}
export interface ReuseSourceBundleStreamEvent {
  operation: "reuse_source_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReuseSourceBundleData;
  diagnostic?: ReuseSourceBundleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface SubmitAdmissionParams extends WebStudioPathParams {}
export interface SubmitAdmissionQuery extends WebStudioQueryParams {}
export interface SubmitAdmissionBody extends WebStudioBody {}
export interface SubmitAdmissionData {
  operationId: "submit_admission";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface SubmitAdmissionDiagnostic {
  operation: "submit_admission";
  operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SubmitAdmissionEvidence extends WebStudioEvidence {}
export interface SubmitAdmissionReceipt extends WebStudioReceipt {}
export interface SubmitAdmissionUnavailableAction {
  operation: "submit_admission";
  operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SubmitAdmissionRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "submit_admission";
  operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SubmitAdmissionParams;
  query?: SubmitAdmissionQuery;
  body?: SubmitAdmissionBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SubmitAdmissionResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "submit_admission";
  operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SubmitAdmissionData;
  diagnostics: SubmitAdmissionDiagnostic[];
  evidence: SubmitAdmissionEvidence;
  receipt?: SubmitAdmissionReceipt;
}
export interface SubmitAdmissionStreamEvent {
  operation: "submit_admission";
  operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: SubmitAdmissionData;
  diagnostic?: SubmitAdmissionDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface StreamDiagnosticsParams extends WebStudioPathParams {}
export interface StreamDiagnosticsQuery extends WebStudioQueryParams {}
export interface StreamDiagnosticsBody extends WebStudioBody {}
export interface StreamDiagnosticsData {
  operationId: "stream_diagnostics";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  activityRows?: WebStudioPresentationRow[];
  filterRows?: WebStudioPresentationRow[];
  filterCounts?: JsonObject;
  sessionScope?: string;
  lensDescriptorRows?: WebStudioPresentationRow[];
  lensMembershipRows?: WebStudioPresentationRow[];
  inspectorTimelineRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
}
export interface StreamDiagnosticsDiagnostic {
  operation: "stream_diagnostics";
  operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface StreamDiagnosticsEvidence extends WebStudioEvidence {}
export interface StreamDiagnosticsReceipt extends WebStudioReceipt {}
export interface StreamDiagnosticsUnavailableAction {
  operation: "stream_diagnostics";
  operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface StreamDiagnosticsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "stream_diagnostics";
  operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: StreamDiagnosticsParams;
  query?: StreamDiagnosticsQuery;
  body?: StreamDiagnosticsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface StreamDiagnosticsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "stream_diagnostics";
  operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: StreamDiagnosticsData;
  diagnostics: StreamDiagnosticsDiagnostic[];
  evidence: StreamDiagnosticsEvidence;
  receipt?: StreamDiagnosticsReceipt;
}
export interface StreamDiagnosticsStreamEvent {
  operation: "stream_diagnostics";
  operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: StreamDiagnosticsData;
  diagnostic?: StreamDiagnosticsDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadHostedAppsParams extends WebStudioPathParams {}
export interface ReadHostedAppsQuery extends WebStudioQueryParams {}
export interface ReadHostedAppsBody extends WebStudioBody {}
export interface ReadHostedAppsData {
  operationId: "read_hosted_apps";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface ReadHostedAppsDiagnostic {
  operation: "read_hosted_apps";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_hosted_apps";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadHostedAppsEvidence extends WebStudioEvidence {}
export interface ReadHostedAppsReceipt extends WebStudioReceipt {}
export interface ReadHostedAppsUnavailableAction {
  operation: "read_hosted_apps";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_hosted_apps";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadHostedAppsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_hosted_apps";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_hosted_apps";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadHostedAppsParams;
  query?: ReadHostedAppsQuery;
  body?: ReadHostedAppsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadHostedAppsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_hosted_apps";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_hosted_apps";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadHostedAppsData;
  diagnostics: ReadHostedAppsDiagnostic[];
  evidence: ReadHostedAppsEvidence;
  receipt?: ReadHostedAppsReceipt;
}

export interface ReadCloudOperationsParams extends WebStudioPathParams {}
export interface ReadCloudOperationsQuery extends WebStudioQueryParams {}
export interface ReadCloudOperationsBody extends WebStudioBody {}
export interface ReadCloudOperationsData {
  operationId: "read_cloud_operations";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface ReadCloudOperationsDiagnostic {
  operation: "read_cloud_operations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadCloudOperationsEvidence extends WebStudioEvidence {}
export interface ReadCloudOperationsReceipt extends WebStudioReceipt {}
export interface ReadCloudOperationsUnavailableAction {
  operation: "read_cloud_operations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadCloudOperationsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_cloud_operations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadCloudOperationsParams;
  query?: ReadCloudOperationsQuery;
  body?: ReadCloudOperationsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadCloudOperationsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_cloud_operations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadCloudOperationsData;
  diagnostics: ReadCloudOperationsDiagnostic[];
  evidence: ReadCloudOperationsEvidence;
  receipt?: ReadCloudOperationsReceipt;
}
export interface ReadCloudOperationsStreamEvent {
  operation: "read_cloud_operations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadCloudOperationsData;
  diagnostic?: ReadCloudOperationsDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface CompatibilityReportParams extends WebStudioPathParams {}
export interface CompatibilityReportQuery extends WebStudioQueryParams {}
export interface CompatibilityReportBody extends WebStudioBody {}
export interface CompatibilityReportData {
  operationId: "compatibility_report";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface CompatibilityReportDiagnostic {
  operation: "compatibility_report";
  operationContract: "jacqos-web-studio-cloud-api:v1/compatibility_report";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface CompatibilityReportEvidence extends WebStudioEvidence {}
export interface CompatibilityReportReceipt extends WebStudioReceipt {}
export interface CompatibilityReportUnavailableAction {
  operation: "compatibility_report";
  operationContract: "jacqos-web-studio-cloud-api:v1/compatibility_report";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface CompatibilityReportRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "compatibility_report";
  operationContract: "jacqos-web-studio-cloud-api:v1/compatibility_report";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: CompatibilityReportParams;
  query?: CompatibilityReportQuery;
  body?: CompatibilityReportBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface CompatibilityReportResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "compatibility_report";
  operationContract: "jacqos-web-studio-cloud-api:v1/compatibility_report";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: CompatibilityReportData;
  diagnostics: CompatibilityReportDiagnostic[];
  evidence: CompatibilityReportEvidence;
  receipt?: CompatibilityReportReceipt;
}

export interface ResolveProviderBindingsParams extends WebStudioPathParams {}
export interface ResolveProviderBindingsQuery extends WebStudioQueryParams {}
export interface ResolveProviderBindingsBody extends WebStudioBody {}
export interface ResolveProviderBindingsData {
  operationId: "resolve_provider_bindings";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  providerBindingRows?: WebStudioPresentationRow[];
  setupDiagnostics?: WebStudioDiagnostic[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  providerBindingReceipts?: WebStudioReceipt[];
}
export interface ResolveProviderBindingsDiagnostic {
  operation: "resolve_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/resolve_provider_bindings";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ResolveProviderBindingsEvidence extends WebStudioEvidence {}
export interface ResolveProviderBindingsReceipt extends WebStudioReceipt {}
export interface ResolveProviderBindingsUnavailableAction {
  operation: "resolve_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/resolve_provider_bindings";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ResolveProviderBindingsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "resolve_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/resolve_provider_bindings";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ResolveProviderBindingsParams;
  query?: ResolveProviderBindingsQuery;
  body?: ResolveProviderBindingsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ResolveProviderBindingsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "resolve_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/resolve_provider_bindings";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ResolveProviderBindingsData;
  diagnostics: ResolveProviderBindingsDiagnostic[];
  evidence: ResolveProviderBindingsEvidence;
  receipt?: ResolveProviderBindingsReceipt;
}

export interface ReadProviderBindingsParams extends WebStudioPathParams {}
export interface ReadProviderBindingsQuery extends WebStudioQueryParams {}
export interface ReadProviderBindingsBody extends WebStudioBody {}
export interface ReadProviderBindingsData {
  operationId: "read_provider_bindings";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  providerBindingRows?: WebStudioPresentationRow[];
  setupDiagnostics?: WebStudioDiagnostic[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  providerBindingReceipts?: WebStudioReceipt[];
}
export interface ReadProviderBindingsDiagnostic {
  operation: "read_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provider_bindings";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadProviderBindingsEvidence extends WebStudioEvidence {}
export interface ReadProviderBindingsReceipt extends WebStudioReceipt {}
export interface ReadProviderBindingsUnavailableAction {
  operation: "read_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provider_bindings";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadProviderBindingsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provider_bindings";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadProviderBindingsParams;
  query?: ReadProviderBindingsQuery;
  body?: ReadProviderBindingsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadProviderBindingsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_provider_bindings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provider_bindings";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadProviderBindingsData;
  diagnostics: ReadProviderBindingsDiagnostic[];
  evidence: ReadProviderBindingsEvidence;
  receipt?: ReadProviderBindingsReceipt;
}

export interface StartDeterministicTestRunParams extends WebStudioPathParams {}
export interface StartDeterministicTestRunQuery extends WebStudioQueryParams {}
export interface StartDeterministicTestRunBody extends WebStudioBody {}
export interface StartDeterministicTestRunData {
  operationId: "start_deterministic_test_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface StartDeterministicTestRunDiagnostic {
  operation: "start_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface StartDeterministicTestRunEvidence extends WebStudioEvidence {}
export interface StartDeterministicTestRunReceipt extends WebStudioReceipt {}
export interface StartDeterministicTestRunUnavailableAction {
  operation: "start_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface StartDeterministicTestRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: StartDeterministicTestRunParams;
  query?: StartDeterministicTestRunQuery;
  body?: StartDeterministicTestRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface StartDeterministicTestRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: StartDeterministicTestRunData;
  diagnostics: StartDeterministicTestRunDiagnostic[];
  evidence: StartDeterministicTestRunEvidence;
  receipt?: StartDeterministicTestRunReceipt;
}
export interface StartDeterministicTestRunStreamEvent {
  operation: "start_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: StartDeterministicTestRunData;
  diagnostic?: StartDeterministicTestRunDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PollDeterministicTestRunParams extends WebStudioPathParams {}
export interface PollDeterministicTestRunQuery extends WebStudioQueryParams {}
export interface PollDeterministicTestRunBody extends WebStudioBody {}
export interface PollDeterministicTestRunData {
  operationId: "poll_deterministic_test_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface PollDeterministicTestRunDiagnostic {
  operation: "poll_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PollDeterministicTestRunEvidence extends WebStudioEvidence {}
export interface PollDeterministicTestRunReceipt extends WebStudioReceipt {}
export interface PollDeterministicTestRunUnavailableAction {
  operation: "poll_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PollDeterministicTestRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "poll_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PollDeterministicTestRunParams;
  query?: PollDeterministicTestRunQuery;
  body?: PollDeterministicTestRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PollDeterministicTestRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "poll_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PollDeterministicTestRunData;
  diagnostics: PollDeterministicTestRunDiagnostic[];
  evidence: PollDeterministicTestRunEvidence;
  receipt?: PollDeterministicTestRunReceipt;
}
export interface PollDeterministicTestRunStreamEvent {
  operation: "poll_deterministic_test_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: PollDeterministicTestRunData;
  diagnostic?: PollDeterministicTestRunDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ExpectedOutputDiffParams extends WebStudioPathParams {}
export interface ExpectedOutputDiffQuery extends WebStudioQueryParams {}
export interface ExpectedOutputDiffBody extends WebStudioBody {}
export interface ExpectedOutputDiffData {
  operationId: "expected_output_diff";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface ExpectedOutputDiffDiagnostic {
  operation: "expected_output_diff";
  operationContract: "jacqos-web-studio-cloud-api:v1/expected_output_diff";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ExpectedOutputDiffEvidence extends WebStudioEvidence {}
export interface ExpectedOutputDiffReceipt extends WebStudioReceipt {}
export interface ExpectedOutputDiffUnavailableAction {
  operation: "expected_output_diff";
  operationContract: "jacqos-web-studio-cloud-api:v1/expected_output_diff";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ExpectedOutputDiffRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "expected_output_diff";
  operationContract: "jacqos-web-studio-cloud-api:v1/expected_output_diff";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ExpectedOutputDiffParams;
  query?: ExpectedOutputDiffQuery;
  body?: ExpectedOutputDiffBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ExpectedOutputDiffResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "expected_output_diff";
  operationContract: "jacqos-web-studio-cloud-api:v1/expected_output_diff";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ExpectedOutputDiffData;
  diagnostics: ExpectedOutputDiffDiagnostic[];
  evidence: ExpectedOutputDiffEvidence;
  receipt?: ExpectedOutputDiffReceipt;
}

export interface RetrieveEvidenceReceiptParams extends WebStudioPathParams {}
export interface RetrieveEvidenceReceiptQuery extends WebStudioQueryParams {}
export interface RetrieveEvidenceReceiptBody extends WebStudioBody {}
export interface RetrieveEvidenceReceiptData {
  operationId: "retrieve_evidence_receipt";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface RetrieveEvidenceReceiptDiagnostic {
  operation: "retrieve_evidence_receipt";
  operationContract: "jacqos-web-studio-cloud-api:v1/retrieve_evidence_receipt";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface RetrieveEvidenceReceiptEvidence extends WebStudioEvidence {}
export interface RetrieveEvidenceReceiptReceipt extends WebStudioReceipt {}
export interface RetrieveEvidenceReceiptUnavailableAction {
  operation: "retrieve_evidence_receipt";
  operationContract: "jacqos-web-studio-cloud-api:v1/retrieve_evidence_receipt";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface RetrieveEvidenceReceiptRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "retrieve_evidence_receipt";
  operationContract: "jacqos-web-studio-cloud-api:v1/retrieve_evidence_receipt";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: RetrieveEvidenceReceiptParams;
  query?: RetrieveEvidenceReceiptQuery;
  body?: RetrieveEvidenceReceiptBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface RetrieveEvidenceReceiptResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "retrieve_evidence_receipt";
  operationContract: "jacqos-web-studio-cloud-api:v1/retrieve_evidence_receipt";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: RetrieveEvidenceReceiptData;
  diagnostics: RetrieveEvidenceReceiptDiagnostic[];
  evidence: RetrieveEvidenceReceiptEvidence;
  receipt?: RetrieveEvidenceReceiptReceipt;
}

export interface ValidateEvidenceCacheParams extends WebStudioPathParams {}
export interface ValidateEvidenceCacheQuery extends WebStudioQueryParams {}
export interface ValidateEvidenceCacheBody extends WebStudioBody {}
export interface ValidateEvidenceCacheData {
  operationId: "validate_evidence_cache";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface ValidateEvidenceCacheDiagnostic {
  operation: "validate_evidence_cache";
  operationContract: "jacqos-web-studio-cloud-api:v1/validate_evidence_cache";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ValidateEvidenceCacheEvidence extends WebStudioEvidence {}
export interface ValidateEvidenceCacheReceipt extends WebStudioReceipt {}
export interface ValidateEvidenceCacheUnavailableAction {
  operation: "validate_evidence_cache";
  operationContract: "jacqos-web-studio-cloud-api:v1/validate_evidence_cache";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ValidateEvidenceCacheRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "validate_evidence_cache";
  operationContract: "jacqos-web-studio-cloud-api:v1/validate_evidence_cache";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ValidateEvidenceCacheParams;
  query?: ValidateEvidenceCacheQuery;
  body?: ValidateEvidenceCacheBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ValidateEvidenceCacheResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "validate_evidence_cache";
  operationContract: "jacqos-web-studio-cloud-api:v1/validate_evidence_cache";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ValidateEvidenceCacheData;
  diagnostics: ValidateEvidenceCacheDiagnostic[];
  evidence: ValidateEvidenceCacheEvidence;
  receipt?: ValidateEvidenceCacheReceipt;
}

export interface RefreshTrustBundleParams extends WebStudioPathParams {}
export interface RefreshTrustBundleQuery extends WebStudioQueryParams {}
export interface RefreshTrustBundleBody extends WebStudioBody {}
export interface RefreshTrustBundleData {
  operationId: "refresh_trust_bundle";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface RefreshTrustBundleDiagnostic {
  operation: "refresh_trust_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface RefreshTrustBundleEvidence extends WebStudioEvidence {}
export interface RefreshTrustBundleReceipt extends WebStudioReceipt {}
export interface RefreshTrustBundleUnavailableAction {
  operation: "refresh_trust_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface RefreshTrustBundleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "refresh_trust_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: RefreshTrustBundleParams;
  query?: RefreshTrustBundleQuery;
  body?: RefreshTrustBundleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface RefreshTrustBundleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "refresh_trust_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: RefreshTrustBundleData;
  diagnostics: RefreshTrustBundleDiagnostic[];
  evidence: RefreshTrustBundleEvidence;
  receipt?: RefreshTrustBundleReceipt;
}
export interface RefreshTrustBundleStreamEvent {
  operation: "refresh_trust_bundle";
  operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: RefreshTrustBundleData;
  diagnostic?: RefreshTrustBundleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface WebStudioDeepLinkParams extends WebStudioPathParams {}
export interface WebStudioDeepLinkQuery extends WebStudioQueryParams {}
export interface WebStudioDeepLinkBody extends WebStudioBody {}
export interface WebStudioDeepLinkData {
  operationId: "web_studio_deep_link";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  deepLinkTarget?: string;
  requestedRouteContext?: JsonObject;
  authorizedRouteState?: WebStudioRouteState;
  routeDiagnostic?: WebStudioDiagnostic;
  buildMetadata?: JsonObject;
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
  activityLensRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
}
export interface WebStudioDeepLinkDiagnostic {
  operation: "web_studio_deep_link";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_deep_link";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface WebStudioDeepLinkEvidence extends WebStudioEvidence {}
export interface WebStudioDeepLinkReceipt extends WebStudioReceipt {}
export interface WebStudioDeepLinkUnavailableAction {
  operation: "web_studio_deep_link";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_deep_link";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface WebStudioDeepLinkRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "web_studio_deep_link";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_deep_link";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: WebStudioDeepLinkParams;
  query?: WebStudioDeepLinkQuery;
  body?: WebStudioDeepLinkBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface WebStudioDeepLinkResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "web_studio_deep_link";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_deep_link";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: WebStudioDeepLinkData;
  diagnostics: WebStudioDeepLinkDiagnostic[];
  evidence: WebStudioDeepLinkEvidence;
  receipt?: WebStudioDeepLinkReceipt;
}

export interface WebStudioBootParams extends WebStudioPathParams {}
export interface WebStudioBootQuery extends WebStudioQueryParams {}
export interface WebStudioBootBody extends WebStudioBody {}
export interface WebStudioBootData {
  operationId: "web_studio_boot";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  signIn?: WebStudioSignInAvailability;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  sections: WebStudioPresentationSection[];
  factsPlane: WebStudioFactsPlaneSnapshot;
  actorSessionSection?: WebStudioPresentationSection;
  selectedScopeSection?: WebStudioPresentationSection;
  routeStateSection?: WebStudioPresentationSection;
  runtimeIdentitySection?: WebStudioPresentationSection;
  compatibilitySection?: WebStudioPresentationSection;
  actionAvailabilitySection?: WebStudioPresentationSection;
  reconciliationSection?: WebStudioPresentationSection;
  artifactProvenanceSection?: WebStudioPresentationSection;
  semanticPlaneReadinessSection?: WebStudioPresentationSection;
  deferredPanelRows?: WebStudioPresentationRow[];
  followUpActions?: WebStudioActionAvailabilityEntry[];
  deepLinkTarget?: string;
  requestedRouteContext?: JsonObject;
  authorizedRouteState?: WebStudioRouteState;
  routeDiagnostic?: WebStudioDiagnostic;
  buildMetadata?: JsonObject;
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
  activityLensRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
}
export interface WebStudioBootDiagnostic {
  operation: "web_studio_boot";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_boot";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface WebStudioBootEvidence extends WebStudioEvidence {}
export interface WebStudioBootReceipt extends WebStudioReceipt {}
export interface WebStudioBootUnavailableAction {
  operation: "web_studio_boot";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_boot";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface WebStudioBootRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "web_studio_boot";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_boot";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: WebStudioBootParams;
  query?: WebStudioBootQuery;
  body?: WebStudioBootBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface WebStudioBootResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "web_studio_boot";
  operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_boot";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: WebStudioBootData;
  diagnostics: WebStudioBootDiagnostic[];
  evidence: WebStudioBootEvidence;
  receipt?: WebStudioBootReceipt;
}

export interface ActivateDevParams extends WebStudioPathParams {}
export interface ActivateDevQuery extends WebStudioQueryParams {}
export interface ActivateDevBody extends WebStudioBody {}
export interface ActivateDevData {
  operationId: "activate_dev";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface ActivateDevDiagnostic {
  operation: "activate_dev";
  operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ActivateDevEvidence extends WebStudioEvidence {}
export interface ActivateDevReceipt extends WebStudioReceipt {}
export interface ActivateDevUnavailableAction {
  operation: "activate_dev";
  operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ActivateDevRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "activate_dev";
  operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ActivateDevParams;
  query?: ActivateDevQuery;
  body?: ActivateDevBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ActivateDevResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "activate_dev";
  operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ActivateDevData;
  diagnostics: ActivateDevDiagnostic[];
  evidence: ActivateDevEvidence;
  receipt?: ActivateDevReceipt;
}
export interface ActivateDevStreamEvent {
  operation: "activate_dev";
  operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ActivateDevData;
  diagnostic?: ActivateDevDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadRuntimeStatusParams extends WebStudioPathParams {}
export interface ReadRuntimeStatusQuery extends WebStudioQueryParams {}
export interface ReadRuntimeStatusBody extends WebStudioBody {}
export interface ReadRuntimeStatusData {
  operationId: "read_runtime_status";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface ReadRuntimeStatusDiagnostic {
  operation: "read_runtime_status";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_runtime_status";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadRuntimeStatusEvidence extends WebStudioEvidence {}
export interface ReadRuntimeStatusReceipt extends WebStudioReceipt {}
export interface ReadRuntimeStatusUnavailableAction {
  operation: "read_runtime_status";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_runtime_status";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadRuntimeStatusRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_runtime_status";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_runtime_status";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadRuntimeStatusParams;
  query?: ReadRuntimeStatusQuery;
  body?: ReadRuntimeStatusBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadRuntimeStatusResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_runtime_status";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_runtime_status";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadRuntimeStatusData;
  diagnostics: ReadRuntimeStatusDiagnostic[];
  evidence: ReadRuntimeStatusEvidence;
  receipt?: ReadRuntimeStatusReceipt;
}

export interface ReadActivityParams extends WebStudioPathParams {}
export interface ReadActivityQuery extends WebStudioQueryParams {}
export interface ReadActivityBody extends WebStudioBody {}
export interface ReadActivityData {
  operationId: "read_activity";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadActivityDiagnostic {
  operation: "read_activity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadActivityEvidence extends WebStudioEvidence {}
export interface ReadActivityReceipt extends WebStudioReceipt {}
export interface ReadActivityUnavailableAction {
  operation: "read_activity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadActivityRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadActivityParams;
  query?: ReadActivityQuery;
  body?: ReadActivityBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadActivityResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadActivityData;
  diagnostics: ReadActivityDiagnostic[];
  evidence: ReadActivityEvidence;
  receipt?: ReadActivityReceipt;
}
export interface ReadActivityStreamEvent {
  operation: "read_activity";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadActivityData;
  diagnostic?: ReadActivityDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadObservationsParams extends WebStudioPathParams {}
export interface ReadObservationsQuery extends WebStudioQueryParams {}
export interface ReadObservationsBody extends WebStudioBody {}
export interface ReadObservationsData {
  operationId: "read_observations";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadObservationsDiagnostic {
  operation: "read_observations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_observations";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadObservationsEvidence extends WebStudioEvidence {}
export interface ReadObservationsReceipt extends WebStudioReceipt {}
export interface ReadObservationsUnavailableAction {
  operation: "read_observations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_observations";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadObservationsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_observations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_observations";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadObservationsParams;
  query?: ReadObservationsQuery;
  body?: ReadObservationsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadObservationsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_observations";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_observations";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadObservationsData;
  diagnostics: ReadObservationsDiagnostic[];
  evidence: ReadObservationsEvidence;
  receipt?: ReadObservationsReceipt;
}

export interface ReadFactsParams extends WebStudioPathParams {}
export interface ReadFactsQuery extends WebStudioQueryParams {}
export interface ReadFactsBody extends WebStudioBody {}
export interface ReadFactsData {
  operationId: "read_facts";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadFactsDiagnostic {
  operation: "read_facts";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_facts";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadFactsEvidence extends WebStudioEvidence {}
export interface ReadFactsReceipt extends WebStudioReceipt {}
export interface ReadFactsUnavailableAction {
  operation: "read_facts";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_facts";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadFactsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_facts";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_facts";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadFactsParams;
  query?: ReadFactsQuery;
  body?: ReadFactsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadFactsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_facts";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_facts";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadFactsData;
  diagnostics: ReadFactsDiagnostic[];
  evidence: ReadFactsEvidence;
  receipt?: ReadFactsReceipt;
}
export interface ReadFactsStreamEvent {
  operation: "read_facts";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_facts";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadFactsData;
  diagnostic?: ReadFactsDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadIntentsParams extends WebStudioPathParams {}
export interface ReadIntentsQuery extends WebStudioQueryParams {}
export interface ReadIntentsBody extends WebStudioBody {}
export interface ReadIntentsData {
  operationId: "read_intents";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadIntentsDiagnostic {
  operation: "read_intents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_intents";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadIntentsEvidence extends WebStudioEvidence {}
export interface ReadIntentsReceipt extends WebStudioReceipt {}
export interface ReadIntentsUnavailableAction {
  operation: "read_intents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_intents";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadIntentsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_intents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_intents";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadIntentsParams;
  query?: ReadIntentsQuery;
  body?: ReadIntentsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadIntentsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_intents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_intents";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadIntentsData;
  diagnostics: ReadIntentsDiagnostic[];
  evidence: ReadIntentsEvidence;
  receipt?: ReadIntentsReceipt;
}

export interface ReadEffectsParams extends WebStudioPathParams {}
export interface ReadEffectsQuery extends WebStudioQueryParams {}
export interface ReadEffectsBody extends WebStudioBody {}
export interface ReadEffectsData {
  operationId: "read_effects";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadEffectsDiagnostic {
  operation: "read_effects";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_effects";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadEffectsEvidence extends WebStudioEvidence {}
export interface ReadEffectsReceipt extends WebStudioReceipt {}
export interface ReadEffectsUnavailableAction {
  operation: "read_effects";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_effects";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadEffectsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_effects";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_effects";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadEffectsParams;
  query?: ReadEffectsQuery;
  body?: ReadEffectsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadEffectsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_effects";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_effects";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadEffectsData;
  diagnostics: ReadEffectsDiagnostic[];
  evidence: ReadEffectsEvidence;
  receipt?: ReadEffectsReceipt;
}
export interface ReadEffectsStreamEvent {
  operation: "read_effects";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_effects";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadEffectsData;
  diagnostic?: ReadEffectsDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadProvenanceParams extends WebStudioPathParams {}
export interface ReadProvenanceQuery extends WebStudioQueryParams {}
export interface ReadProvenanceBody extends WebStudioBody {}
export interface ReadProvenanceData {
  operationId: "read_provenance";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  graph: WebStudioProvenanceGraph;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadProvenanceDiagnostic {
  operation: "read_provenance";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadProvenanceEvidence extends WebStudioEvidence {}
export interface ReadProvenanceReceipt extends WebStudioReceipt {}
export interface ReadProvenanceUnavailableAction {
  operation: "read_provenance";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadProvenanceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_provenance";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadProvenanceParams;
  query?: ReadProvenanceQuery;
  body?: ReadProvenanceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadProvenanceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_provenance";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadProvenanceData;
  diagnostics: ReadProvenanceDiagnostic[];
  evidence: ReadProvenanceEvidence;
  receipt?: ReadProvenanceReceipt;
}
export interface ReadProvenanceStreamEvent {
  operation: "read_provenance";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadProvenanceData;
  diagnostic?: ReadProvenanceDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadWorkviewsParams extends WebStudioPathParams {}
export interface ReadWorkviewsQuery extends WebStudioQueryParams {}
export interface ReadWorkviewsBody extends WebStudioBody {}
export interface ReadWorkviewsData {
  operationId: "read_workviews";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadWorkviewsDiagnostic {
  operation: "read_workviews";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workviews";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadWorkviewsEvidence extends WebStudioEvidence {}
export interface ReadWorkviewsReceipt extends WebStudioReceipt {}
export interface ReadWorkviewsUnavailableAction {
  operation: "read_workviews";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workviews";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadWorkviewsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_workviews";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workviews";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadWorkviewsParams;
  query?: ReadWorkviewsQuery;
  body?: ReadWorkviewsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadWorkviewsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_workviews";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_workviews";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadWorkviewsData;
  diagnostics: ReadWorkviewsDiagnostic[];
  evidence: ReadWorkviewsEvidence;
  receipt?: ReadWorkviewsReceipt;
}

export interface ReadSchedulesParams extends WebStudioPathParams {}
export interface ReadSchedulesQuery extends WebStudioQueryParams {}
export interface ReadSchedulesBody extends WebStudioBody {}
export interface ReadSchedulesData {
  operationId: "read_schedules";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadSchedulesDiagnostic {
  operation: "read_schedules";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedules";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadSchedulesEvidence extends WebStudioEvidence {}
export interface ReadSchedulesReceipt extends WebStudioReceipt {}
export interface ReadSchedulesUnavailableAction {
  operation: "read_schedules";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedules";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadSchedulesRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedules";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedules";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadSchedulesParams;
  query?: ReadSchedulesQuery;
  body?: ReadSchedulesBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadSchedulesResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedules";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedules";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadSchedulesData;
  diagnostics: ReadSchedulesDiagnostic[];
  evidence: ReadSchedulesEvidence;
  receipt?: ReadSchedulesReceipt;
}

export interface ReadQueuesParams extends WebStudioPathParams {}
export interface ReadQueuesQuery extends WebStudioQueryParams {}
export interface ReadQueuesBody extends WebStudioBody {}
export interface ReadQueuesData {
  operationId: "read_queues";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  plane?: string;
  projectionScope?: string;
  provenanceEntryPoints?: string[];
  contradictionSummaries?: WebStudioPresentationRow[];
}
export interface ReadQueuesDiagnostic {
  operation: "read_queues";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_queues";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadQueuesEvidence extends WebStudioEvidence {}
export interface ReadQueuesReceipt extends WebStudioReceipt {}
export interface ReadQueuesUnavailableAction {
  operation: "read_queues";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_queues";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadQueuesRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_queues";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_queues";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadQueuesParams;
  query?: ReadQueuesQuery;
  body?: ReadQueuesBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadQueuesResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_queues";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_queues";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadQueuesData;
  diagnostics: ReadQueuesDiagnostic[];
  evidence: ReadQueuesEvidence;
  receipt?: ReadQueuesReceipt;
}

export interface ReadAgentsParams extends WebStudioPathParams {}
export interface ReadAgentsQuery extends WebStudioQueryParams {}
export interface ReadAgentsBody extends WebStudioBody {}
export interface ReadAgentsData {
  operationId: "read_agents";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface ReadAgentsDiagnostic {
  operation: "read_agents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agents";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadAgentsEvidence extends WebStudioEvidence {}
export interface ReadAgentsReceipt extends WebStudioReceipt {}
export interface ReadAgentsUnavailableAction {
  operation: "read_agents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agents";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadAgentsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agents";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadAgentsParams;
  query?: ReadAgentsQuery;
  body?: ReadAgentsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadAgentsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agents";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agents";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadAgentsData;
  diagnostics: ReadAgentsDiagnostic[];
  evidence: ReadAgentsEvidence;
  receipt?: ReadAgentsReceipt;
}

export interface InspectAgentParams extends WebStudioPathParams {}
export interface InspectAgentQuery extends WebStudioQueryParams {}
export interface InspectAgentBody extends WebStudioBody {}
export interface InspectAgentData {
  operationId: "inspect_agent";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface InspectAgentDiagnostic {
  operation: "inspect_agent";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_agent";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface InspectAgentEvidence extends WebStudioEvidence {}
export interface InspectAgentReceipt extends WebStudioReceipt {}
export interface InspectAgentUnavailableAction {
  operation: "inspect_agent";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_agent";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface InspectAgentRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_agent";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_agent";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: InspectAgentParams;
  query?: InspectAgentQuery;
  body?: InspectAgentBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface InspectAgentResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_agent";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_agent";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: InspectAgentData;
  diagnostics: InspectAgentDiagnostic[];
  evidence: InspectAgentEvidence;
  receipt?: InspectAgentReceipt;
}

export interface ReadAgentSessionsParams extends WebStudioPathParams {}
export interface ReadAgentSessionsQuery extends WebStudioQueryParams {}
export interface ReadAgentSessionsBody extends WebStudioBody {}
export interface ReadAgentSessionsData {
  operationId: "read_agent_sessions";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface ReadAgentSessionsDiagnostic {
  operation: "read_agent_sessions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_sessions";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadAgentSessionsEvidence extends WebStudioEvidence {}
export interface ReadAgentSessionsReceipt extends WebStudioReceipt {}
export interface ReadAgentSessionsUnavailableAction {
  operation: "read_agent_sessions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_sessions";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadAgentSessionsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_sessions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_sessions";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadAgentSessionsParams;
  query?: ReadAgentSessionsQuery;
  body?: ReadAgentSessionsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadAgentSessionsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_sessions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_sessions";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadAgentSessionsData;
  diagnostics: ReadAgentSessionsDiagnostic[];
  evidence: ReadAgentSessionsEvidence;
  receipt?: ReadAgentSessionsReceipt;
}

export interface StartAgentSessionParams extends WebStudioPathParams {}
export interface StartAgentSessionQuery extends WebStudioQueryParams {}
export interface StartAgentSessionBody extends WebStudioBody {}
export interface StartAgentSessionData {
  operationId: "start_agent_session";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface StartAgentSessionDiagnostic {
  operation: "start_agent_session";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface StartAgentSessionEvidence extends WebStudioEvidence {}
export interface StartAgentSessionReceipt extends WebStudioReceipt {}
export interface StartAgentSessionUnavailableAction {
  operation: "start_agent_session";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface StartAgentSessionRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_agent_session";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: StartAgentSessionParams;
  query?: StartAgentSessionQuery;
  body?: StartAgentSessionBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface StartAgentSessionResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_agent_session";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: StartAgentSessionData;
  diagnostics: StartAgentSessionDiagnostic[];
  evidence: StartAgentSessionEvidence;
  receipt?: StartAgentSessionReceipt;
}
export interface StartAgentSessionStreamEvent {
  operation: "start_agent_session";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: StartAgentSessionData;
  diagnostic?: StartAgentSessionDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadAgentTranscriptParams extends WebStudioPathParams {}
export interface ReadAgentTranscriptQuery extends WebStudioQueryParams {}
export interface ReadAgentTranscriptBody extends WebStudioBody {}
export interface ReadAgentTranscriptData {
  operationId: "read_agent_transcript";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface ReadAgentTranscriptDiagnostic {
  operation: "read_agent_transcript";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_transcript";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadAgentTranscriptEvidence extends WebStudioEvidence {}
export interface ReadAgentTranscriptReceipt extends WebStudioReceipt {}
export interface ReadAgentTranscriptUnavailableAction {
  operation: "read_agent_transcript";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_transcript";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadAgentTranscriptRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_transcript";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_transcript";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadAgentTranscriptParams;
  query?: ReadAgentTranscriptQuery;
  body?: ReadAgentTranscriptBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadAgentTranscriptResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_transcript";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_transcript";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadAgentTranscriptData;
  diagnostics: ReadAgentTranscriptDiagnostic[];
  evidence: ReadAgentTranscriptEvidence;
  receipt?: ReadAgentTranscriptReceipt;
}

export interface SendAgentMessageParams extends WebStudioPathParams {}
export interface SendAgentMessageQuery extends WebStudioQueryParams {}
export interface SendAgentMessageBody extends WebStudioBody {}
export interface SendAgentMessageData {
  operationId: "send_agent_message";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface SendAgentMessageDiagnostic {
  operation: "send_agent_message";
  operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SendAgentMessageEvidence extends WebStudioEvidence {}
export interface SendAgentMessageReceipt extends WebStudioReceipt {}
export interface SendAgentMessageUnavailableAction {
  operation: "send_agent_message";
  operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SendAgentMessageRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "send_agent_message";
  operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SendAgentMessageParams;
  query?: SendAgentMessageQuery;
  body?: SendAgentMessageBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SendAgentMessageResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "send_agent_message";
  operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SendAgentMessageData;
  diagnostics: SendAgentMessageDiagnostic[];
  evidence: SendAgentMessageEvidence;
  receipt?: SendAgentMessageReceipt;
}
export interface SendAgentMessageStreamEvent {
  operation: "send_agent_message";
  operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: SendAgentMessageData;
  diagnostic?: SendAgentMessageDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadAgentTraceParams extends WebStudioPathParams {}
export interface ReadAgentTraceQuery extends WebStudioQueryParams {}
export interface ReadAgentTraceBody extends WebStudioBody {}
export interface ReadAgentTraceData {
  operationId: "read_agent_trace";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  agentRows?: WebStudioPresentationRow[];
  topologyRows?: WebStudioPresentationRow[];
  topologyGraph?: WebStudioProvenanceGraph;
  transcriptRows?: WebStudioPresentationRow[];
  composerAuthorization?: WebStudioActionAvailabilityEntry;
}
export interface ReadAgentTraceDiagnostic {
  operation: "read_agent_trace";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadAgentTraceEvidence extends WebStudioEvidence {}
export interface ReadAgentTraceReceipt extends WebStudioReceipt {}
export interface ReadAgentTraceUnavailableAction {
  operation: "read_agent_trace";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadAgentTraceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_trace";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadAgentTraceParams;
  query?: ReadAgentTraceQuery;
  body?: ReadAgentTraceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadAgentTraceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_agent_trace";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadAgentTraceData;
  diagnostics: ReadAgentTraceDiagnostic[];
  evidence: ReadAgentTraceEvidence;
  receipt?: ReadAgentTraceReceipt;
}
export interface ReadAgentTraceStreamEvent {
  operation: "read_agent_trace";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReadAgentTraceData;
  diagnostic?: ReadAgentTraceDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadOntologySummaryParams extends WebStudioPathParams {}
export interface ReadOntologySummaryQuery extends WebStudioQueryParams {}
export interface ReadOntologySummaryBody extends WebStudioBody {}
export interface ReadOntologySummaryData {
  operationId: "read_ontology_summary";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  relationRows?: WebStudioPresentationRow[];
  ruleGraph?: WebStudioProvenanceGraph;
  sourceRows?: WebStudioPresentationRow[];
}
export interface ReadOntologySummaryDiagnostic {
  operation: "read_ontology_summary";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_summary";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadOntologySummaryEvidence extends WebStudioEvidence {}
export interface ReadOntologySummaryReceipt extends WebStudioReceipt {}
export interface ReadOntologySummaryUnavailableAction {
  operation: "read_ontology_summary";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_summary";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadOntologySummaryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_summary";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_summary";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadOntologySummaryParams;
  query?: ReadOntologySummaryQuery;
  body?: ReadOntologySummaryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadOntologySummaryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_summary";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_summary";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadOntologySummaryData;
  diagnostics: ReadOntologySummaryDiagnostic[];
  evidence: ReadOntologySummaryEvidence;
  receipt?: ReadOntologySummaryReceipt;
}

export interface ReadOntologyRelationParams extends WebStudioPathParams {}
export interface ReadOntologyRelationQuery extends WebStudioQueryParams {}
export interface ReadOntologyRelationBody extends WebStudioBody {}
export interface ReadOntologyRelationData {
  operationId: "read_ontology_relation";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  relationRows?: WebStudioPresentationRow[];
  ruleGraph?: WebStudioProvenanceGraph;
  sourceRows?: WebStudioPresentationRow[];
}
export interface ReadOntologyRelationDiagnostic {
  operation: "read_ontology_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_relation";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadOntologyRelationEvidence extends WebStudioEvidence {}
export interface ReadOntologyRelationReceipt extends WebStudioReceipt {}
export interface ReadOntologyRelationUnavailableAction {
  operation: "read_ontology_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_relation";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadOntologyRelationRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_relation";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadOntologyRelationParams;
  query?: ReadOntologyRelationQuery;
  body?: ReadOntologyRelationBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadOntologyRelationResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_relation";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadOntologyRelationData;
  diagnostics: ReadOntologyRelationDiagnostic[];
  evidence: ReadOntologyRelationEvidence;
  receipt?: ReadOntologyRelationReceipt;
}

export interface ReadOntologySourceParams extends WebStudioPathParams {}
export interface ReadOntologySourceQuery extends WebStudioQueryParams {}
export interface ReadOntologySourceBody extends WebStudioBody {}
export interface ReadOntologySourceData {
  operationId: "read_ontology_source";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  relationRows?: WebStudioPresentationRow[];
  ruleGraph?: WebStudioProvenanceGraph;
  sourceRows?: WebStudioPresentationRow[];
}
export interface ReadOntologySourceDiagnostic {
  operation: "read_ontology_source";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_source";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadOntologySourceEvidence extends WebStudioEvidence {}
export interface ReadOntologySourceReceipt extends WebStudioReceipt {}
export interface ReadOntologySourceUnavailableAction {
  operation: "read_ontology_source";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_source";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadOntologySourceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_source";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_source";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadOntologySourceParams;
  query?: ReadOntologySourceQuery;
  body?: ReadOntologySourceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadOntologySourceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_source";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_source";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadOntologySourceData;
  diagnostics: ReadOntologySourceDiagnostic[];
  evidence: ReadOntologySourceEvidence;
  receipt?: ReadOntologySourceReceipt;
}

export interface ReadOntologyRuleGraphParams extends WebStudioPathParams {}
export interface ReadOntologyRuleGraphQuery extends WebStudioQueryParams {}
export interface ReadOntologyRuleGraphBody extends WebStudioBody {}
export interface ReadOntologyRuleGraphData {
  operationId: "read_ontology_rule_graph";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  relationRows?: WebStudioPresentationRow[];
  ruleGraph?: WebStudioProvenanceGraph;
  sourceRows?: WebStudioPresentationRow[];
}
export interface ReadOntologyRuleGraphDiagnostic {
  operation: "read_ontology_rule_graph";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_rule_graph";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadOntologyRuleGraphEvidence extends WebStudioEvidence {}
export interface ReadOntologyRuleGraphReceipt extends WebStudioReceipt {}
export interface ReadOntologyRuleGraphUnavailableAction {
  operation: "read_ontology_rule_graph";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_rule_graph";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadOntologyRuleGraphRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_rule_graph";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_rule_graph";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadOntologyRuleGraphParams;
  query?: ReadOntologyRuleGraphQuery;
  body?: ReadOntologyRuleGraphBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadOntologyRuleGraphResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_ontology_rule_graph";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_rule_graph";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadOntologyRuleGraphData;
  diagnostics: ReadOntologyRuleGraphDiagnostic[];
  evidence: ReadOntologyRuleGraphEvidence;
  receipt?: ReadOntologyRuleGraphReceipt;
}

export interface ReadActivityViewsParams extends WebStudioPathParams {}
export interface ReadActivityViewsQuery extends WebStudioQueryParams {}
export interface ReadActivityViewsBody extends WebStudioBody {}
export interface ReadActivityViewsData {
  operationId: "read_activity_views";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  activityRows?: WebStudioPresentationRow[];
  filterRows?: WebStudioPresentationRow[];
  filterCounts?: JsonObject;
  sessionScope?: string;
  lensDescriptorRows?: WebStudioPresentationRow[];
  lensMembershipRows?: WebStudioPresentationRow[];
  inspectorTimelineRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
}
export interface ReadActivityViewsDiagnostic {
  operation: "read_activity_views";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_views";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadActivityViewsEvidence extends WebStudioEvidence {}
export interface ReadActivityViewsReceipt extends WebStudioReceipt {}
export interface ReadActivityViewsUnavailableAction {
  operation: "read_activity_views";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_views";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadActivityViewsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity_views";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_views";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadActivityViewsParams;
  query?: ReadActivityViewsQuery;
  body?: ReadActivityViewsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadActivityViewsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity_views";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_views";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadActivityViewsData;
  diagnostics: ReadActivityViewsDiagnostic[];
  evidence: ReadActivityViewsEvidence;
  receipt?: ReadActivityViewsReceipt;
}

export interface SaveActivityViewParams extends WebStudioPathParams {}
export interface SaveActivityViewQuery extends WebStudioQueryParams {}
export interface SaveActivityViewBody extends WebStudioBody {}
export interface SaveActivityViewData {
  operationId: "save_activity_view";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  activityRows?: WebStudioPresentationRow[];
  filterRows?: WebStudioPresentationRow[];
  filterCounts?: JsonObject;
  sessionScope?: string;
  lensDescriptorRows?: WebStudioPresentationRow[];
  lensMembershipRows?: WebStudioPresentationRow[];
  inspectorTimelineRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
}
export interface SaveActivityViewDiagnostic {
  operation: "save_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SaveActivityViewEvidence extends WebStudioEvidence {}
export interface SaveActivityViewReceipt extends WebStudioReceipt {}
export interface SaveActivityViewUnavailableAction {
  operation: "save_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SaveActivityViewRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "save_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SaveActivityViewParams;
  query?: SaveActivityViewQuery;
  body?: SaveActivityViewBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SaveActivityViewResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "save_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SaveActivityViewData;
  diagnostics: SaveActivityViewDiagnostic[];
  evidence: SaveActivityViewEvidence;
  receipt?: SaveActivityViewReceipt;
}
export interface SaveActivityViewStreamEvent {
  operation: "save_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: SaveActivityViewData;
  diagnostic?: SaveActivityViewDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface DeleteActivityViewParams extends WebStudioPathParams {}
export interface DeleteActivityViewQuery extends WebStudioQueryParams {}
export interface DeleteActivityViewBody extends WebStudioBody {}
export interface DeleteActivityViewData {
  operationId: "delete_activity_view";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  activityRows?: WebStudioPresentationRow[];
  filterRows?: WebStudioPresentationRow[];
  filterCounts?: JsonObject;
  sessionScope?: string;
  lensDescriptorRows?: WebStudioPresentationRow[];
  lensMembershipRows?: WebStudioPresentationRow[];
  inspectorTimelineRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
}
export interface DeleteActivityViewDiagnostic {
  operation: "delete_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface DeleteActivityViewEvidence extends WebStudioEvidence {}
export interface DeleteActivityViewReceipt extends WebStudioReceipt {}
export interface DeleteActivityViewUnavailableAction {
  operation: "delete_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface DeleteActivityViewRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "delete_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: DeleteActivityViewParams;
  query?: DeleteActivityViewQuery;
  body?: DeleteActivityViewBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface DeleteActivityViewResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "delete_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: DeleteActivityViewData;
  diagnostics: DeleteActivityViewDiagnostic[];
  evidence: DeleteActivityViewEvidence;
  receipt?: DeleteActivityViewReceipt;
}
export interface DeleteActivityViewStreamEvent {
  operation: "delete_activity_view";
  operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: DeleteActivityViewData;
  diagnostic?: DeleteActivityViewDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadActivitySessionCatalogParams extends WebStudioPathParams {}
export interface ReadActivitySessionCatalogQuery extends WebStudioQueryParams {}
export interface ReadActivitySessionCatalogBody extends WebStudioBody {}
export interface ReadActivitySessionCatalogData {
  operationId: "read_activity_session_catalog";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  activityRows?: WebStudioPresentationRow[];
  filterRows?: WebStudioPresentationRow[];
  filterCounts?: JsonObject;
  sessionScope?: string;
  lensDescriptorRows?: WebStudioPresentationRow[];
  lensMembershipRows?: WebStudioPresentationRow[];
  inspectorTimelineRows?: WebStudioPresentationRow[];
  inspectorContextRows?: WebStudioPresentationRow[];
}
export interface ReadActivitySessionCatalogDiagnostic {
  operation: "read_activity_session_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_session_catalog";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadActivitySessionCatalogEvidence extends WebStudioEvidence {}
export interface ReadActivitySessionCatalogReceipt extends WebStudioReceipt {}
export interface ReadActivitySessionCatalogUnavailableAction {
  operation: "read_activity_session_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_session_catalog";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadActivitySessionCatalogRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity_session_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_session_catalog";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadActivitySessionCatalogParams;
  query?: ReadActivitySessionCatalogQuery;
  body?: ReadActivitySessionCatalogBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadActivitySessionCatalogResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_activity_session_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_session_catalog";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadActivitySessionCatalogData;
  diagnostics: ReadActivitySessionCatalogDiagnostic[];
  evidence: ReadActivitySessionCatalogEvidence;
  receipt?: ReadActivitySessionCatalogReceipt;
}

export interface ReadScheduleDetailParams extends WebStudioPathParams {}
export interface ReadScheduleDetailQuery extends WebStudioQueryParams {}
export interface ReadScheduleDetailBody extends WebStudioBody {}
export interface ReadScheduleDetailData {
  operationId: "read_schedule_detail";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface ReadScheduleDetailDiagnostic {
  operation: "read_schedule_detail";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_detail";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadScheduleDetailEvidence extends WebStudioEvidence {}
export interface ReadScheduleDetailReceipt extends WebStudioReceipt {}
export interface ReadScheduleDetailUnavailableAction {
  operation: "read_schedule_detail";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_detail";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadScheduleDetailRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedule_detail";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_detail";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadScheduleDetailParams;
  query?: ReadScheduleDetailQuery;
  body?: ReadScheduleDetailBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadScheduleDetailResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedule_detail";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_detail";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadScheduleDetailData;
  diagnostics: ReadScheduleDetailDiagnostic[];
  evidence: ReadScheduleDetailEvidence;
  receipt?: ReadScheduleDetailReceipt;
}

export interface ReadScheduleFiresParams extends WebStudioPathParams {}
export interface ReadScheduleFiresQuery extends WebStudioQueryParams {}
export interface ReadScheduleFiresBody extends WebStudioBody {}
export interface ReadScheduleFiresData {
  operationId: "read_schedule_fires";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface ReadScheduleFiresDiagnostic {
  operation: "read_schedule_fires";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_fires";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadScheduleFiresEvidence extends WebStudioEvidence {}
export interface ReadScheduleFiresReceipt extends WebStudioReceipt {}
export interface ReadScheduleFiresUnavailableAction {
  operation: "read_schedule_fires";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_fires";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadScheduleFiresRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedule_fires";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_fires";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadScheduleFiresParams;
  query?: ReadScheduleFiresQuery;
  body?: ReadScheduleFiresBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadScheduleFiresResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_schedule_fires";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_fires";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadScheduleFiresData;
  diagnostics: ReadScheduleFiresDiagnostic[];
  evidence: ReadScheduleFiresEvidence;
  receipt?: ReadScheduleFiresReceipt;
}

export interface PreviewScheduleParams extends WebStudioPathParams {}
export interface PreviewScheduleQuery extends WebStudioQueryParams {}
export interface PreviewScheduleBody extends WebStudioBody {}
export interface PreviewScheduleData {
  operationId: "preview_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface PreviewScheduleDiagnostic {
  operation: "preview_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PreviewScheduleEvidence extends WebStudioEvidence {}
export interface PreviewScheduleReceipt extends WebStudioReceipt {}
export interface PreviewScheduleUnavailableAction {
  operation: "preview_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PreviewScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PreviewScheduleParams;
  query?: PreviewScheduleQuery;
  body?: PreviewScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PreviewScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PreviewScheduleData;
  diagnostics: PreviewScheduleDiagnostic[];
  evidence: PreviewScheduleEvidence;
  receipt?: PreviewScheduleReceipt;
}

export interface CreateScheduleParams extends WebStudioPathParams {}
export interface CreateScheduleQuery extends WebStudioQueryParams {}
export interface CreateScheduleBody extends WebStudioBody {}
export interface CreateScheduleData {
  operationId: "create_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface CreateScheduleDiagnostic {
  operation: "create_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface CreateScheduleEvidence extends WebStudioEvidence {}
export interface CreateScheduleReceipt extends WebStudioReceipt {}
export interface CreateScheduleUnavailableAction {
  operation: "create_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface CreateScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "create_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: CreateScheduleParams;
  query?: CreateScheduleQuery;
  body?: CreateScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface CreateScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "create_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: CreateScheduleData;
  diagnostics: CreateScheduleDiagnostic[];
  evidence: CreateScheduleEvidence;
  receipt?: CreateScheduleReceipt;
}
export interface CreateScheduleStreamEvent {
  operation: "create_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: CreateScheduleData;
  diagnostic?: CreateScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface UpdateScheduleParams extends WebStudioPathParams {}
export interface UpdateScheduleQuery extends WebStudioQueryParams {}
export interface UpdateScheduleBody extends WebStudioBody {}
export interface UpdateScheduleData {
  operationId: "update_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface UpdateScheduleDiagnostic {
  operation: "update_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UpdateScheduleEvidence extends WebStudioEvidence {}
export interface UpdateScheduleReceipt extends WebStudioReceipt {}
export interface UpdateScheduleUnavailableAction {
  operation: "update_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UpdateScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UpdateScheduleParams;
  query?: UpdateScheduleQuery;
  body?: UpdateScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UpdateScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UpdateScheduleData;
  diagnostics: UpdateScheduleDiagnostic[];
  evidence: UpdateScheduleEvidence;
  receipt?: UpdateScheduleReceipt;
}
export interface UpdateScheduleStreamEvent {
  operation: "update_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UpdateScheduleData;
  diagnostic?: UpdateScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PauseScheduleParams extends WebStudioPathParams {}
export interface PauseScheduleQuery extends WebStudioQueryParams {}
export interface PauseScheduleBody extends WebStudioBody {}
export interface PauseScheduleData {
  operationId: "pause_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface PauseScheduleDiagnostic {
  operation: "pause_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PauseScheduleEvidence extends WebStudioEvidence {}
export interface PauseScheduleReceipt extends WebStudioReceipt {}
export interface PauseScheduleUnavailableAction {
  operation: "pause_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PauseScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "pause_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PauseScheduleParams;
  query?: PauseScheduleQuery;
  body?: PauseScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PauseScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "pause_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PauseScheduleData;
  diagnostics: PauseScheduleDiagnostic[];
  evidence: PauseScheduleEvidence;
  receipt?: PauseScheduleReceipt;
}
export interface PauseScheduleStreamEvent {
  operation: "pause_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: PauseScheduleData;
  diagnostic?: PauseScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ResumeScheduleParams extends WebStudioPathParams {}
export interface ResumeScheduleQuery extends WebStudioQueryParams {}
export interface ResumeScheduleBody extends WebStudioBody {}
export interface ResumeScheduleData {
  operationId: "resume_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface ResumeScheduleDiagnostic {
  operation: "resume_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ResumeScheduleEvidence extends WebStudioEvidence {}
export interface ResumeScheduleReceipt extends WebStudioReceipt {}
export interface ResumeScheduleUnavailableAction {
  operation: "resume_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ResumeScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "resume_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ResumeScheduleParams;
  query?: ResumeScheduleQuery;
  body?: ResumeScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ResumeScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "resume_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ResumeScheduleData;
  diagnostics: ResumeScheduleDiagnostic[];
  evidence: ResumeScheduleEvidence;
  receipt?: ResumeScheduleReceipt;
}
export interface ResumeScheduleStreamEvent {
  operation: "resume_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ResumeScheduleData;
  diagnostic?: ResumeScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface TriggerScheduleParams extends WebStudioPathParams {}
export interface TriggerScheduleQuery extends WebStudioQueryParams {}
export interface TriggerScheduleBody extends WebStudioBody {}
export interface TriggerScheduleData {
  operationId: "trigger_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface TriggerScheduleDiagnostic {
  operation: "trigger_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface TriggerScheduleEvidence extends WebStudioEvidence {}
export interface TriggerScheduleReceipt extends WebStudioReceipt {}
export interface TriggerScheduleUnavailableAction {
  operation: "trigger_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface TriggerScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "trigger_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: TriggerScheduleParams;
  query?: TriggerScheduleQuery;
  body?: TriggerScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface TriggerScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "trigger_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: TriggerScheduleData;
  diagnostics: TriggerScheduleDiagnostic[];
  evidence: TriggerScheduleEvidence;
  receipt?: TriggerScheduleReceipt;
}
export interface TriggerScheduleStreamEvent {
  operation: "trigger_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: TriggerScheduleData;
  diagnostic?: TriggerScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface RemoveScheduleParams extends WebStudioPathParams {}
export interface RemoveScheduleQuery extends WebStudioQueryParams {}
export interface RemoveScheduleBody extends WebStudioBody {}
export interface RemoveScheduleData {
  operationId: "remove_schedule";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  scheduleRows?: WebStudioPresentationRow[];
  fireHistoryRows?: WebStudioPresentationRow[];
  previewDiagnostics?: WebStudioDiagnostic[];
  scheduleReceipts?: WebStudioReceipt[];
}
export interface RemoveScheduleDiagnostic {
  operation: "remove_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface RemoveScheduleEvidence extends WebStudioEvidence {}
export interface RemoveScheduleReceipt extends WebStudioReceipt {}
export interface RemoveScheduleUnavailableAction {
  operation: "remove_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface RemoveScheduleRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "remove_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: RemoveScheduleParams;
  query?: RemoveScheduleQuery;
  body?: RemoveScheduleBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface RemoveScheduleResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "remove_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: RemoveScheduleData;
  diagnostics: RemoveScheduleDiagnostic[];
  evidence: RemoveScheduleEvidence;
  receipt?: RemoveScheduleReceipt;
}
export interface RemoveScheduleStreamEvent {
  operation: "remove_schedule";
  operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: RemoveScheduleData;
  diagnostic?: RemoveScheduleDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadStorageUsageParams extends WebStudioPathParams {}
export interface ReadStorageUsageQuery extends WebStudioQueryParams {}
export interface ReadStorageUsageBody extends WebStudioBody {}
export interface ReadStorageUsageData {
  operationId: "read_storage_usage";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface ReadStorageUsageDiagnostic {
  operation: "read_storage_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_storage_usage";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadStorageUsageEvidence extends WebStudioEvidence {}
export interface ReadStorageUsageReceipt extends WebStudioReceipt {}
export interface ReadStorageUsageUnavailableAction {
  operation: "read_storage_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_storage_usage";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadStorageUsageRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_storage_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_storage_usage";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadStorageUsageParams;
  query?: ReadStorageUsageQuery;
  body?: ReadStorageUsageBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadStorageUsageResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_storage_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_storage_usage";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadStorageUsageData;
  diagnostics: ReadStorageUsageDiagnostic[];
  evidence: ReadStorageUsageEvidence;
  receipt?: ReadStorageUsageReceipt;
}

export interface ReadBlobInventoryParams extends WebStudioPathParams {}
export interface ReadBlobInventoryQuery extends WebStudioQueryParams {}
export interface ReadBlobInventoryBody extends WebStudioBody {}
export interface ReadBlobInventoryData {
  operationId: "read_blob_inventory";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface ReadBlobInventoryDiagnostic {
  operation: "read_blob_inventory";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_blob_inventory";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadBlobInventoryEvidence extends WebStudioEvidence {}
export interface ReadBlobInventoryReceipt extends WebStudioReceipt {}
export interface ReadBlobInventoryUnavailableAction {
  operation: "read_blob_inventory";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_blob_inventory";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadBlobInventoryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_blob_inventory";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_blob_inventory";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadBlobInventoryParams;
  query?: ReadBlobInventoryQuery;
  body?: ReadBlobInventoryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadBlobInventoryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_blob_inventory";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_blob_inventory";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadBlobInventoryData;
  diagnostics: ReadBlobInventoryDiagnostic[];
  evidence: ReadBlobInventoryEvidence;
  receipt?: ReadBlobInventoryReceipt;
}

export interface InspectBlobParams extends WebStudioPathParams {}
export interface InspectBlobQuery extends WebStudioQueryParams {}
export interface InspectBlobBody extends WebStudioBody {}
export interface InspectBlobData {
  operationId: "inspect_blob";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface InspectBlobDiagnostic {
  operation: "inspect_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_blob";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface InspectBlobEvidence extends WebStudioEvidence {}
export interface InspectBlobReceipt extends WebStudioReceipt {}
export interface InspectBlobUnavailableAction {
  operation: "inspect_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_blob";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface InspectBlobRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_blob";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: InspectBlobParams;
  query?: InspectBlobQuery;
  body?: InspectBlobBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface InspectBlobResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "inspect_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/inspect_blob";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: InspectBlobData;
  diagnostics: InspectBlobDiagnostic[];
  evidence: InspectBlobEvidence;
  receipt?: InspectBlobReceipt;
}

export interface DownloadBlobParams extends WebStudioPathParams {}
export interface DownloadBlobQuery extends WebStudioQueryParams {}
export interface DownloadBlobBody extends WebStudioBody {}
export interface DownloadBlobData {
  operationId: "download_blob";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface DownloadBlobDiagnostic {
  operation: "download_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/download_blob";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface DownloadBlobEvidence extends WebStudioEvidence {}
export interface DownloadBlobReceipt extends WebStudioReceipt {}
export interface DownloadBlobUnavailableAction {
  operation: "download_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/download_blob";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface DownloadBlobRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "download_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/download_blob";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: DownloadBlobParams;
  query?: DownloadBlobQuery;
  body?: DownloadBlobBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface DownloadBlobResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "download_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/download_blob";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: DownloadBlobData;
  diagnostics: DownloadBlobDiagnostic[];
  evidence: DownloadBlobEvidence;
  receipt?: DownloadBlobReceipt;
}

export interface UploadBlobParams extends WebStudioPathParams {}
export interface UploadBlobQuery extends WebStudioQueryParams {}
export interface UploadBlobBody extends WebStudioBody {}
export interface UploadBlobData {
  operationId: "upload_blob";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface UploadBlobDiagnostic {
  operation: "upload_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UploadBlobEvidence extends WebStudioEvidence {}
export interface UploadBlobReceipt extends WebStudioReceipt {}
export interface UploadBlobUnavailableAction {
  operation: "upload_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UploadBlobRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upload_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UploadBlobParams;
  query?: UploadBlobQuery;
  body?: UploadBlobBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UploadBlobResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upload_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UploadBlobData;
  diagnostics: UploadBlobDiagnostic[];
  evidence: UploadBlobEvidence;
  receipt?: UploadBlobReceipt;
}
export interface UploadBlobStreamEvent {
  operation: "upload_blob";
  operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UploadBlobData;
  diagnostic?: UploadBlobDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReclaimBlobsDryRunParams extends WebStudioPathParams {}
export interface ReclaimBlobsDryRunQuery extends WebStudioQueryParams {}
export interface ReclaimBlobsDryRunBody extends WebStudioBody {}
export interface ReclaimBlobsDryRunData {
  operationId: "reclaim_blobs_dry_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface ReclaimBlobsDryRunDiagnostic {
  operation: "reclaim_blobs_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_dry_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReclaimBlobsDryRunEvidence extends WebStudioEvidence {}
export interface ReclaimBlobsDryRunReceipt extends WebStudioReceipt {}
export interface ReclaimBlobsDryRunUnavailableAction {
  operation: "reclaim_blobs_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_dry_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReclaimBlobsDryRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reclaim_blobs_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_dry_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReclaimBlobsDryRunParams;
  query?: ReclaimBlobsDryRunQuery;
  body?: ReclaimBlobsDryRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReclaimBlobsDryRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reclaim_blobs_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_dry_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReclaimBlobsDryRunData;
  diagnostics: ReclaimBlobsDryRunDiagnostic[];
  evidence: ReclaimBlobsDryRunEvidence;
  receipt?: ReclaimBlobsDryRunReceipt;
}

export interface ReclaimBlobsConfirmParams extends WebStudioPathParams {}
export interface ReclaimBlobsConfirmQuery extends WebStudioQueryParams {}
export interface ReclaimBlobsConfirmBody extends WebStudioBody {}
export interface ReclaimBlobsConfirmData {
  operationId: "reclaim_blobs_confirm";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  storageUsageRows?: WebStudioPresentationRow[];
  blobRows?: WebStudioPresentationRow[];
  reclaimReceipts?: WebStudioReceipt[];
}
export interface ReclaimBlobsConfirmDiagnostic {
  operation: "reclaim_blobs_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReclaimBlobsConfirmEvidence extends WebStudioEvidence {}
export interface ReclaimBlobsConfirmReceipt extends WebStudioReceipt {}
export interface ReclaimBlobsConfirmUnavailableAction {
  operation: "reclaim_blobs_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReclaimBlobsConfirmRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reclaim_blobs_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReclaimBlobsConfirmParams;
  query?: ReclaimBlobsConfirmQuery;
  body?: ReclaimBlobsConfirmBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReclaimBlobsConfirmResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "reclaim_blobs_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReclaimBlobsConfirmData;
  diagnostics: ReclaimBlobsConfirmDiagnostic[];
  evidence: ReclaimBlobsConfirmEvidence;
  receipt?: ReclaimBlobsConfirmReceipt;
}
export interface ReclaimBlobsConfirmStreamEvent {
  operation: "reclaim_blobs_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ReclaimBlobsConfirmData;
  diagnostic?: ReclaimBlobsConfirmDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadCommandCatalogParams extends WebStudioPathParams {}
export interface ReadCommandCatalogQuery extends WebStudioQueryParams {}
export interface ReadCommandCatalogBody extends WebStudioBody {}
export interface ReadCommandCatalogData {
  operationId: "read_command_catalog";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface ReadCommandCatalogDiagnostic {
  operation: "read_command_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_command_catalog";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadCommandCatalogEvidence extends WebStudioEvidence {}
export interface ReadCommandCatalogReceipt extends WebStudioReceipt {}
export interface ReadCommandCatalogUnavailableAction {
  operation: "read_command_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_command_catalog";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadCommandCatalogRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_command_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_command_catalog";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadCommandCatalogParams;
  query?: ReadCommandCatalogQuery;
  body?: ReadCommandCatalogBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadCommandCatalogResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_command_catalog";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_command_catalog";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadCommandCatalogData;
  diagnostics: ReadCommandCatalogDiagnostic[];
  evidence: ReadCommandCatalogEvidence;
  receipt?: ReadCommandCatalogReceipt;
}

export interface StartReplayRunParams extends WebStudioPathParams {}
export interface StartReplayRunQuery extends WebStudioQueryParams {}
export interface StartReplayRunBody extends WebStudioBody {}
export interface StartReplayRunData {
  operationId: "start_replay_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface StartReplayRunDiagnostic {
  operation: "start_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface StartReplayRunEvidence extends WebStudioEvidence {}
export interface StartReplayRunReceipt extends WebStudioReceipt {}
export interface StartReplayRunUnavailableAction {
  operation: "start_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface StartReplayRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: StartReplayRunParams;
  query?: StartReplayRunQuery;
  body?: StartReplayRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface StartReplayRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "start_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: StartReplayRunData;
  diagnostics: StartReplayRunDiagnostic[];
  evidence: StartReplayRunEvidence;
  receipt?: StartReplayRunReceipt;
}
export interface StartReplayRunStreamEvent {
  operation: "start_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: StartReplayRunData;
  diagnostic?: StartReplayRunDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PollReplayRunParams extends WebStudioPathParams {}
export interface PollReplayRunQuery extends WebStudioQueryParams {}
export interface PollReplayRunBody extends WebStudioBody {}
export interface PollReplayRunData {
  operationId: "poll_replay_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface PollReplayRunDiagnostic {
  operation: "poll_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PollReplayRunEvidence extends WebStudioEvidence {}
export interface PollReplayRunReceipt extends WebStudioReceipt {}
export interface PollReplayRunUnavailableAction {
  operation: "poll_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PollReplayRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "poll_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PollReplayRunParams;
  query?: PollReplayRunQuery;
  body?: PollReplayRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PollReplayRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "poll_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PollReplayRunData;
  diagnostics: PollReplayRunDiagnostic[];
  evidence: PollReplayRunEvidence;
  receipt?: PollReplayRunReceipt;
}
export interface PollReplayRunStreamEvent {
  operation: "poll_replay_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: PollReplayRunData;
  diagnostic?: PollReplayRunDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PreviewWorkspaceExportParams extends WebStudioPathParams {}
export interface PreviewWorkspaceExportQuery extends WebStudioQueryParams {}
export interface PreviewWorkspaceExportBody extends WebStudioBody {}
export interface PreviewWorkspaceExportData {
  operationId: "preview_workspace_export";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface PreviewWorkspaceExportDiagnostic {
  operation: "preview_workspace_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_workspace_export";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PreviewWorkspaceExportEvidence extends WebStudioEvidence {}
export interface PreviewWorkspaceExportReceipt extends WebStudioReceipt {}
export interface PreviewWorkspaceExportUnavailableAction {
  operation: "preview_workspace_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_workspace_export";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PreviewWorkspaceExportRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_workspace_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_workspace_export";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PreviewWorkspaceExportParams;
  query?: PreviewWorkspaceExportQuery;
  body?: PreviewWorkspaceExportBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PreviewWorkspaceExportResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_workspace_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_workspace_export";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PreviewWorkspaceExportData;
  diagnostics: PreviewWorkspaceExportDiagnostic[];
  evidence: PreviewWorkspaceExportEvidence;
  receipt?: PreviewWorkspaceExportReceipt;
}

export interface GarbageCollectDryRunParams extends WebStudioPathParams {}
export interface GarbageCollectDryRunQuery extends WebStudioQueryParams {}
export interface GarbageCollectDryRunBody extends WebStudioBody {}
export interface GarbageCollectDryRunData {
  operationId: "garbage_collect_dry_run";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface GarbageCollectDryRunDiagnostic {
  operation: "garbage_collect_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_dry_run";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface GarbageCollectDryRunEvidence extends WebStudioEvidence {}
export interface GarbageCollectDryRunReceipt extends WebStudioReceipt {}
export interface GarbageCollectDryRunUnavailableAction {
  operation: "garbage_collect_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_dry_run";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface GarbageCollectDryRunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "garbage_collect_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_dry_run";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: GarbageCollectDryRunParams;
  query?: GarbageCollectDryRunQuery;
  body?: GarbageCollectDryRunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface GarbageCollectDryRunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "garbage_collect_dry_run";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_dry_run";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: GarbageCollectDryRunData;
  diagnostics: GarbageCollectDryRunDiagnostic[];
  evidence: GarbageCollectDryRunEvidence;
  receipt?: GarbageCollectDryRunReceipt;
}

export interface GarbageCollectConfirmParams extends WebStudioPathParams {}
export interface GarbageCollectConfirmQuery extends WebStudioQueryParams {}
export interface GarbageCollectConfirmBody extends WebStudioBody {}
export interface GarbageCollectConfirmData {
  operationId: "garbage_collect_confirm";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  commandRows?: WebStudioPresentationRow[];
  docsHelpReferenceRows?: WebStudioPresentationRow[];
  nativeMenuEquivalentRows?: WebStudioPresentationRow[];
  routeDestinationRows?: WebStudioPresentationRow[];
  replaySubmodeRows?: WebStudioPresentationRow[];
  exportKindRows?: WebStudioPresentationRow[];
  shortcutLabels?: JsonObject;
  receipts?: WebStudioReceipt[];
  replayProgressRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
  gcDryRunRows?: WebStudioPresentationRow[];
}
export interface GarbageCollectConfirmDiagnostic {
  operation: "garbage_collect_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface GarbageCollectConfirmEvidence extends WebStudioEvidence {}
export interface GarbageCollectConfirmReceipt extends WebStudioReceipt {}
export interface GarbageCollectConfirmUnavailableAction {
  operation: "garbage_collect_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface GarbageCollectConfirmRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "garbage_collect_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: GarbageCollectConfirmParams;
  query?: GarbageCollectConfirmQuery;
  body?: GarbageCollectConfirmBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface GarbageCollectConfirmResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "garbage_collect_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: GarbageCollectConfirmData;
  diagnostics: GarbageCollectConfirmDiagnostic[];
  evidence: GarbageCollectConfirmEvidence;
  receipt?: GarbageCollectConfirmReceipt;
}
export interface GarbageCollectConfirmStreamEvent {
  operation: "garbage_collect_confirm";
  operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: GarbageCollectConfirmData;
  diagnostic?: GarbageCollectConfirmDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadReconcileQueueParams extends WebStudioPathParams {}
export interface ReadReconcileQueueQuery extends WebStudioQueryParams {}
export interface ReadReconcileQueueBody extends WebStudioBody {}
export interface ReadReconcileQueueData {
  operationId: "read_reconcile_queue";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface ReadReconcileQueueDiagnostic {
  operation: "read_reconcile_queue";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_reconcile_queue";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadReconcileQueueEvidence extends WebStudioEvidence {}
export interface ReadReconcileQueueReceipt extends WebStudioReceipt {}
export interface ReadReconcileQueueUnavailableAction {
  operation: "read_reconcile_queue";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_reconcile_queue";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadReconcileQueueRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_reconcile_queue";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_reconcile_queue";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadReconcileQueueParams;
  query?: ReadReconcileQueueQuery;
  body?: ReadReconcileQueueBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadReconcileQueueResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_reconcile_queue";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_reconcile_queue";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadReconcileQueueData;
  diagnostics: ReadReconcileQueueDiagnostic[];
  evidence: ReadReconcileQueueEvidence;
  receipt?: ReadReconcileQueueReceipt;
}

export interface PreviewReconcileParams extends WebStudioPathParams {}
export interface PreviewReconcileQuery extends WebStudioQueryParams {}
export interface PreviewReconcileBody extends WebStudioBody {}
export interface PreviewReconcileData {
  operationId: "preview_reconcile";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface PreviewReconcileDiagnostic {
  operation: "preview_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_reconcile";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PreviewReconcileEvidence extends WebStudioEvidence {}
export interface PreviewReconcileReceipt extends WebStudioReceipt {}
export interface PreviewReconcileUnavailableAction {
  operation: "preview_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_reconcile";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PreviewReconcileRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_reconcile";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PreviewReconcileParams;
  query?: PreviewReconcileQuery;
  body?: PreviewReconcileBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PreviewReconcileResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_reconcile";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PreviewReconcileData;
  diagnostics: PreviewReconcileDiagnostic[];
  evidence: PreviewReconcileEvidence;
  receipt?: PreviewReconcileReceipt;
}

export interface CommitReconcileParams extends WebStudioPathParams {}
export interface CommitReconcileQuery extends WebStudioQueryParams {}
export interface CommitReconcileBody extends WebStudioBody {}
export interface CommitReconcileData {
  operationId: "commit_reconcile";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface CommitReconcileDiagnostic {
  operation: "commit_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface CommitReconcileEvidence extends WebStudioEvidence {}
export interface CommitReconcileReceipt extends WebStudioReceipt {}
export interface CommitReconcileUnavailableAction {
  operation: "commit_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface CommitReconcileRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "commit_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: CommitReconcileParams;
  query?: CommitReconcileQuery;
  body?: CommitReconcileBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface CommitReconcileResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "commit_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: CommitReconcileData;
  diagnostics: CommitReconcileDiagnostic[];
  evidence: CommitReconcileEvidence;
  receipt?: CommitReconcileReceipt;
}
export interface CommitReconcileStreamEvent {
  operation: "commit_reconcile";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: CommitReconcileData;
  diagnostic?: CommitReconcileDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadContradictionsParams extends WebStudioPathParams {}
export interface ReadContradictionsQuery extends WebStudioQueryParams {}
export interface ReadContradictionsBody extends WebStudioBody {}
export interface ReadContradictionsData {
  operationId: "read_contradictions";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface ReadContradictionsDiagnostic {
  operation: "read_contradictions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_contradictions";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadContradictionsEvidence extends WebStudioEvidence {}
export interface ReadContradictionsReceipt extends WebStudioReceipt {}
export interface ReadContradictionsUnavailableAction {
  operation: "read_contradictions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_contradictions";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadContradictionsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_contradictions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_contradictions";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadContradictionsParams;
  query?: ReadContradictionsQuery;
  body?: ReadContradictionsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadContradictionsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_contradictions";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_contradictions";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadContradictionsData;
  diagnostics: ReadContradictionsDiagnostic[];
  evidence: ReadContradictionsEvidence;
  receipt?: ReadContradictionsReceipt;
}

export interface PreviewContradictionResolutionParams extends WebStudioPathParams {}
export interface PreviewContradictionResolutionQuery extends WebStudioQueryParams {}
export interface PreviewContradictionResolutionBody extends WebStudioBody {}
export interface PreviewContradictionResolutionData {
  operationId: "preview_contradiction_resolution";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface PreviewContradictionResolutionDiagnostic {
  operation: "preview_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_contradiction_resolution";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PreviewContradictionResolutionEvidence extends WebStudioEvidence {}
export interface PreviewContradictionResolutionReceipt extends WebStudioReceipt {}
export interface PreviewContradictionResolutionUnavailableAction {
  operation: "preview_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_contradiction_resolution";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PreviewContradictionResolutionRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_contradiction_resolution";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PreviewContradictionResolutionParams;
  query?: PreviewContradictionResolutionQuery;
  body?: PreviewContradictionResolutionBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PreviewContradictionResolutionResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_contradiction_resolution";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PreviewContradictionResolutionData;
  diagnostics: PreviewContradictionResolutionDiagnostic[];
  evidence: PreviewContradictionResolutionEvidence;
  receipt?: PreviewContradictionResolutionReceipt;
}

export interface CommitContradictionResolutionParams extends WebStudioPathParams {}
export interface CommitContradictionResolutionQuery extends WebStudioQueryParams {}
export interface CommitContradictionResolutionBody extends WebStudioBody {}
export interface CommitContradictionResolutionData {
  operationId: "commit_contradiction_resolution";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queueRows?: WebStudioPresentationRow[];
  blockedActionFamilies?: string[];
  availableReconciliationActions?: WebStudioActionAvailabilityEntry[];
  previewSummary?: string;
  commitReceipts?: WebStudioReceipt[];
  auditRows?: WebStudioPresentationRow[];
}
export interface CommitContradictionResolutionDiagnostic {
  operation: "commit_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface CommitContradictionResolutionEvidence extends WebStudioEvidence {}
export interface CommitContradictionResolutionReceipt extends WebStudioReceipt {}
export interface CommitContradictionResolutionUnavailableAction {
  operation: "commit_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface CommitContradictionResolutionRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "commit_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: CommitContradictionResolutionParams;
  query?: CommitContradictionResolutionQuery;
  body?: CommitContradictionResolutionBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface CommitContradictionResolutionResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "commit_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: CommitContradictionResolutionData;
  diagnostics: CommitContradictionResolutionDiagnostic[];
  evidence: CommitContradictionResolutionEvidence;
  receipt?: CommitContradictionResolutionReceipt;
}
export interface CommitContradictionResolutionStreamEvent {
  operation: "commit_contradiction_resolution";
  operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: CommitContradictionResolutionData;
  diagnostic?: CommitContradictionResolutionDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadStudioSettingsParams extends WebStudioPathParams {}
export interface ReadStudioSettingsQuery extends WebStudioQueryParams {}
export interface ReadStudioSettingsBody extends WebStudioBody {}
export interface ReadStudioSettingsData {
  operationId: "read_studio_settings";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  settingsRows?: WebStudioPresentationRow[];
  secretMetadataRows?: WebStudioPresentationRow[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  telemetryState?: string;
  localOnlyUnavailableRows?: WebStudioActionAvailabilityEntry[];
  sourceRootRows?: WebStudioPresentationRow[];
  localWorkspaceRootRows?: WebStudioPresentationRow[];
  draftValidationDiagnostics?: WebStudioDiagnostic[];
  secretReceipts?: WebStudioReceipt[];
  noSecretEchoDiagnostics?: WebStudioDiagnostic[];
}
export interface ReadStudioSettingsDiagnostic {
  operation: "read_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_studio_settings";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadStudioSettingsEvidence extends WebStudioEvidence {}
export interface ReadStudioSettingsReceipt extends WebStudioReceipt {}
export interface ReadStudioSettingsUnavailableAction {
  operation: "read_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_studio_settings";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadStudioSettingsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_studio_settings";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadStudioSettingsParams;
  query?: ReadStudioSettingsQuery;
  body?: ReadStudioSettingsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadStudioSettingsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_studio_settings";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadStudioSettingsData;
  diagnostics: ReadStudioSettingsDiagnostic[];
  evidence: ReadStudioSettingsEvidence;
  receipt?: ReadStudioSettingsReceipt;
}

export interface UpdateStudioSettingsParams extends WebStudioPathParams {}
export interface UpdateStudioSettingsQuery extends WebStudioQueryParams {}
export interface UpdateStudioSettingsBody extends WebStudioBody {}
export interface UpdateStudioSettingsData {
  operationId: "update_studio_settings";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  settingsRows?: WebStudioPresentationRow[];
  secretMetadataRows?: WebStudioPresentationRow[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  telemetryState?: string;
  localOnlyUnavailableRows?: WebStudioActionAvailabilityEntry[];
  sourceRootRows?: WebStudioPresentationRow[];
  localWorkspaceRootRows?: WebStudioPresentationRow[];
  draftValidationDiagnostics?: WebStudioDiagnostic[];
  secretReceipts?: WebStudioReceipt[];
  noSecretEchoDiagnostics?: WebStudioDiagnostic[];
}
export interface UpdateStudioSettingsDiagnostic {
  operation: "update_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UpdateStudioSettingsEvidence extends WebStudioEvidence {}
export interface UpdateStudioSettingsReceipt extends WebStudioReceipt {}
export interface UpdateStudioSettingsUnavailableAction {
  operation: "update_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UpdateStudioSettingsRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UpdateStudioSettingsParams;
  query?: UpdateStudioSettingsQuery;
  body?: UpdateStudioSettingsBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UpdateStudioSettingsResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UpdateStudioSettingsData;
  diagnostics: UpdateStudioSettingsDiagnostic[];
  evidence: UpdateStudioSettingsEvidence;
  receipt?: UpdateStudioSettingsReceipt;
}
export interface UpdateStudioSettingsStreamEvent {
  operation: "update_studio_settings";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UpdateStudioSettingsData;
  diagnostic?: UpdateStudioSettingsDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface UpdateTelemetryPreferenceParams extends WebStudioPathParams {}
export interface UpdateTelemetryPreferenceQuery extends WebStudioQueryParams {}
export interface UpdateTelemetryPreferenceBody extends WebStudioBody {}
export interface UpdateTelemetryPreferenceData {
  operationId: "update_telemetry_preference";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  settingsRows?: WebStudioPresentationRow[];
  secretMetadataRows?: WebStudioPresentationRow[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  telemetryState?: string;
  localOnlyUnavailableRows?: WebStudioActionAvailabilityEntry[];
  sourceRootRows?: WebStudioPresentationRow[];
  localWorkspaceRootRows?: WebStudioPresentationRow[];
  draftValidationDiagnostics?: WebStudioDiagnostic[];
  secretReceipts?: WebStudioReceipt[];
  noSecretEchoDiagnostics?: WebStudioDiagnostic[];
}
export interface UpdateTelemetryPreferenceDiagnostic {
  operation: "update_telemetry_preference";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UpdateTelemetryPreferenceEvidence extends WebStudioEvidence {}
export interface UpdateTelemetryPreferenceReceipt extends WebStudioReceipt {}
export interface UpdateTelemetryPreferenceUnavailableAction {
  operation: "update_telemetry_preference";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UpdateTelemetryPreferenceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_telemetry_preference";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UpdateTelemetryPreferenceParams;
  query?: UpdateTelemetryPreferenceQuery;
  body?: UpdateTelemetryPreferenceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UpdateTelemetryPreferenceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "update_telemetry_preference";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UpdateTelemetryPreferenceData;
  diagnostics: UpdateTelemetryPreferenceDiagnostic[];
  evidence: UpdateTelemetryPreferenceEvidence;
  receipt?: UpdateTelemetryPreferenceReceipt;
}
export interface UpdateTelemetryPreferenceStreamEvent {
  operation: "update_telemetry_preference";
  operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UpdateTelemetryPreferenceData;
  diagnostic?: UpdateTelemetryPreferenceDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PreviewObservationMappingParams extends WebStudioPathParams {}
export interface PreviewObservationMappingQuery extends WebStudioQueryParams {}
export interface PreviewObservationMappingBody extends WebStudioBody {}
export interface PreviewObservationMappingData {
  operationId: "preview_observation_mapping";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  mappingPreviewRows?: WebStudioPresentationRow[];
  appendDiagnostics?: WebStudioDiagnostic[];
  appendReceipt?: WebStudioReceipt;
  auditRows?: WebStudioPresentationRow[];
}
export interface PreviewObservationMappingDiagnostic {
  operation: "preview_observation_mapping";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_observation_mapping";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PreviewObservationMappingEvidence extends WebStudioEvidence {}
export interface PreviewObservationMappingReceipt extends WebStudioReceipt {}
export interface PreviewObservationMappingUnavailableAction {
  operation: "preview_observation_mapping";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_observation_mapping";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PreviewObservationMappingRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_observation_mapping";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_observation_mapping";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PreviewObservationMappingParams;
  query?: PreviewObservationMappingQuery;
  body?: PreviewObservationMappingBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PreviewObservationMappingResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "preview_observation_mapping";
  operationContract: "jacqos-web-studio-cloud-api:v1/preview_observation_mapping";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PreviewObservationMappingData;
  diagnostics: PreviewObservationMappingDiagnostic[];
  evidence: PreviewObservationMappingEvidence;
  receipt?: PreviewObservationMappingReceipt;
}

export interface ExportWorkspaceParams extends WebStudioPathParams {}
export interface ExportWorkspaceQuery extends WebStudioQueryParams {}
export interface ExportWorkspaceBody extends WebStudioBody {}
export interface ExportWorkspaceData {
  operationId: "export_workspace";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  sourceInspectionRows?: WebStudioPresentationRow[];
  admissionStreamRows?: WebStudioPresentationRow[];
  expectedOutputDiffRows?: WebStudioPresentationRow[];
  evidenceReceipts?: WebStudioReceipt[];
  validationDiagnostics?: WebStudioDiagnostic[];
  streamState?: string;
}
export interface ExportWorkspaceDiagnostic {
  operation: "export_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ExportWorkspaceEvidence extends WebStudioEvidence {}
export interface ExportWorkspaceReceipt extends WebStudioReceipt {}
export interface ExportWorkspaceUnavailableAction {
  operation: "export_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ExportWorkspaceRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "export_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ExportWorkspaceParams;
  query?: ExportWorkspaceQuery;
  body?: ExportWorkspaceBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ExportWorkspaceResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "export_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ExportWorkspaceData;
  diagnostics: ExportWorkspaceDiagnostic[];
  evidence: ExportWorkspaceEvidence;
  receipt?: ExportWorkspaceReceipt;
}
export interface ExportWorkspaceStreamEvent {
  operation: "export_workspace";
  operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ExportWorkspaceData;
  diagnostic?: ExportWorkspaceDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ReadSecretsMetadataParams extends WebStudioPathParams {}
export interface ReadSecretsMetadataQuery extends WebStudioQueryParams {}
export interface ReadSecretsMetadataBody extends WebStudioBody {}
export interface ReadSecretsMetadataData {
  operationId: "read_secrets_metadata";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  settingsRows?: WebStudioPresentationRow[];
  secretMetadataRows?: WebStudioPresentationRow[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  telemetryState?: string;
  localOnlyUnavailableRows?: WebStudioActionAvailabilityEntry[];
  sourceRootRows?: WebStudioPresentationRow[];
  localWorkspaceRootRows?: WebStudioPresentationRow[];
  draftValidationDiagnostics?: WebStudioDiagnostic[];
  secretReceipts?: WebStudioReceipt[];
  noSecretEchoDiagnostics?: WebStudioDiagnostic[];
}
export interface ReadSecretsMetadataDiagnostic {
  operation: "read_secrets_metadata";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_secrets_metadata";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadSecretsMetadataEvidence extends WebStudioEvidence {}
export interface ReadSecretsMetadataReceipt extends WebStudioReceipt {}
export interface ReadSecretsMetadataUnavailableAction {
  operation: "read_secrets_metadata";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_secrets_metadata";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadSecretsMetadataRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_secrets_metadata";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_secrets_metadata";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadSecretsMetadataParams;
  query?: ReadSecretsMetadataQuery;
  body?: ReadSecretsMetadataBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadSecretsMetadataResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_secrets_metadata";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_secrets_metadata";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadSecretsMetadataData;
  diagnostics: ReadSecretsMetadataDiagnostic[];
  evidence: ReadSecretsMetadataEvidence;
  receipt?: ReadSecretsMetadataReceipt;
}

export interface ReadReadinessParams extends WebStudioPathParams {}
export interface ReadReadinessQuery extends WebStudioQueryParams {}
export interface ReadReadinessBody extends WebStudioBody {}
export interface ReadReadinessData {
  operationId: "read_readiness";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface ReadReadinessDiagnostic {
  operation: "read_readiness";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_readiness";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadReadinessEvidence extends WebStudioEvidence {}
export interface ReadReadinessReceipt extends WebStudioReceipt {}
export interface ReadReadinessUnavailableAction {
  operation: "read_readiness";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_readiness";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadReadinessRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_readiness";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_readiness";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadReadinessParams;
  query?: ReadReadinessQuery;
  body?: ReadReadinessBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadReadinessResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_readiness";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_readiness";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadReadinessData;
  diagnostics: ReadReadinessDiagnostic[];
  evidence: ReadReadinessEvidence;
  receipt?: ReadReadinessReceipt;
}

export interface ReadUsageParams extends WebStudioPathParams {}
export interface ReadUsageQuery extends WebStudioQueryParams {}
export interface ReadUsageBody extends WebStudioBody {}
export interface ReadUsageData {
  operationId: "read_usage";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  usageRows?: WebStudioPresentationRow[];
  supportSnapshotRows?: WebStudioPresentationRow[];
  supportPurposeRows?: WebStudioPresentationRow[];
  supportExpiryRows?: WebStudioPresentationRow[];
  tenantScope?: string;
  redactionSummary?: string;
  supportActionReceipts?: WebStudioReceipt[];
}
export interface ReadUsageDiagnostic {
  operation: "read_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_usage";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadUsageEvidence extends WebStudioEvidence {}
export interface ReadUsageReceipt extends WebStudioReceipt {}
export interface ReadUsageUnavailableAction {
  operation: "read_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_usage";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadUsageRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_usage";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadUsageParams;
  query?: ReadUsageQuery;
  body?: ReadUsageBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadUsageResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_usage";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_usage";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadUsageData;
  diagnostics: ReadUsageDiagnostic[];
  evidence: ReadUsageEvidence;
  receipt?: ReadUsageReceipt;
}

export interface ReadBillingOverviewParams extends WebStudioPathParams {}
export interface ReadBillingOverviewQuery extends WebStudioQueryParams {}
export interface ReadBillingOverviewBody extends WebStudioBody {}
export interface ReadBillingOverviewData {
  operationId: "read_billing_overview";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  usageRows?: WebStudioPresentationRow[];
  supportSnapshotRows?: WebStudioPresentationRow[];
  supportPurposeRows?: WebStudioPresentationRow[];
  supportExpiryRows?: WebStudioPresentationRow[];
  tenantScope?: string;
  redactionSummary?: string;
  supportActionReceipts?: WebStudioReceipt[];
}
export interface ReadBillingOverviewDiagnostic {
  operation: "read_billing_overview";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_billing_overview";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ReadBillingOverviewEvidence extends WebStudioEvidence {}
export interface ReadBillingOverviewReceipt extends WebStudioReceipt {}
export interface ReadBillingOverviewUnavailableAction {
  operation: "read_billing_overview";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_billing_overview";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ReadBillingOverviewRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_billing_overview";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_billing_overview";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ReadBillingOverviewParams;
  query?: ReadBillingOverviewQuery;
  body?: ReadBillingOverviewBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ReadBillingOverviewResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "read_billing_overview";
  operationContract: "jacqos-web-studio-cloud-api:v1/read_billing_overview";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ReadBillingOverviewData;
  diagnostics: ReadBillingOverviewDiagnostic[];
  evidence: ReadBillingOverviewEvidence;
  receipt?: ReadBillingOverviewReceipt;
}

export interface QueryCapabilityDiscoveryParams extends WebStudioPathParams {}
export interface QueryCapabilityDiscoveryQuery extends WebStudioQueryParams {}
export interface QueryCapabilityDiscoveryBody extends WebStudioBody {}
export interface QueryCapabilityDiscoveryData {
  operationId: "query_capability_discovery";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryCapabilityDiscoveryDiagnostic {
  operation: "query_capability_discovery";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_capability_discovery";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryCapabilityDiscoveryEvidence extends WebStudioEvidence {}
export interface QueryCapabilityDiscoveryReceipt extends WebStudioReceipt {}
export interface QueryCapabilityDiscoveryUnavailableAction {
  operation: "query_capability_discovery";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_capability_discovery";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryCapabilityDiscoveryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_capability_discovery";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_capability_discovery";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryCapabilityDiscoveryParams;
  query?: QueryCapabilityDiscoveryQuery;
  body?: QueryCapabilityDiscoveryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryCapabilityDiscoveryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_capability_discovery";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_capability_discovery";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryCapabilityDiscoveryData;
  diagnostics: QueryCapabilityDiscoveryDiagnostic[];
  evidence: QueryCapabilityDiscoveryEvidence;
  receipt?: QueryCapabilityDiscoveryReceipt;
}

export interface QueryListDeclaredParams extends WebStudioPathParams {}
export interface QueryListDeclaredQuery extends WebStudioQueryParams {}
export interface QueryListDeclaredBody extends WebStudioBody {}
export interface QueryListDeclaredData {
  operationId: "query_list_declared";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryListDeclaredDiagnostic {
  operation: "query_list_declared";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_list_declared";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryListDeclaredEvidence extends WebStudioEvidence {}
export interface QueryListDeclaredReceipt extends WebStudioReceipt {}
export interface QueryListDeclaredUnavailableAction {
  operation: "query_list_declared";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_list_declared";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryListDeclaredRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_list_declared";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_list_declared";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryListDeclaredParams;
  query?: QueryListDeclaredQuery;
  body?: QueryListDeclaredBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryListDeclaredResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_list_declared";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_list_declared";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryListDeclaredData;
  diagnostics: QueryListDeclaredDiagnostic[];
  evidence: QueryListDeclaredEvidence;
  receipt?: QueryListDeclaredReceipt;
}

export interface QueryExecuteNamedParams extends WebStudioPathParams {}
export interface QueryExecuteNamedQuery extends WebStudioQueryParams {}
export interface QueryExecuteNamedBody extends WebStudioBody {}
export interface QueryExecuteNamedData {
  operationId: "query_execute_named";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryExecuteNamedDiagnostic {
  operation: "query_execute_named";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_named";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryExecuteNamedEvidence extends WebStudioEvidence {}
export interface QueryExecuteNamedReceipt extends WebStudioReceipt {}
export interface QueryExecuteNamedUnavailableAction {
  operation: "query_execute_named";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_named";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryExecuteNamedRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_execute_named";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_named";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryExecuteNamedParams;
  query?: QueryExecuteNamedQuery;
  body?: QueryExecuteNamedBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryExecuteNamedResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_execute_named";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_named";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryExecuteNamedData;
  diagnostics: QueryExecuteNamedDiagnostic[];
  evidence: QueryExecuteNamedEvidence;
  receipt?: QueryExecuteNamedReceipt;
}

export interface QueryExecuteAdhocParams extends WebStudioPathParams {}
export interface QueryExecuteAdhocQuery extends WebStudioQueryParams {}
export interface QueryExecuteAdhocBody extends WebStudioBody {}
export interface QueryExecuteAdhocData {
  operationId: "query_execute_adhoc";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryExecuteAdhocDiagnostic {
  operation: "query_execute_adhoc";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_adhoc";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryExecuteAdhocEvidence extends WebStudioEvidence {}
export interface QueryExecuteAdhocReceipt extends WebStudioReceipt {}
export interface QueryExecuteAdhocUnavailableAction {
  operation: "query_execute_adhoc";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_adhoc";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryExecuteAdhocRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_execute_adhoc";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_adhoc";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryExecuteAdhocParams;
  query?: QueryExecuteAdhocQuery;
  body?: QueryExecuteAdhocBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryExecuteAdhocResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_execute_adhoc";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_adhoc";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryExecuteAdhocData;
  diagnostics: QueryExecuteAdhocDiagnostic[];
  evidence: QueryExecuteAdhocEvidence;
  receipt?: QueryExecuteAdhocReceipt;
}

export interface QueryExplainParams extends WebStudioPathParams {}
export interface QueryExplainQuery extends WebStudioQueryParams {}
export interface QueryExplainBody extends WebStudioBody {}
export interface QueryExplainData {
  operationId: "query_explain";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryExplainDiagnostic {
  operation: "query_explain";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_explain";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryExplainEvidence extends WebStudioEvidence {}
export interface QueryExplainReceipt extends WebStudioReceipt {}
export interface QueryExplainUnavailableAction {
  operation: "query_explain";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_explain";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryExplainRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_explain";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_explain";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryExplainParams;
  query?: QueryExplainQuery;
  body?: QueryExplainBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryExplainResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_explain";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_explain";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryExplainData;
  diagnostics: QueryExplainDiagnostic[];
  evidence: QueryExplainEvidence;
  receipt?: QueryExplainReceipt;
}

export interface QueryContinueCursorParams extends WebStudioPathParams {}
export interface QueryContinueCursorQuery extends WebStudioQueryParams {}
export interface QueryContinueCursorBody extends WebStudioBody {}
export interface QueryContinueCursorData {
  operationId: "query_continue_cursor";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryContinueCursorDiagnostic {
  operation: "query_continue_cursor";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_continue_cursor";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryContinueCursorEvidence extends WebStudioEvidence {}
export interface QueryContinueCursorReceipt extends WebStudioReceipt {}
export interface QueryContinueCursorUnavailableAction {
  operation: "query_continue_cursor";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_continue_cursor";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryContinueCursorRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_continue_cursor";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_continue_cursor";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryContinueCursorParams;
  query?: QueryContinueCursorQuery;
  body?: QueryContinueCursorBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryContinueCursorResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_continue_cursor";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_continue_cursor";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryContinueCursorData;
  diagnostics: QueryContinueCursorDiagnostic[];
  evidence: QueryContinueCursorEvidence;
  receipt?: QueryContinueCursorReceipt;
}

export interface QuerySupportWitnessParams extends WebStudioPathParams {}
export interface QuerySupportWitnessQuery extends WebStudioQueryParams {}
export interface QuerySupportWitnessBody extends WebStudioBody {}
export interface QuerySupportWitnessData {
  operationId: "query_support_witness";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QuerySupportWitnessDiagnostic {
  operation: "query_support_witness";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_support_witness";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QuerySupportWitnessEvidence extends WebStudioEvidence {}
export interface QuerySupportWitnessReceipt extends WebStudioReceipt {}
export interface QuerySupportWitnessUnavailableAction {
  operation: "query_support_witness";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_support_witness";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QuerySupportWitnessRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_support_witness";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_support_witness";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QuerySupportWitnessParams;
  query?: QuerySupportWitnessQuery;
  body?: QuerySupportWitnessBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QuerySupportWitnessResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_support_witness";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_support_witness";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QuerySupportWitnessData;
  diagnostics: QuerySupportWitnessDiagnostic[];
  evidence: QuerySupportWitnessEvidence;
  receipt?: QuerySupportWitnessReceipt;
}

export interface QueryAccessAuditReadParams extends WebStudioPathParams {}
export interface QueryAccessAuditReadQuery extends WebStudioQueryParams {}
export interface QueryAccessAuditReadBody extends WebStudioBody {}
export interface QueryAccessAuditReadData {
  operationId: "query_access_audit_read";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryAccessAuditReadDiagnostic {
  operation: "query_access_audit_read";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_access_audit_read";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryAccessAuditReadEvidence extends WebStudioEvidence {}
export interface QueryAccessAuditReadReceipt extends WebStudioReceipt {}
export interface QueryAccessAuditReadUnavailableAction {
  operation: "query_access_audit_read";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_access_audit_read";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryAccessAuditReadRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_access_audit_read";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_access_audit_read";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryAccessAuditReadParams;
  query?: QueryAccessAuditReadQuery;
  body?: QueryAccessAuditReadBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryAccessAuditReadResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_access_audit_read";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_access_audit_read";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryAccessAuditReadData;
  diagnostics: QueryAccessAuditReadDiagnostic[];
  evidence: QueryAccessAuditReadEvidence;
  receipt?: QueryAccessAuditReadReceipt;
}

export interface QueryHistoryParams extends WebStudioPathParams {}
export interface QueryHistoryQuery extends WebStudioQueryParams {}
export interface QueryHistoryBody extends WebStudioBody {}
export interface QueryHistoryData {
  operationId: "query_history";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryHistoryDiagnostic {
  operation: "query_history";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_history";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryHistoryEvidence extends WebStudioEvidence {}
export interface QueryHistoryReceipt extends WebStudioReceipt {}
export interface QueryHistoryUnavailableAction {
  operation: "query_history";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_history";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryHistoryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_history";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_history";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryHistoryParams;
  query?: QueryHistoryQuery;
  body?: QueryHistoryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryHistoryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_history";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_history";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryHistoryData;
  diagnostics: QueryHistoryDiagnostic[];
  evidence: QueryHistoryEvidence;
  receipt?: QueryHistoryReceipt;
}

export interface QueryContextManifestParams extends WebStudioPathParams {}
export interface QueryContextManifestQuery extends WebStudioQueryParams {}
export interface QueryContextManifestBody extends WebStudioBody {}
export interface QueryContextManifestData {
  operationId: "query_context_manifest";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryContextManifestDiagnostic {
  operation: "query_context_manifest";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_context_manifest";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryContextManifestEvidence extends WebStudioEvidence {}
export interface QueryContextManifestReceipt extends WebStudioReceipt {}
export interface QueryContextManifestUnavailableAction {
  operation: "query_context_manifest";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_context_manifest";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryContextManifestRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_context_manifest";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_context_manifest";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryContextManifestParams;
  query?: QueryContextManifestQuery;
  body?: QueryContextManifestBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryContextManifestResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_context_manifest";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_context_manifest";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryContextManifestData;
  diagnostics: QueryContextManifestDiagnostic[];
  evidence: QueryContextManifestEvidence;
  receipt?: QueryContextManifestReceipt;
}

export interface QueryAuditExportParams extends WebStudioPathParams {}
export interface QueryAuditExportQuery extends WebStudioQueryParams {}
export interface QueryAuditExportBody extends WebStudioBody {}
export interface QueryAuditExportData {
  operationId: "query_audit_export";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryAuditExportDiagnostic {
  operation: "query_audit_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_audit_export";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryAuditExportEvidence extends WebStudioEvidence {}
export interface QueryAuditExportReceipt extends WebStudioReceipt {}
export interface QueryAuditExportUnavailableAction {
  operation: "query_audit_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_audit_export";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryAuditExportRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_audit_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_audit_export";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryAuditExportParams;
  query?: QueryAuditExportQuery;
  body?: QueryAuditExportBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryAuditExportResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_audit_export";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_audit_export";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryAuditExportData;
  diagnostics: QueryAuditExportDiagnostic[];
  evidence: QueryAuditExportEvidence;
  receipt?: QueryAuditExportReceipt;
}

export interface QueryRetainedAdhocRerunParams extends WebStudioPathParams {}
export interface QueryRetainedAdhocRerunQuery extends WebStudioQueryParams {}
export interface QueryRetainedAdhocRerunBody extends WebStudioBody {}
export interface QueryRetainedAdhocRerunData {
  operationId: "query_retained_adhoc_rerun";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryRetainedAdhocRerunDiagnostic {
  operation: "query_retained_adhoc_rerun";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_retained_adhoc_rerun";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryRetainedAdhocRerunEvidence extends WebStudioEvidence {}
export interface QueryRetainedAdhocRerunReceipt extends WebStudioReceipt {}
export interface QueryRetainedAdhocRerunUnavailableAction {
  operation: "query_retained_adhoc_rerun";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_retained_adhoc_rerun";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryRetainedAdhocRerunRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_retained_adhoc_rerun";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_retained_adhoc_rerun";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryRetainedAdhocRerunParams;
  query?: QueryRetainedAdhocRerunQuery;
  body?: QueryRetainedAdhocRerunBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryRetainedAdhocRerunResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_retained_adhoc_rerun";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_retained_adhoc_rerun";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryRetainedAdhocRerunData;
  diagnostics: QueryRetainedAdhocRerunDiagnostic[];
  evidence: QueryRetainedAdhocRerunEvidence;
  receipt?: QueryRetainedAdhocRerunReceipt;
}

export interface QueryBrowseRelationParams extends WebStudioPathParams {}
export interface QueryBrowseRelationQuery extends WebStudioQueryParams {}
export interface QueryBrowseRelationBody extends WebStudioBody {}
export interface QueryBrowseRelationData {
  operationId: "query_browse_relation";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryBrowseRelationDiagnostic {
  operation: "query_browse_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_browse_relation";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryBrowseRelationEvidence extends WebStudioEvidence {}
export interface QueryBrowseRelationReceipt extends WebStudioReceipt {}
export interface QueryBrowseRelationUnavailableAction {
  operation: "query_browse_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_browse_relation";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryBrowseRelationRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_browse_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_browse_relation";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryBrowseRelationParams;
  query?: QueryBrowseRelationQuery;
  body?: QueryBrowseRelationBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryBrowseRelationResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_browse_relation";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_browse_relation";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryBrowseRelationData;
  diagnostics: QueryBrowseRelationDiagnostic[];
  evidence: QueryBrowseRelationEvidence;
  receipt?: QueryBrowseRelationReceipt;
}

export interface QuerySaveOperatorQueryParams extends WebStudioPathParams {}
export interface QuerySaveOperatorQueryQuery extends WebStudioQueryParams {}
export interface QuerySaveOperatorQueryBody extends WebStudioBody {}
export interface QuerySaveOperatorQueryData {
  operationId: "query_save_operator_query";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QuerySaveOperatorQueryDiagnostic {
  operation: "query_save_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QuerySaveOperatorQueryEvidence extends WebStudioEvidence {}
export interface QuerySaveOperatorQueryReceipt extends WebStudioReceipt {}
export interface QuerySaveOperatorQueryUnavailableAction {
  operation: "query_save_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QuerySaveOperatorQueryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_save_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QuerySaveOperatorQueryParams;
  query?: QuerySaveOperatorQueryQuery;
  body?: QuerySaveOperatorQueryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QuerySaveOperatorQueryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_save_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QuerySaveOperatorQueryData;
  diagnostics: QuerySaveOperatorQueryDiagnostic[];
  evidence: QuerySaveOperatorQueryEvidence;
  receipt?: QuerySaveOperatorQueryReceipt;
}
export interface QuerySaveOperatorQueryStreamEvent {
  operation: "query_save_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: QuerySaveOperatorQueryData;
  diagnostic?: QuerySaveOperatorQueryDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface QueryDeleteOperatorQueryParams extends WebStudioPathParams {}
export interface QueryDeleteOperatorQueryQuery extends WebStudioQueryParams {}
export interface QueryDeleteOperatorQueryBody extends WebStudioBody {}
export interface QueryDeleteOperatorQueryData {
  operationId: "query_delete_operator_query";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryDeleteOperatorQueryDiagnostic {
  operation: "query_delete_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryDeleteOperatorQueryEvidence extends WebStudioEvidence {}
export interface QueryDeleteOperatorQueryReceipt extends WebStudioReceipt {}
export interface QueryDeleteOperatorQueryUnavailableAction {
  operation: "query_delete_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryDeleteOperatorQueryRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_delete_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryDeleteOperatorQueryParams;
  query?: QueryDeleteOperatorQueryQuery;
  body?: QueryDeleteOperatorQueryBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryDeleteOperatorQueryResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_delete_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryDeleteOperatorQueryData;
  diagnostics: QueryDeleteOperatorQueryDiagnostic[];
  evidence: QueryDeleteOperatorQueryEvidence;
  receipt?: QueryDeleteOperatorQueryReceipt;
}
export interface QueryDeleteOperatorQueryStreamEvent {
  operation: "query_delete_operator_query";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: QueryDeleteOperatorQueryData;
  diagnostic?: QueryDeleteOperatorQueryDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface QueryExportSavedParams extends WebStudioPathParams {}
export interface QueryExportSavedQuery extends WebStudioQueryParams {}
export interface QueryExportSavedBody extends WebStudioBody {}
export interface QueryExportSavedData {
  operationId: "query_export_saved";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  queryRows?: WebStudioPresentationRow[];
  resultRows?: WebStudioPresentationRow[];
  savedQueryRows?: WebStudioPresentationRow[];
  cursorState?: string;
  explainRows?: WebStudioPresentationRow[];
  queryReceipts?: WebStudioReceipt[];
  hostedReadinessRows?: WebStudioPresentationRow[];
  accessAuditRows?: WebStudioPresentationRow[];
  exportMetadata?: JsonObject;
}
export interface QueryExportSavedDiagnostic {
  operation: "query_export_saved";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_export_saved";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface QueryExportSavedEvidence extends WebStudioEvidence {}
export interface QueryExportSavedReceipt extends WebStudioReceipt {}
export interface QueryExportSavedUnavailableAction {
  operation: "query_export_saved";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_export_saved";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface QueryExportSavedRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_export_saved";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_export_saved";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: QueryExportSavedParams;
  query?: QueryExportSavedQuery;
  body?: QueryExportSavedBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface QueryExportSavedResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "query_export_saved";
  operationContract: "jacqos-web-studio-cloud-api:v1/query_export_saved";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: QueryExportSavedData;
  diagnostics: QueryExportSavedDiagnostic[];
  evidence: QueryExportSavedEvidence;
  receipt?: QueryExportSavedReceipt;
}

export interface MutateObservationParams extends WebStudioPathParams {}
export interface MutateObservationQuery extends WebStudioQueryParams {}
export interface MutateObservationBody extends WebStudioBody {}
export interface MutateObservationData {
  operationId: "mutate_observation";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  mappingPreviewRows?: WebStudioPresentationRow[];
  appendDiagnostics?: WebStudioDiagnostic[];
  appendReceipt?: WebStudioReceipt;
  auditRows?: WebStudioPresentationRow[];
}
export interface MutateObservationDiagnostic {
  operation: "mutate_observation";
  operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface MutateObservationEvidence extends WebStudioEvidence {}
export interface MutateObservationReceipt extends WebStudioReceipt {}
export interface MutateObservationUnavailableAction {
  operation: "mutate_observation";
  operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface MutateObservationRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "mutate_observation";
  operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: MutateObservationParams;
  query?: MutateObservationQuery;
  body?: MutateObservationBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface MutateObservationResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "mutate_observation";
  operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: MutateObservationData;
  diagnostics: MutateObservationDiagnostic[];
  evidence: MutateObservationEvidence;
  receipt?: MutateObservationReceipt;
}
export interface MutateObservationStreamEvent {
  operation: "mutate_observation";
  operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: MutateObservationData;
  diagnostic?: MutateObservationDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface PromoteActivationParams extends WebStudioPathParams {}
export interface PromoteActivationQuery extends WebStudioQueryParams {}
export interface PromoteActivationBody extends WebStudioBody {}
export interface PromoteActivationData {
  operationId: "promote_activation";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface PromoteActivationDiagnostic {
  operation: "promote_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface PromoteActivationEvidence extends WebStudioEvidence {}
export interface PromoteActivationReceipt extends WebStudioReceipt {}
export interface PromoteActivationUnavailableAction {
  operation: "promote_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface PromoteActivationRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "promote_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: PromoteActivationParams;
  query?: PromoteActivationQuery;
  body?: PromoteActivationBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface PromoteActivationResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "promote_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: PromoteActivationData;
  diagnostics: PromoteActivationDiagnostic[];
  evidence: PromoteActivationEvidence;
  receipt?: PromoteActivationReceipt;
}
export interface PromoteActivationStreamEvent {
  operation: "promote_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: PromoteActivationData;
  diagnostic?: PromoteActivationDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface RollbackActivationParams extends WebStudioPathParams {}
export interface RollbackActivationQuery extends WebStudioQueryParams {}
export interface RollbackActivationBody extends WebStudioBody {}
export interface RollbackActivationData {
  operationId: "rollback_activation";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface RollbackActivationDiagnostic {
  operation: "rollback_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface RollbackActivationEvidence extends WebStudioEvidence {}
export interface RollbackActivationReceipt extends WebStudioReceipt {}
export interface RollbackActivationUnavailableAction {
  operation: "rollback_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface RollbackActivationRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "rollback_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: RollbackActivationParams;
  query?: RollbackActivationQuery;
  body?: RollbackActivationBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface RollbackActivationResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "rollback_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: RollbackActivationData;
  diagnostics: RollbackActivationDiagnostic[];
  evidence: RollbackActivationEvidence;
  receipt?: RollbackActivationReceipt;
}
export interface RollbackActivationStreamEvent {
  operation: "rollback_activation";
  operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: RollbackActivationData;
  diagnostic?: RollbackActivationDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface UpgradeRuntimeParams extends WebStudioPathParams {}
export interface UpgradeRuntimeQuery extends WebStudioQueryParams {}
export interface UpgradeRuntimeBody extends WebStudioBody {}
export interface UpgradeRuntimeData {
  operationId: "upgrade_runtime";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  hostedAppRows?: WebStudioPresentationRow[];
  readinessRows?: WebStudioPresentationRow[];
  readinessEvidenceRows?: WebStudioPresentationRow[];
  defaultSurfacePromotionRows?: WebStudioPresentationRow[];
  rollbackControls?: WebStudioActionAvailabilityEntry[];
  runtimeAuthorityRole?: string;
}
export interface UpgradeRuntimeDiagnostic {
  operation: "upgrade_runtime";
  operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface UpgradeRuntimeEvidence extends WebStudioEvidence {}
export interface UpgradeRuntimeReceipt extends WebStudioReceipt {}
export interface UpgradeRuntimeUnavailableAction {
  operation: "upgrade_runtime";
  operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface UpgradeRuntimeRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upgrade_runtime";
  operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: UpgradeRuntimeParams;
  query?: UpgradeRuntimeQuery;
  body?: UpgradeRuntimeBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface UpgradeRuntimeResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "upgrade_runtime";
  operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: UpgradeRuntimeData;
  diagnostics: UpgradeRuntimeDiagnostic[];
  evidence: UpgradeRuntimeEvidence;
  receipt?: UpgradeRuntimeReceipt;
}
export interface UpgradeRuntimeStreamEvent {
  operation: "upgrade_runtime";
  operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: UpgradeRuntimeData;
  diagnostic?: UpgradeRuntimeDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface ManageSecretGrantParams extends WebStudioPathParams {}
export interface ManageSecretGrantQuery extends WebStudioQueryParams {}
export interface ManageSecretGrantBody extends WebStudioBody {}
export interface ManageSecretGrantData {
  operationId: "manage_secret_grant";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  settingsRows?: WebStudioPresentationRow[];
  secretMetadataRows?: WebStudioPresentationRow[];
  credentialMetadataRows?: WebStudioPresentationRow[];
  telemetryState?: string;
  localOnlyUnavailableRows?: WebStudioActionAvailabilityEntry[];
  sourceRootRows?: WebStudioPresentationRow[];
  localWorkspaceRootRows?: WebStudioPresentationRow[];
  draftValidationDiagnostics?: WebStudioDiagnostic[];
  secretReceipts?: WebStudioReceipt[];
  noSecretEchoDiagnostics?: WebStudioDiagnostic[];
}
export interface ManageSecretGrantDiagnostic {
  operation: "manage_secret_grant";
  operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface ManageSecretGrantEvidence extends WebStudioEvidence {}
export interface ManageSecretGrantReceipt extends WebStudioReceipt {}
export interface ManageSecretGrantUnavailableAction {
  operation: "manage_secret_grant";
  operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface ManageSecretGrantRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "manage_secret_grant";
  operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: ManageSecretGrantParams;
  query?: ManageSecretGrantQuery;
  body?: ManageSecretGrantBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface ManageSecretGrantResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "manage_secret_grant";
  operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: ManageSecretGrantData;
  diagnostics: ManageSecretGrantDiagnostic[];
  evidence: ManageSecretGrantEvidence;
  receipt?: ManageSecretGrantReceipt;
}
export interface ManageSecretGrantStreamEvent {
  operation: "manage_secret_grant";
  operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: ManageSecretGrantData;
  diagnostic?: ManageSecretGrantDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export interface SupportSnapshotParams extends WebStudioPathParams {}
export interface SupportSnapshotQuery extends WebStudioQueryParams {}
export interface SupportSnapshotBody extends WebStudioBody {}
export interface SupportSnapshotData {
  operationId: "support_snapshot";
  summary?: JsonObject;
  rows: WebStudioPresentationRow[];
  collection: WebStudioCollectionState;
  routeState?: WebStudioRouteState;
  diagnosticCopy?: string;
  availabilityManifest?: WebStudioRouteAvailabilityManifest;
  sessionState?: string;
  accountSessionRows?: WebStudioPresentationRow[];
  workspaceAccessRows?: WebStudioPresentationRow[];
  fixtureAuthRejected?: boolean;
  usageRows?: WebStudioPresentationRow[];
  supportSnapshotRows?: WebStudioPresentationRow[];
  supportPurposeRows?: WebStudioPresentationRow[];
  supportExpiryRows?: WebStudioPresentationRow[];
  tenantScope?: string;
  redactionSummary?: string;
  supportActionReceipts?: WebStudioReceipt[];
}
export interface SupportSnapshotDiagnostic {
  operation: "support_snapshot";
  operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot";
  diagnostic: WebStudioDiagnostic;
  authority?: WebStudioAuthorityMetadata;
  compatibility?: WebStudioCompatibilityMetadata;
  correlationId: string;
  requestId?: string;
  redactionState: string;
}
export interface SupportSnapshotEvidence extends WebStudioEvidence {}
export interface SupportSnapshotReceipt extends WebStudioReceipt {}
export interface SupportSnapshotUnavailableAction {
  operation: "support_snapshot";
  operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot";
  action: WebStudioActionAvailabilityEntry;
  diagnostic: WebStudioDiagnostic;
  minimumRequiredContract?: string;
}
export interface SupportSnapshotRequest {
  schemaVersion: "jacqos.contracts.v1";
  operation: "support_snapshot";
  operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot";
  actor?: WebStudioActor;
  target: WebStudioTarget;
  authority: WebStudioAuthorityMetadata;
  params: SupportSnapshotParams;
  query?: SupportSnapshotQuery;
  body?: SupportSnapshotBody;
  idempotencyKey?: string;
  expectedState?: WebStudioExpectedState;
}
export interface SupportSnapshotResponse {
  schemaVersion: "jacqos.contracts.v1";
  operation: "support_snapshot";
  operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot";
  authority: WebStudioAuthorityMetadata;
  compatibility: WebStudioCompatibilityMetadata;
  responseIdentity: WebStudioResponseIdentity;
  freshness: WebStudioFreshnessMetadata;
  cachePolicy: WebStudioCachePolicy;
  actionAvailability: WebStudioActionAvailabilityReport;
  presentationModel: WebStudioPresentationModel;
  data: SupportSnapshotData;
  diagnostics: SupportSnapshotDiagnostic[];
  evidence: SupportSnapshotEvidence;
  receipt?: SupportSnapshotReceipt;
}
export interface SupportSnapshotStreamEvent {
  operation: "support_snapshot";
  operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot";
  streamId?: string;
  sequence: number;
  cursor: string;
  snapshotReference?: string;
  eventState: "data" | "resumable_diagnostic" | "terminal_diagnostic" | "ignorable" | "render_as_unavailable" | "blocking";
  event: SupportSnapshotData;
  diagnostic?: SupportSnapshotDiagnostic;
  redactionState: string;
  compatibility: WebStudioCompatibilityMetadata;
}

export const webStudioCloudApiOperations = {
  authenticate: { method: "POST", path: "/v1/auth/session", operationId: "authenticate", operationContract: "jacqos-web-studio-cloud-api:v1/authenticate", requestSchema: "AuthenticateRequest", responseSchema: "AuthenticateResponse", presentationModelId: "account-and-auth_presentation" },
  authenticateStart: { method: "POST", path: "/v1/auth/session/start", operationId: "authenticate_start", operationContract: "jacqos-web-studio-cloud-api:v1/authenticate_start", requestSchema: "AuthenticateStartRequest", responseSchema: "AuthenticateStartResponse", presentationModelId: "account-and-auth_presentation" },
  signOut: { method: "POST", path: "/v1/auth/session/sign-out", operationId: "sign_out", operationContract: "jacqos-web-studio-cloud-api:v1/sign_out", requestSchema: "SignOutRequest", responseSchema: "SignOutResponse", presentationModelId: "account-and-auth_presentation" },
  selectWorkspaceEnvironment: { method: "POST", path: "/v1/workspaces/{workspace_id}/environment-selection", operationId: "select_workspace_environment", operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace_environment", requestSchema: "SelectWorkspaceEnvironmentRequest", responseSchema: "SelectWorkspaceEnvironmentResponse", presentationModelId: "workspace-and-worldview_presentation" },
  readIdentity: { method: "GET", path: "/v1/identity", operationId: "read_identity", operationContract: "jacqos-web-studio-cloud-api:v1/read_identity", requestSchema: "ReadIdentityRequest", responseSchema: "ReadIdentityResponse", presentationModelId: "account-and-auth_presentation" },
  selectAppEnvironment: { method: "POST", path: "/v1/apps/{app_id}/environments/{environment_id}/select", operationId: "select_app_environment", operationContract: "jacqos-web-studio-cloud-api:v1/select_app_environment", requestSchema: "SelectAppEnvironmentRequest", responseSchema: "SelectAppEnvironmentResponse", presentationModelId: "workspace-and-worldview_presentation" },
  readWorkspaceCatalog: { method: "GET", path: "/v1/workspaces", operationId: "read_workspace_catalog", operationContract: "jacqos-web-studio-cloud-api:v1/read_workspace_catalog", requestSchema: "ReadWorkspaceCatalogRequest", responseSchema: "ReadWorkspaceCatalogResponse", presentationModelId: "workspace-and-worldview_presentation" },
  readTemplateCatalog: { method: "GET", path: "/v1/templates", operationId: "read_template_catalog", operationContract: "jacqos-web-studio-cloud-api:v1/read_template_catalog", requestSchema: "ReadTemplateCatalogRequest", responseSchema: "ReadTemplateCatalogResponse", presentationModelId: "home-and-onboarding_presentation" },
  createWorkspaceFromTemplate: { method: "POST", path: "/v1/workspaces/from-template", operationId: "create_workspace_from_template", operationContract: "jacqos-web-studio-cloud-api:v1/create_workspace_from_template", requestSchema: "CreateWorkspaceFromTemplateRequest", responseSchema: "CreateWorkspaceFromTemplateResponse", presentationModelId: "home-and-onboarding_presentation" },
  selectWorkspace: { method: "POST", path: "/v1/workspaces/{workspace_id}/select", operationId: "select_workspace", operationContract: "jacqos-web-studio-cloud-api:v1/select_workspace", requestSchema: "SelectWorkspaceRequest", responseSchema: "SelectWorkspaceResponse", presentationModelId: "workspace-and-worldview_presentation" },
  selectWorldview: { method: "POST", path: "/v1/worldviews/{worldview_id}/select", operationId: "select_worldview", operationContract: "jacqos-web-studio-cloud-api:v1/select_worldview", requestSchema: "SelectWorldviewRequest", responseSchema: "SelectWorldviewResponse", presentationModelId: "workspace-and-worldview_presentation" },
  inspectSourceBundle: { method: "POST", path: "/v1/source-bundles/inspect", operationId: "inspect_source_bundle", operationContract: "jacqos-web-studio-cloud-api:v1/inspect_source_bundle", requestSchema: "InspectSourceBundleRequest", responseSchema: "InspectSourceBundleResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  uploadSourceBundle: { method: "POST", path: "/v1/source-bundles", operationId: "upload_source_bundle", operationContract: "jacqos-web-studio-cloud-api:v1/upload_source_bundle", requestSchema: "UploadSourceBundleRequest", responseSchema: "UploadSourceBundleResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  reuseSourceBundle: { method: "POST", path: "/v1/source-bundles/reuse", operationId: "reuse_source_bundle", operationContract: "jacqos-web-studio-cloud-api:v1/reuse_source_bundle", requestSchema: "ReuseSourceBundleRequest", responseSchema: "ReuseSourceBundleResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  submitAdmission: { method: "POST", path: "/v1/admissions", operationId: "submit_admission", operationContract: "jacqos-web-studio-cloud-api:v1/submit_admission", requestSchema: "SubmitAdmissionRequest", responseSchema: "SubmitAdmissionResponse", presentationModelId: "cloud-and-deployments_presentation" },
  streamDiagnostics: { method: "GET", path: "/v1/operations/{operation_id}/diagnostics/stream", operationId: "stream_diagnostics", operationContract: "jacqos-web-studio-cloud-api:v1/stream_diagnostics", requestSchema: "StreamDiagnosticsRequest", responseSchema: "StreamDiagnosticsResponse", presentationModelId: "cloud-and-deployments_presentation" },
  readHostedApps: { method: "GET", path: "/v1/hosted-apps", operationId: "read_hosted_apps", operationContract: "jacqos-web-studio-cloud-api:v1/read_hosted_apps", requestSchema: "ReadHostedAppsRequest", responseSchema: "ReadHostedAppsResponse", presentationModelId: "cloud-and-deployments_presentation" },
  readCloudOperations: { method: "GET", path: "/v1/cloud/operations", operationId: "read_cloud_operations", operationContract: "jacqos-web-studio-cloud-api:v1/read_cloud_operations", requestSchema: "ReadCloudOperationsRequest", responseSchema: "ReadCloudOperationsResponse", presentationModelId: "cloud-and-deployments_presentation" },
  compatibilityReport: { method: "GET", path: "/v1/compatibility", operationId: "compatibility_report", operationContract: "jacqos-web-studio-cloud-api:v1/compatibility_report", requestSchema: "CompatibilityReportRequest", responseSchema: "CompatibilityReportResponse", presentationModelId: "shell-and-global-commands_presentation" },
  resolveProviderBindings: { method: "POST", path: "/v1/provider-bindings/resolve", operationId: "resolve_provider_bindings", operationContract: "jacqos-web-studio-cloud-api:v1/resolve_provider_bindings", requestSchema: "ResolveProviderBindingsRequest", responseSchema: "ResolveProviderBindingsResponse", presentationModelId: "provider-bindings-and-secrets_presentation" },
  readProviderBindings: { method: "GET", path: "/v1/provider-bindings", operationId: "read_provider_bindings", operationContract: "jacqos-web-studio-cloud-api:v1/read_provider_bindings", requestSchema: "ReadProviderBindingsRequest", responseSchema: "ReadProviderBindingsResponse", presentationModelId: "provider-bindings-and-secrets_presentation" },
  startDeterministicTestRun: { method: "POST", path: "/v1/test-runs", operationId: "start_deterministic_test_run", operationContract: "jacqos-web-studio-cloud-api:v1/start_deterministic_test_run", requestSchema: "StartDeterministicTestRunRequest", responseSchema: "StartDeterministicTestRunResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  pollDeterministicTestRun: { method: "GET", path: "/v1/test-runs/{run_id}", operationId: "poll_deterministic_test_run", operationContract: "jacqos-web-studio-cloud-api:v1/poll_deterministic_test_run", requestSchema: "PollDeterministicTestRunRequest", responseSchema: "PollDeterministicTestRunResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  expectedOutputDiff: { method: "GET", path: "/v1/test-runs/{run_id}/expected-output-diff", operationId: "expected_output_diff", operationContract: "jacqos-web-studio-cloud-api:v1/expected_output_diff", requestSchema: "ExpectedOutputDiffRequest", responseSchema: "ExpectedOutputDiffResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  retrieveEvidenceReceipt: { method: "GET", path: "/v1/evidence/{evidence_id}", operationId: "retrieve_evidence_receipt", operationContract: "jacqos-web-studio-cloud-api:v1/retrieve_evidence_receipt", requestSchema: "RetrieveEvidenceReceiptRequest", responseSchema: "RetrieveEvidenceReceiptResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  validateEvidenceCache: { method: "POST", path: "/v1/evidence/cache/validate", operationId: "validate_evidence_cache", operationContract: "jacqos-web-studio-cloud-api:v1/validate_evidence_cache", requestSchema: "ValidateEvidenceCacheRequest", responseSchema: "ValidateEvidenceCacheResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  refreshTrustBundle: { method: "POST", path: "/v1/trust-bundles/refresh", operationId: "refresh_trust_bundle", operationContract: "jacqos-web-studio-cloud-api:v1/refresh_trust_bundle", requestSchema: "RefreshTrustBundleRequest", responseSchema: "RefreshTrustBundleResponse", presentationModelId: "source-sync-package-admission-test-and-verify-evidence_presentation" },
  webStudioDeepLink: { method: "GET", path: "/v1/web-studio/deep-link", operationId: "web_studio_deep_link", operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_deep_link", requestSchema: "WebStudioDeepLinkRequest", responseSchema: "WebStudioDeepLinkResponse", presentationModelId: "shell-and-global-commands_presentation" },
  webStudioBoot: { method: "GET", path: "/v1/web-studio/boot", operationId: "web_studio_boot", operationContract: "jacqos-web-studio-cloud-api:v1/web_studio_boot", requestSchema: "WebStudioBootRequest", responseSchema: "WebStudioBootResponse", presentationModelId: "web-studio-boot_presentation" },
  activateDev: { method: "POST", path: "/v1/environments/{environment_id}/dev/activate", operationId: "activate_dev", operationContract: "jacqos-web-studio-cloud-api:v1/activate_dev", requestSchema: "ActivateDevRequest", responseSchema: "ActivateDevResponse", presentationModelId: "shell-and-global-commands_presentation" },
  readRuntimeStatus: { method: "GET", path: "/v1/runtime/status", operationId: "read_runtime_status", operationContract: "jacqos-web-studio-cloud-api:v1/read_runtime_status", requestSchema: "ReadRuntimeStatusRequest", responseSchema: "ReadRuntimeStatusResponse", presentationModelId: "shell-and-global-commands_presentation" },
  readActivity: { method: "GET", path: "/v1/activity", operationId: "read_activity", operationContract: "jacqos-web-studio-cloud-api:v1/read_activity", requestSchema: "ReadActivityRequest", responseSchema: "ReadActivityResponse", presentationModelId: "activity-list_presentation" },
  readObservations: { method: "GET", path: "/v1/observations", operationId: "read_observations", operationContract: "jacqos-web-studio-cloud-api:v1/read_observations", requestSchema: "ReadObservationsRequest", responseSchema: "ReadObservationsResponse", presentationModelId: "semantic-planes_presentation" },
  readFacts: { method: "GET", path: "/v1/facts", operationId: "read_facts", operationContract: "jacqos-web-studio-cloud-api:v1/read_facts", requestSchema: "ReadFactsRequest", responseSchema: "ReadFactsResponse", presentationModelId: "semantic-planes_presentation" },
  readIntents: { method: "GET", path: "/v1/intents", operationId: "read_intents", operationContract: "jacqos-web-studio-cloud-api:v1/read_intents", requestSchema: "ReadIntentsRequest", responseSchema: "ReadIntentsResponse", presentationModelId: "semantic-planes_presentation" },
  readEffects: { method: "GET", path: "/v1/effects", operationId: "read_effects", operationContract: "jacqos-web-studio-cloud-api:v1/read_effects", requestSchema: "ReadEffectsRequest", responseSchema: "ReadEffectsResponse", presentationModelId: "semantic-planes_presentation" },
  readProvenance: { method: "GET", path: "/v1/provenance", operationId: "read_provenance", operationContract: "jacqos-web-studio-cloud-api:v1/read_provenance", requestSchema: "ReadProvenanceRequest", responseSchema: "ReadProvenanceResponse", presentationModelId: "provenance_presentation" },
  readWorkviews: { method: "GET", path: "/v1/workviews", operationId: "read_workviews", operationContract: "jacqos-web-studio-cloud-api:v1/read_workviews", requestSchema: "ReadWorkviewsRequest", responseSchema: "ReadWorkviewsResponse", presentationModelId: "workviews_presentation" },
  readSchedules: { method: "GET", path: "/v1/schedules", operationId: "read_schedules", operationContract: "jacqos-web-studio-cloud-api:v1/read_schedules", requestSchema: "ReadSchedulesRequest", responseSchema: "ReadSchedulesResponse", presentationModelId: "schedules_presentation" },
  readQueues: { method: "GET", path: "/v1/queues", operationId: "read_queues", operationContract: "jacqos-web-studio-cloud-api:v1/read_queues", requestSchema: "ReadQueuesRequest", responseSchema: "ReadQueuesResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  readAgents: { method: "GET", path: "/v1/agents", operationId: "read_agents", operationContract: "jacqos-web-studio-cloud-api:v1/read_agents", requestSchema: "ReadAgentsRequest", responseSchema: "ReadAgentsResponse", presentationModelId: "agents_presentation" },
  inspectAgent: { method: "GET", path: "/v1/agents/{agent_id}", operationId: "inspect_agent", operationContract: "jacqos-web-studio-cloud-api:v1/inspect_agent", requestSchema: "InspectAgentRequest", responseSchema: "InspectAgentResponse", presentationModelId: "agents_presentation" },
  readAgentSessions: { method: "GET", path: "/v1/agents/{agent_id}/interfaces/{interface_id}/sessions", operationId: "read_agent_sessions", operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_sessions", requestSchema: "ReadAgentSessionsRequest", responseSchema: "ReadAgentSessionsResponse", presentationModelId: "chat_presentation" },
  startAgentSession: { method: "POST", path: "/v1/agents/{agent_id}/interfaces/{interface_id}/sessions", operationId: "start_agent_session", operationContract: "jacqos-web-studio-cloud-api:v1/start_agent_session", requestSchema: "StartAgentSessionRequest", responseSchema: "StartAgentSessionResponse", presentationModelId: "chat_presentation" },
  readAgentTranscript: { method: "GET", path: "/v1/agents/{agent_id}/interfaces/{interface_id}/sessions/{session_id}/transcript", operationId: "read_agent_transcript", operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_transcript", requestSchema: "ReadAgentTranscriptRequest", responseSchema: "ReadAgentTranscriptResponse", presentationModelId: "chat_presentation" },
  sendAgentMessage: { method: "POST", path: "/v1/agents/{agent_id}/interfaces/{interface_id}/sessions/{session_id}/messages", operationId: "send_agent_message", operationContract: "jacqos-web-studio-cloud-api:v1/send_agent_message", requestSchema: "SendAgentMessageRequest", responseSchema: "SendAgentMessageResponse", presentationModelId: "chat_presentation" },
  readAgentTrace: { method: "GET", path: "/v1/agents/{agent_id}/interfaces/{interface_id}/sessions/{session_id}/trace", operationId: "read_agent_trace", operationContract: "jacqos-web-studio-cloud-api:v1/read_agent_trace", requestSchema: "ReadAgentTraceRequest", responseSchema: "ReadAgentTraceResponse", presentationModelId: "agents_presentation" },
  readOntologySummary: { method: "GET", path: "/v1/ontology", operationId: "read_ontology_summary", operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_summary", requestSchema: "ReadOntologySummaryRequest", responseSchema: "ReadOntologySummaryResponse", presentationModelId: "ontology-browser_presentation" },
  readOntologyRelation: { method: "GET", path: "/v1/ontology/relations/{relation}", operationId: "read_ontology_relation", operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_relation", requestSchema: "ReadOntologyRelationRequest", responseSchema: "ReadOntologyRelationResponse", presentationModelId: "ontology-browser_presentation" },
  readOntologySource: { method: "GET", path: "/v1/ontology/sources/{source_id}", operationId: "read_ontology_source", operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_source", requestSchema: "ReadOntologySourceRequest", responseSchema: "ReadOntologySourceResponse", presentationModelId: "ontology-browser_presentation" },
  readOntologyRuleGraph: { method: "GET", path: "/v1/ontology/rule-graph", operationId: "read_ontology_rule_graph", operationContract: "jacqos-web-studio-cloud-api:v1/read_ontology_rule_graph", requestSchema: "ReadOntologyRuleGraphRequest", responseSchema: "ReadOntologyRuleGraphResponse", presentationModelId: "ontology-browser_presentation" },
  readActivityViews: { method: "GET", path: "/v1/activity/views", operationId: "read_activity_views", operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_views", requestSchema: "ReadActivityViewsRequest", responseSchema: "ReadActivityViewsResponse", presentationModelId: "activity-list_presentation" },
  saveActivityView: { method: "POST", path: "/v1/activity/views", operationId: "save_activity_view", operationContract: "jacqos-web-studio-cloud-api:v1/save_activity_view", requestSchema: "SaveActivityViewRequest", responseSchema: "SaveActivityViewResponse", presentationModelId: "activity-list_presentation" },
  deleteActivityView: { method: "POST", path: "/v1/activity/views/{view_id}/delete", operationId: "delete_activity_view", operationContract: "jacqos-web-studio-cloud-api:v1/delete_activity_view", requestSchema: "DeleteActivityViewRequest", responseSchema: "DeleteActivityViewResponse", presentationModelId: "activity-list_presentation" },
  readActivitySessionCatalog: { method: "GET", path: "/v1/activity/sessions", operationId: "read_activity_session_catalog", operationContract: "jacqos-web-studio-cloud-api:v1/read_activity_session_catalog", requestSchema: "ReadActivitySessionCatalogRequest", responseSchema: "ReadActivitySessionCatalogResponse", presentationModelId: "activity-list_presentation" },
  readScheduleDetail: { method: "GET", path: "/v1/schedules/{schedule_id}", operationId: "read_schedule_detail", operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_detail", requestSchema: "ReadScheduleDetailRequest", responseSchema: "ReadScheduleDetailResponse", presentationModelId: "schedules_presentation" },
  readScheduleFires: { method: "GET", path: "/v1/schedules/{schedule_id}/fires", operationId: "read_schedule_fires", operationContract: "jacqos-web-studio-cloud-api:v1/read_schedule_fires", requestSchema: "ReadScheduleFiresRequest", responseSchema: "ReadScheduleFiresResponse", presentationModelId: "schedules_presentation" },
  previewSchedule: { method: "POST", path: "/v1/schedules/preview", operationId: "preview_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/preview_schedule", requestSchema: "PreviewScheduleRequest", responseSchema: "PreviewScheduleResponse", presentationModelId: "schedules_presentation" },
  createSchedule: { method: "POST", path: "/v1/schedules", operationId: "create_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/create_schedule", requestSchema: "CreateScheduleRequest", responseSchema: "CreateScheduleResponse", presentationModelId: "schedules_presentation" },
  updateSchedule: { method: "POST", path: "/v1/schedules/{schedule_id}", operationId: "update_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/update_schedule", requestSchema: "UpdateScheduleRequest", responseSchema: "UpdateScheduleResponse", presentationModelId: "schedules_presentation" },
  pauseSchedule: { method: "POST", path: "/v1/schedules/{schedule_id}/pause", operationId: "pause_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/pause_schedule", requestSchema: "PauseScheduleRequest", responseSchema: "PauseScheduleResponse", presentationModelId: "schedules_presentation" },
  resumeSchedule: { method: "POST", path: "/v1/schedules/{schedule_id}/resume", operationId: "resume_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/resume_schedule", requestSchema: "ResumeScheduleRequest", responseSchema: "ResumeScheduleResponse", presentationModelId: "schedules_presentation" },
  triggerSchedule: { method: "POST", path: "/v1/schedules/{schedule_id}/trigger", operationId: "trigger_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/trigger_schedule", requestSchema: "TriggerScheduleRequest", responseSchema: "TriggerScheduleResponse", presentationModelId: "schedules_presentation" },
  removeSchedule: { method: "POST", path: "/v1/schedules/{schedule_id}/remove", operationId: "remove_schedule", operationContract: "jacqos-web-studio-cloud-api:v1/remove_schedule", requestSchema: "RemoveScheduleRequest", responseSchema: "RemoveScheduleResponse", presentationModelId: "schedules_presentation" },
  readStorageUsage: { method: "GET", path: "/v1/storage/usage", operationId: "read_storage_usage", operationContract: "jacqos-web-studio-cloud-api:v1/read_storage_usage", requestSchema: "ReadStorageUsageRequest", responseSchema: "ReadStorageUsageResponse", presentationModelId: "storage-and-blobs_presentation" },
  readBlobInventory: { method: "GET", path: "/v1/blobs", operationId: "read_blob_inventory", operationContract: "jacqos-web-studio-cloud-api:v1/read_blob_inventory", requestSchema: "ReadBlobInventoryRequest", responseSchema: "ReadBlobInventoryResponse", presentationModelId: "storage-and-blobs_presentation" },
  inspectBlob: { method: "GET", path: "/v1/blobs/{digest}/metadata", operationId: "inspect_blob", operationContract: "jacqos-web-studio-cloud-api:v1/inspect_blob", requestSchema: "InspectBlobRequest", responseSchema: "InspectBlobResponse", presentationModelId: "storage-and-blobs_presentation" },
  downloadBlob: { method: "GET", path: "/v1/blobs/{digest}", operationId: "download_blob", operationContract: "jacqos-web-studio-cloud-api:v1/download_blob", requestSchema: "DownloadBlobRequest", responseSchema: "DownloadBlobResponse", presentationModelId: "storage-and-blobs_presentation" },
  uploadBlob: { method: "POST", path: "/v1/blobs", operationId: "upload_blob", operationContract: "jacqos-web-studio-cloud-api:v1/upload_blob", requestSchema: "UploadBlobRequest", responseSchema: "UploadBlobResponse", presentationModelId: "storage-and-blobs_presentation" },
  reclaimBlobsDryRun: { method: "POST", path: "/v1/blobs/reclaim-dry-run", operationId: "reclaim_blobs_dry_run", operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_dry_run", requestSchema: "ReclaimBlobsDryRunRequest", responseSchema: "ReclaimBlobsDryRunResponse", presentationModelId: "storage-and-blobs_presentation" },
  reclaimBlobsConfirm: { method: "POST", path: "/v1/blobs/reclaim", operationId: "reclaim_blobs_confirm", operationContract: "jacqos-web-studio-cloud-api:v1/reclaim_blobs_confirm", requestSchema: "ReclaimBlobsConfirmRequest", responseSchema: "ReclaimBlobsConfirmResponse", presentationModelId: "storage-and-blobs_presentation" },
  readCommandCatalog: { method: "GET", path: "/v1/commands", operationId: "read_command_catalog", operationContract: "jacqos-web-studio-cloud-api:v1/read_command_catalog", requestSchema: "ReadCommandCatalogRequest", responseSchema: "ReadCommandCatalogResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  startReplayRun: { method: "POST", path: "/v1/replay-runs", operationId: "start_replay_run", operationContract: "jacqos-web-studio-cloud-api:v1/start_replay_run", requestSchema: "StartReplayRunRequest", responseSchema: "StartReplayRunResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  pollReplayRun: { method: "GET", path: "/v1/replay-runs/{run_id}", operationId: "poll_replay_run", operationContract: "jacqos-web-studio-cloud-api:v1/poll_replay_run", requestSchema: "PollReplayRunRequest", responseSchema: "PollReplayRunResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  previewWorkspaceExport: { method: "POST", path: "/v1/exports/workspace/preview", operationId: "preview_workspace_export", operationContract: "jacqos-web-studio-cloud-api:v1/preview_workspace_export", requestSchema: "PreviewWorkspaceExportRequest", responseSchema: "PreviewWorkspaceExportResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  garbageCollectDryRun: { method: "POST", path: "/v1/gc/dry-run", operationId: "garbage_collect_dry_run", operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_dry_run", requestSchema: "GarbageCollectDryRunRequest", responseSchema: "GarbageCollectDryRunResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  garbageCollectConfirm: { method: "POST", path: "/v1/gc", operationId: "garbage_collect_confirm", operationContract: "jacqos-web-studio-cloud-api:v1/garbage_collect_confirm", requestSchema: "GarbageCollectConfirmRequest", responseSchema: "GarbageCollectConfirmResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  readReconcileQueue: { method: "GET", path: "/v1/reconcile", operationId: "read_reconcile_queue", operationContract: "jacqos-web-studio-cloud-api:v1/read_reconcile_queue", requestSchema: "ReadReconcileQueueRequest", responseSchema: "ReadReconcileQueueResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  previewReconcile: { method: "POST", path: "/v1/reconcile/{entry_id}/preview", operationId: "preview_reconcile", operationContract: "jacqos-web-studio-cloud-api:v1/preview_reconcile", requestSchema: "PreviewReconcileRequest", responseSchema: "PreviewReconcileResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  commitReconcile: { method: "POST", path: "/v1/reconcile/{entry_id}/commit", operationId: "commit_reconcile", operationContract: "jacqos-web-studio-cloud-api:v1/commit_reconcile", requestSchema: "CommitReconcileRequest", responseSchema: "CommitReconcileResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  readContradictions: { method: "GET", path: "/v1/contradictions", operationId: "read_contradictions", operationContract: "jacqos-web-studio-cloud-api:v1/read_contradictions", requestSchema: "ReadContradictionsRequest", responseSchema: "ReadContradictionsResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  previewContradictionResolution: { method: "POST", path: "/v1/contradictions/{contradiction_id}/preview", operationId: "preview_contradiction_resolution", operationContract: "jacqos-web-studio-cloud-api:v1/preview_contradiction_resolution", requestSchema: "PreviewContradictionResolutionRequest", responseSchema: "PreviewContradictionResolutionResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  commitContradictionResolution: { method: "POST", path: "/v1/contradictions/{contradiction_id}/commit", operationId: "commit_contradiction_resolution", operationContract: "jacqos-web-studio-cloud-api:v1/commit_contradiction_resolution", requestSchema: "CommitContradictionResolutionRequest", responseSchema: "CommitContradictionResolutionResponse", presentationModelId: "reconciliation-and-contradictions_presentation" },
  readStudioSettings: { method: "GET", path: "/v1/studio/settings", operationId: "read_studio_settings", operationContract: "jacqos-web-studio-cloud-api:v1/read_studio_settings", requestSchema: "ReadStudioSettingsRequest", responseSchema: "ReadStudioSettingsResponse", presentationModelId: "settings-and-preferences_presentation" },
  updateStudioSettings: { method: "POST", path: "/v1/studio/settings", operationId: "update_studio_settings", operationContract: "jacqos-web-studio-cloud-api:v1/update_studio_settings", requestSchema: "UpdateStudioSettingsRequest", responseSchema: "UpdateStudioSettingsResponse", presentationModelId: "settings-and-preferences_presentation" },
  updateTelemetryPreference: { method: "POST", path: "/v1/studio/settings/telemetry", operationId: "update_telemetry_preference", operationContract: "jacqos-web-studio-cloud-api:v1/update_telemetry_preference", requestSchema: "UpdateTelemetryPreferenceRequest", responseSchema: "UpdateTelemetryPreferenceResponse", presentationModelId: "settings-and-preferences_presentation" },
  previewObservationMapping: { method: "POST", path: "/v1/observations/preview-mapping", operationId: "preview_observation_mapping", operationContract: "jacqos-web-studio-cloud-api:v1/preview_observation_mapping", requestSchema: "PreviewObservationMappingRequest", responseSchema: "PreviewObservationMappingResponse", presentationModelId: "observation-authoring-and-mapping_presentation" },
  exportWorkspace: { method: "POST", path: "/v1/exports/workspace", operationId: "export_workspace", operationContract: "jacqos-web-studio-cloud-api:v1/export_workspace", requestSchema: "ExportWorkspaceRequest", responseSchema: "ExportWorkspaceResponse", presentationModelId: "commands-replay-export-gc_presentation" },
  readSecretsMetadata: { method: "GET", path: "/v1/secrets", operationId: "read_secrets_metadata", operationContract: "jacqos-web-studio-cloud-api:v1/read_secrets_metadata", requestSchema: "ReadSecretsMetadataRequest", responseSchema: "ReadSecretsMetadataResponse", presentationModelId: "provider-bindings-and-secrets_presentation" },
  readReadiness: { method: "GET", path: "/v1/readiness", operationId: "read_readiness", operationContract: "jacqos-web-studio-cloud-api:v1/read_readiness", requestSchema: "ReadReadinessRequest", responseSchema: "ReadReadinessResponse", presentationModelId: "cloud-and-deployments_presentation" },
  readUsage: { method: "GET", path: "/v1/usage", operationId: "read_usage", operationContract: "jacqos-web-studio-cloud-api:v1/read_usage", requestSchema: "ReadUsageRequest", responseSchema: "ReadUsageResponse", presentationModelId: "cloud-and-deployments_presentation" },
  readBillingOverview: { method: "GET", path: "/v1/billing/overview", operationId: "read_billing_overview", operationContract: "jacqos-web-studio-cloud-api:v1/read_billing_overview", requestSchema: "ReadBillingOverviewRequest", responseSchema: "ReadBillingOverviewResponse", presentationModelId: "cloud-and-deployments_presentation" },
  queryCapabilityDiscovery: { method: "GET", path: "/v1/queries/capabilities", operationId: "query_capability_discovery", operationContract: "jacqos-web-studio-cloud-api:v1/query_capability_discovery", requestSchema: "QueryCapabilityDiscoveryRequest", responseSchema: "QueryCapabilityDiscoveryResponse", presentationModelId: "query-workbench_presentation" },
  queryListDeclared: { method: "GET", path: "/v1/queries", operationId: "query_list_declared", operationContract: "jacqos-web-studio-cloud-api:v1/query_list_declared", requestSchema: "QueryListDeclaredRequest", responseSchema: "QueryListDeclaredResponse", presentationModelId: "query-workbench_presentation" },
  queryExecuteNamed: { method: "POST", path: "/v1/queries/{name}/execute", operationId: "query_execute_named", operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_named", requestSchema: "QueryExecuteNamedRequest", responseSchema: "QueryExecuteNamedResponse", presentationModelId: "query-workbench_presentation" },
  queryExecuteAdhoc: { method: "POST", path: "/v1/queries/adhoc", operationId: "query_execute_adhoc", operationContract: "jacqos-web-studio-cloud-api:v1/query_execute_adhoc", requestSchema: "QueryExecuteAdhocRequest", responseSchema: "QueryExecuteAdhocResponse", presentationModelId: "query-workbench_presentation" },
  queryExplain: { method: "POST", path: "/v1/queries/{name}/explain", operationId: "query_explain", operationContract: "jacqos-web-studio-cloud-api:v1/query_explain", requestSchema: "QueryExplainRequest", responseSchema: "QueryExplainResponse", presentationModelId: "query-workbench_presentation" },
  queryContinueCursor: { method: "POST", path: "/v1/queries/{name}/continue", operationId: "query_continue_cursor", operationContract: "jacqos-web-studio-cloud-api:v1/query_continue_cursor", requestSchema: "QueryContinueCursorRequest", responseSchema: "QueryContinueCursorResponse", presentationModelId: "query-workbench_presentation" },
  querySupportWitness: { method: "POST", path: "/v1/queries/{name}/support", operationId: "query_support_witness", operationContract: "jacqos-web-studio-cloud-api:v1/query_support_witness", requestSchema: "QuerySupportWitnessRequest", responseSchema: "QuerySupportWitnessResponse", presentationModelId: "query-workbench_presentation" },
  queryAccessAuditRead: { method: "GET", path: "/v1/audit/access", operationId: "query_access_audit_read", operationContract: "jacqos-web-studio-cloud-api:v1/query_access_audit_read", requestSchema: "QueryAccessAuditReadRequest", responseSchema: "QueryAccessAuditReadResponse", presentationModelId: "query-workbench_presentation" },
  queryHistory: { method: "GET", path: "/v1/queries/history", operationId: "query_history", operationContract: "jacqos-web-studio-cloud-api:v1/query_history", requestSchema: "QueryHistoryRequest", responseSchema: "QueryHistoryResponse", presentationModelId: "query-workbench_presentation" },
  queryContextManifest: { method: "GET", path: "/v1/queries/turns/{turn_id}/context", operationId: "query_context_manifest", operationContract: "jacqos-web-studio-cloud-api:v1/query_context_manifest", requestSchema: "QueryContextManifestRequest", responseSchema: "QueryContextManifestResponse", presentationModelId: "query-workbench_presentation" },
  queryAuditExport: { method: "POST", path: "/v1/queries/audit-export", operationId: "query_audit_export", operationContract: "jacqos-web-studio-cloud-api:v1/query_audit_export", requestSchema: "QueryAuditExportRequest", responseSchema: "QueryAuditExportResponse", presentationModelId: "query-workbench_presentation" },
  queryRetainedAdhocRerun: { method: "POST", path: "/v1/queries/retained-adhoc-rerun", operationId: "query_retained_adhoc_rerun", operationContract: "jacqos-web-studio-cloud-api:v1/query_retained_adhoc_rerun", requestSchema: "QueryRetainedAdhocRerunRequest", responseSchema: "QueryRetainedAdhocRerunResponse", presentationModelId: "query-workbench_presentation" },
  queryBrowseRelation: { method: "POST", path: "/v1/relations/{relation}/browse", operationId: "query_browse_relation", operationContract: "jacqos-web-studio-cloud-api:v1/query_browse_relation", requestSchema: "QueryBrowseRelationRequest", responseSchema: "QueryBrowseRelationResponse", presentationModelId: "query-workbench_presentation" },
  querySaveOperatorQuery: { method: "POST", path: "/v1/queries/saved", operationId: "query_save_operator_query", operationContract: "jacqos-web-studio-cloud-api:v1/query_save_operator_query", requestSchema: "QuerySaveOperatorQueryRequest", responseSchema: "QuerySaveOperatorQueryResponse", presentationModelId: "query-workbench_presentation" },
  queryDeleteOperatorQuery: { method: "POST", path: "/v1/queries/saved/{query_id}/delete", operationId: "query_delete_operator_query", operationContract: "jacqos-web-studio-cloud-api:v1/query_delete_operator_query", requestSchema: "QueryDeleteOperatorQueryRequest", responseSchema: "QueryDeleteOperatorQueryResponse", presentationModelId: "query-workbench_presentation" },
  queryExportSaved: { method: "POST", path: "/v1/queries/saved/{query_id}/export", operationId: "query_export_saved", operationContract: "jacqos-web-studio-cloud-api:v1/query_export_saved", requestSchema: "QueryExportSavedRequest", responseSchema: "QueryExportSavedResponse", presentationModelId: "query-workbench_presentation" },
  mutateObservation: { method: "POST", path: "/v1/observations", operationId: "mutate_observation", operationContract: "jacqos-web-studio-cloud-api:v1/mutate_observation", requestSchema: "MutateObservationRequest", responseSchema: "MutateObservationResponse", presentationModelId: "observation-authoring-and-mapping_presentation" },
  promoteActivation: { method: "POST", path: "/v1/activations/{activation_id}/promote", operationId: "promote_activation", operationContract: "jacqos-web-studio-cloud-api:v1/promote_activation", requestSchema: "PromoteActivationRequest", responseSchema: "PromoteActivationResponse", presentationModelId: "cloud-and-deployments_presentation" },
  rollbackActivation: { method: "POST", path: "/v1/activations/{activation_id}/rollback", operationId: "rollback_activation", operationContract: "jacqos-web-studio-cloud-api:v1/rollback_activation", requestSchema: "RollbackActivationRequest", responseSchema: "RollbackActivationResponse", presentationModelId: "cloud-and-deployments_presentation" },
  upgradeRuntime: { method: "POST", path: "/v1/runtime/upgrade", operationId: "upgrade_runtime", operationContract: "jacqos-web-studio-cloud-api:v1/upgrade_runtime", requestSchema: "UpgradeRuntimeRequest", responseSchema: "UpgradeRuntimeResponse", presentationModelId: "cloud-and-deployments_presentation" },
  manageSecretGrant: { method: "POST", path: "/v1/secrets/{secret_id}/grant", operationId: "manage_secret_grant", operationContract: "jacqos-web-studio-cloud-api:v1/manage_secret_grant", requestSchema: "ManageSecretGrantRequest", responseSchema: "ManageSecretGrantResponse", presentationModelId: "provider-bindings-and-secrets_presentation" },
  supportSnapshot: { method: "POST", path: "/v1/support/snapshots", operationId: "support_snapshot", operationContract: "jacqos-web-studio-cloud-api:v1/support_snapshot", requestSchema: "SupportSnapshotRequest", responseSchema: "SupportSnapshotResponse", presentationModelId: "support-and-usage_presentation" },
} as const;

export type WebStudioCloudApiOperation = keyof typeof webStudioCloudApiOperations;

export interface WebStudioCloudApiRequestByOperation {
  authenticate: AuthenticateRequest;
  authenticateStart: AuthenticateStartRequest;
  signOut: SignOutRequest;
  selectWorkspaceEnvironment: SelectWorkspaceEnvironmentRequest;
  readIdentity: ReadIdentityRequest;
  selectAppEnvironment: SelectAppEnvironmentRequest;
  readWorkspaceCatalog: ReadWorkspaceCatalogRequest;
  readTemplateCatalog: ReadTemplateCatalogRequest;
  createWorkspaceFromTemplate: CreateWorkspaceFromTemplateRequest;
  selectWorkspace: SelectWorkspaceRequest;
  selectWorldview: SelectWorldviewRequest;
  inspectSourceBundle: InspectSourceBundleRequest;
  uploadSourceBundle: UploadSourceBundleRequest;
  reuseSourceBundle: ReuseSourceBundleRequest;
  submitAdmission: SubmitAdmissionRequest;
  streamDiagnostics: StreamDiagnosticsRequest;
  readHostedApps: ReadHostedAppsRequest;
  readCloudOperations: ReadCloudOperationsRequest;
  compatibilityReport: CompatibilityReportRequest;
  resolveProviderBindings: ResolveProviderBindingsRequest;
  readProviderBindings: ReadProviderBindingsRequest;
  startDeterministicTestRun: StartDeterministicTestRunRequest;
  pollDeterministicTestRun: PollDeterministicTestRunRequest;
  expectedOutputDiff: ExpectedOutputDiffRequest;
  retrieveEvidenceReceipt: RetrieveEvidenceReceiptRequest;
  validateEvidenceCache: ValidateEvidenceCacheRequest;
  refreshTrustBundle: RefreshTrustBundleRequest;
  webStudioDeepLink: WebStudioDeepLinkRequest;
  webStudioBoot: WebStudioBootRequest;
  activateDev: ActivateDevRequest;
  readRuntimeStatus: ReadRuntimeStatusRequest;
  readActivity: ReadActivityRequest;
  readObservations: ReadObservationsRequest;
  readFacts: ReadFactsRequest;
  readIntents: ReadIntentsRequest;
  readEffects: ReadEffectsRequest;
  readProvenance: ReadProvenanceRequest;
  readWorkviews: ReadWorkviewsRequest;
  readSchedules: ReadSchedulesRequest;
  readQueues: ReadQueuesRequest;
  readAgents: ReadAgentsRequest;
  inspectAgent: InspectAgentRequest;
  readAgentSessions: ReadAgentSessionsRequest;
  startAgentSession: StartAgentSessionRequest;
  readAgentTranscript: ReadAgentTranscriptRequest;
  sendAgentMessage: SendAgentMessageRequest;
  readAgentTrace: ReadAgentTraceRequest;
  readOntologySummary: ReadOntologySummaryRequest;
  readOntologyRelation: ReadOntologyRelationRequest;
  readOntologySource: ReadOntologySourceRequest;
  readOntologyRuleGraph: ReadOntologyRuleGraphRequest;
  readActivityViews: ReadActivityViewsRequest;
  saveActivityView: SaveActivityViewRequest;
  deleteActivityView: DeleteActivityViewRequest;
  readActivitySessionCatalog: ReadActivitySessionCatalogRequest;
  readScheduleDetail: ReadScheduleDetailRequest;
  readScheduleFires: ReadScheduleFiresRequest;
  previewSchedule: PreviewScheduleRequest;
  createSchedule: CreateScheduleRequest;
  updateSchedule: UpdateScheduleRequest;
  pauseSchedule: PauseScheduleRequest;
  resumeSchedule: ResumeScheduleRequest;
  triggerSchedule: TriggerScheduleRequest;
  removeSchedule: RemoveScheduleRequest;
  readStorageUsage: ReadStorageUsageRequest;
  readBlobInventory: ReadBlobInventoryRequest;
  inspectBlob: InspectBlobRequest;
  downloadBlob: DownloadBlobRequest;
  uploadBlob: UploadBlobRequest;
  reclaimBlobsDryRun: ReclaimBlobsDryRunRequest;
  reclaimBlobsConfirm: ReclaimBlobsConfirmRequest;
  readCommandCatalog: ReadCommandCatalogRequest;
  startReplayRun: StartReplayRunRequest;
  pollReplayRun: PollReplayRunRequest;
  previewWorkspaceExport: PreviewWorkspaceExportRequest;
  garbageCollectDryRun: GarbageCollectDryRunRequest;
  garbageCollectConfirm: GarbageCollectConfirmRequest;
  readReconcileQueue: ReadReconcileQueueRequest;
  previewReconcile: PreviewReconcileRequest;
  commitReconcile: CommitReconcileRequest;
  readContradictions: ReadContradictionsRequest;
  previewContradictionResolution: PreviewContradictionResolutionRequest;
  commitContradictionResolution: CommitContradictionResolutionRequest;
  readStudioSettings: ReadStudioSettingsRequest;
  updateStudioSettings: UpdateStudioSettingsRequest;
  updateTelemetryPreference: UpdateTelemetryPreferenceRequest;
  previewObservationMapping: PreviewObservationMappingRequest;
  exportWorkspace: ExportWorkspaceRequest;
  readSecretsMetadata: ReadSecretsMetadataRequest;
  readReadiness: ReadReadinessRequest;
  readUsage: ReadUsageRequest;
  readBillingOverview: ReadBillingOverviewRequest;
  queryCapabilityDiscovery: QueryCapabilityDiscoveryRequest;
  queryListDeclared: QueryListDeclaredRequest;
  queryExecuteNamed: QueryExecuteNamedRequest;
  queryExecuteAdhoc: QueryExecuteAdhocRequest;
  queryExplain: QueryExplainRequest;
  queryContinueCursor: QueryContinueCursorRequest;
  querySupportWitness: QuerySupportWitnessRequest;
  queryAccessAuditRead: QueryAccessAuditReadRequest;
  queryHistory: QueryHistoryRequest;
  queryContextManifest: QueryContextManifestRequest;
  queryAuditExport: QueryAuditExportRequest;
  queryRetainedAdhocRerun: QueryRetainedAdhocRerunRequest;
  queryBrowseRelation: QueryBrowseRelationRequest;
  querySaveOperatorQuery: QuerySaveOperatorQueryRequest;
  queryDeleteOperatorQuery: QueryDeleteOperatorQueryRequest;
  queryExportSaved: QueryExportSavedRequest;
  mutateObservation: MutateObservationRequest;
  promoteActivation: PromoteActivationRequest;
  rollbackActivation: RollbackActivationRequest;
  upgradeRuntime: UpgradeRuntimeRequest;
  manageSecretGrant: ManageSecretGrantRequest;
  supportSnapshot: SupportSnapshotRequest;
}

export interface WebStudioCloudApiResponseByOperation {
  authenticate: AuthenticateResponse;
  authenticateStart: AuthenticateStartResponse;
  signOut: SignOutResponse;
  selectWorkspaceEnvironment: SelectWorkspaceEnvironmentResponse;
  readIdentity: ReadIdentityResponse;
  selectAppEnvironment: SelectAppEnvironmentResponse;
  readWorkspaceCatalog: ReadWorkspaceCatalogResponse;
  readTemplateCatalog: ReadTemplateCatalogResponse;
  createWorkspaceFromTemplate: CreateWorkspaceFromTemplateResponse;
  selectWorkspace: SelectWorkspaceResponse;
  selectWorldview: SelectWorldviewResponse;
  inspectSourceBundle: InspectSourceBundleResponse;
  uploadSourceBundle: UploadSourceBundleResponse;
  reuseSourceBundle: ReuseSourceBundleResponse;
  submitAdmission: SubmitAdmissionResponse;
  streamDiagnostics: StreamDiagnosticsResponse;
  readHostedApps: ReadHostedAppsResponse;
  readCloudOperations: ReadCloudOperationsResponse;
  compatibilityReport: CompatibilityReportResponse;
  resolveProviderBindings: ResolveProviderBindingsResponse;
  readProviderBindings: ReadProviderBindingsResponse;
  startDeterministicTestRun: StartDeterministicTestRunResponse;
  pollDeterministicTestRun: PollDeterministicTestRunResponse;
  expectedOutputDiff: ExpectedOutputDiffResponse;
  retrieveEvidenceReceipt: RetrieveEvidenceReceiptResponse;
  validateEvidenceCache: ValidateEvidenceCacheResponse;
  refreshTrustBundle: RefreshTrustBundleResponse;
  webStudioDeepLink: WebStudioDeepLinkResponse;
  webStudioBoot: WebStudioBootResponse;
  activateDev: ActivateDevResponse;
  readRuntimeStatus: ReadRuntimeStatusResponse;
  readActivity: ReadActivityResponse;
  readObservations: ReadObservationsResponse;
  readFacts: ReadFactsResponse;
  readIntents: ReadIntentsResponse;
  readEffects: ReadEffectsResponse;
  readProvenance: ReadProvenanceResponse;
  readWorkviews: ReadWorkviewsResponse;
  readSchedules: ReadSchedulesResponse;
  readQueues: ReadQueuesResponse;
  readAgents: ReadAgentsResponse;
  inspectAgent: InspectAgentResponse;
  readAgentSessions: ReadAgentSessionsResponse;
  startAgentSession: StartAgentSessionResponse;
  readAgentTranscript: ReadAgentTranscriptResponse;
  sendAgentMessage: SendAgentMessageResponse;
  readAgentTrace: ReadAgentTraceResponse;
  readOntologySummary: ReadOntologySummaryResponse;
  readOntologyRelation: ReadOntologyRelationResponse;
  readOntologySource: ReadOntologySourceResponse;
  readOntologyRuleGraph: ReadOntologyRuleGraphResponse;
  readActivityViews: ReadActivityViewsResponse;
  saveActivityView: SaveActivityViewResponse;
  deleteActivityView: DeleteActivityViewResponse;
  readActivitySessionCatalog: ReadActivitySessionCatalogResponse;
  readScheduleDetail: ReadScheduleDetailResponse;
  readScheduleFires: ReadScheduleFiresResponse;
  previewSchedule: PreviewScheduleResponse;
  createSchedule: CreateScheduleResponse;
  updateSchedule: UpdateScheduleResponse;
  pauseSchedule: PauseScheduleResponse;
  resumeSchedule: ResumeScheduleResponse;
  triggerSchedule: TriggerScheduleResponse;
  removeSchedule: RemoveScheduleResponse;
  readStorageUsage: ReadStorageUsageResponse;
  readBlobInventory: ReadBlobInventoryResponse;
  inspectBlob: InspectBlobResponse;
  downloadBlob: DownloadBlobResponse;
  uploadBlob: UploadBlobResponse;
  reclaimBlobsDryRun: ReclaimBlobsDryRunResponse;
  reclaimBlobsConfirm: ReclaimBlobsConfirmResponse;
  readCommandCatalog: ReadCommandCatalogResponse;
  startReplayRun: StartReplayRunResponse;
  pollReplayRun: PollReplayRunResponse;
  previewWorkspaceExport: PreviewWorkspaceExportResponse;
  garbageCollectDryRun: GarbageCollectDryRunResponse;
  garbageCollectConfirm: GarbageCollectConfirmResponse;
  readReconcileQueue: ReadReconcileQueueResponse;
  previewReconcile: PreviewReconcileResponse;
  commitReconcile: CommitReconcileResponse;
  readContradictions: ReadContradictionsResponse;
  previewContradictionResolution: PreviewContradictionResolutionResponse;
  commitContradictionResolution: CommitContradictionResolutionResponse;
  readStudioSettings: ReadStudioSettingsResponse;
  updateStudioSettings: UpdateStudioSettingsResponse;
  updateTelemetryPreference: UpdateTelemetryPreferenceResponse;
  previewObservationMapping: PreviewObservationMappingResponse;
  exportWorkspace: ExportWorkspaceResponse;
  readSecretsMetadata: ReadSecretsMetadataResponse;
  readReadiness: ReadReadinessResponse;
  readUsage: ReadUsageResponse;
  readBillingOverview: ReadBillingOverviewResponse;
  queryCapabilityDiscovery: QueryCapabilityDiscoveryResponse;
  queryListDeclared: QueryListDeclaredResponse;
  queryExecuteNamed: QueryExecuteNamedResponse;
  queryExecuteAdhoc: QueryExecuteAdhocResponse;
  queryExplain: QueryExplainResponse;
  queryContinueCursor: QueryContinueCursorResponse;
  querySupportWitness: QuerySupportWitnessResponse;
  queryAccessAuditRead: QueryAccessAuditReadResponse;
  queryHistory: QueryHistoryResponse;
  queryContextManifest: QueryContextManifestResponse;
  queryAuditExport: QueryAuditExportResponse;
  queryRetainedAdhocRerun: QueryRetainedAdhocRerunResponse;
  queryBrowseRelation: QueryBrowseRelationResponse;
  querySaveOperatorQuery: QuerySaveOperatorQueryResponse;
  queryDeleteOperatorQuery: QueryDeleteOperatorQueryResponse;
  queryExportSaved: QueryExportSavedResponse;
  mutateObservation: MutateObservationResponse;
  promoteActivation: PromoteActivationResponse;
  rollbackActivation: RollbackActivationResponse;
  upgradeRuntime: UpgradeRuntimeResponse;
  manageSecretGrant: ManageSecretGrantResponse;
  supportSnapshot: SupportSnapshotResponse;
}

export interface WebStudioCloudApiTransportRequest<Operation extends WebStudioCloudApiOperation> {
  method: "GET" | "POST";
  path: string;
  operation: Operation;
  operationId: (typeof webStudioCloudApiOperations)[Operation]["operationId"];
  operationContract: (typeof webStudioCloudApiOperations)[Operation]["operationContract"];
  request: WebStudioCloudApiRequestByOperation[Operation];
}

export interface WebStudioCloudApiTransport {
  request<Operation extends WebStudioCloudApiOperation>(input: WebStudioCloudApiTransportRequest<Operation>): Promise<WebStudioCloudApiResponseByOperation[Operation]>;
}

export class WebStudioCloudApiClient {
  constructor(private readonly transport: WebStudioCloudApiTransport) {}

  request<Operation extends WebStudioCloudApiOperation>(
    operation: Operation,
    request: WebStudioCloudApiRequestByOperation[Operation],
  ): Promise<WebStudioCloudApiResponseByOperation[Operation]> {
    const contract = webStudioCloudApiOperations[operation];
    return this.transport.request({
      method: contract.method,
      path: fillPathParams(contract.path, request.params ?? {}),
      operation,
      operationId: contract.operationId,
      operationContract: contract.operationContract,
      request,
    });
  }

  async authenticate(request: AuthenticateRequest): Promise<AuthenticateResponse> {
    return this.request("authenticate", request);
  }

  async authenticateStart(request: AuthenticateStartRequest): Promise<AuthenticateStartResponse> {
    return this.request("authenticateStart", request);
  }

  async signOut(request: SignOutRequest): Promise<SignOutResponse> {
    return this.request("signOut", request);
  }

  async selectWorkspaceEnvironment(request: SelectWorkspaceEnvironmentRequest): Promise<SelectWorkspaceEnvironmentResponse> {
    return this.request("selectWorkspaceEnvironment", request);
  }

  async readIdentity(request: ReadIdentityRequest): Promise<ReadIdentityResponse> {
    return this.request("readIdentity", request);
  }

  async selectAppEnvironment(request: SelectAppEnvironmentRequest): Promise<SelectAppEnvironmentResponse> {
    return this.request("selectAppEnvironment", request);
  }

  async readWorkspaceCatalog(request: ReadWorkspaceCatalogRequest): Promise<ReadWorkspaceCatalogResponse> {
    return this.request("readWorkspaceCatalog", request);
  }

  async readTemplateCatalog(request: ReadTemplateCatalogRequest): Promise<ReadTemplateCatalogResponse> {
    return this.request("readTemplateCatalog", request);
  }

  async createWorkspaceFromTemplate(request: CreateWorkspaceFromTemplateRequest): Promise<CreateWorkspaceFromTemplateResponse> {
    return this.request("createWorkspaceFromTemplate", request);
  }

  async selectWorkspace(request: SelectWorkspaceRequest): Promise<SelectWorkspaceResponse> {
    return this.request("selectWorkspace", request);
  }

  async selectWorldview(request: SelectWorldviewRequest): Promise<SelectWorldviewResponse> {
    return this.request("selectWorldview", request);
  }

  async inspectSourceBundle(request: InspectSourceBundleRequest): Promise<InspectSourceBundleResponse> {
    return this.request("inspectSourceBundle", request);
  }

  async uploadSourceBundle(request: UploadSourceBundleRequest): Promise<UploadSourceBundleResponse> {
    return this.request("uploadSourceBundle", request);
  }

  async reuseSourceBundle(request: ReuseSourceBundleRequest): Promise<ReuseSourceBundleResponse> {
    return this.request("reuseSourceBundle", request);
  }

  async submitAdmission(request: SubmitAdmissionRequest): Promise<SubmitAdmissionResponse> {
    return this.request("submitAdmission", request);
  }

  async streamDiagnostics(request: StreamDiagnosticsRequest): Promise<StreamDiagnosticsResponse> {
    return this.request("streamDiagnostics", request);
  }

  async readHostedApps(request: ReadHostedAppsRequest): Promise<ReadHostedAppsResponse> {
    return this.request("readHostedApps", request);
  }

  async readCloudOperations(request: ReadCloudOperationsRequest): Promise<ReadCloudOperationsResponse> {
    return this.request("readCloudOperations", request);
  }

  async compatibilityReport(request: CompatibilityReportRequest): Promise<CompatibilityReportResponse> {
    return this.request("compatibilityReport", request);
  }

  async resolveProviderBindings(request: ResolveProviderBindingsRequest): Promise<ResolveProviderBindingsResponse> {
    return this.request("resolveProviderBindings", request);
  }

  async readProviderBindings(request: ReadProviderBindingsRequest): Promise<ReadProviderBindingsResponse> {
    return this.request("readProviderBindings", request);
  }

  async startDeterministicTestRun(request: StartDeterministicTestRunRequest): Promise<StartDeterministicTestRunResponse> {
    return this.request("startDeterministicTestRun", request);
  }

  async pollDeterministicTestRun(request: PollDeterministicTestRunRequest): Promise<PollDeterministicTestRunResponse> {
    return this.request("pollDeterministicTestRun", request);
  }

  async expectedOutputDiff(request: ExpectedOutputDiffRequest): Promise<ExpectedOutputDiffResponse> {
    return this.request("expectedOutputDiff", request);
  }

  async retrieveEvidenceReceipt(request: RetrieveEvidenceReceiptRequest): Promise<RetrieveEvidenceReceiptResponse> {
    return this.request("retrieveEvidenceReceipt", request);
  }

  async validateEvidenceCache(request: ValidateEvidenceCacheRequest): Promise<ValidateEvidenceCacheResponse> {
    return this.request("validateEvidenceCache", request);
  }

  async refreshTrustBundle(request: RefreshTrustBundleRequest): Promise<RefreshTrustBundleResponse> {
    return this.request("refreshTrustBundle", request);
  }

  async webStudioDeepLink(request: WebStudioDeepLinkRequest): Promise<WebStudioDeepLinkResponse> {
    return this.request("webStudioDeepLink", request);
  }

  async webStudioBoot(request: WebStudioBootRequest): Promise<WebStudioBootResponse> {
    return this.request("webStudioBoot", request);
  }

  async activateDev(request: ActivateDevRequest): Promise<ActivateDevResponse> {
    return this.request("activateDev", request);
  }

  async readRuntimeStatus(request: ReadRuntimeStatusRequest): Promise<ReadRuntimeStatusResponse> {
    return this.request("readRuntimeStatus", request);
  }

  async readActivity(request: ReadActivityRequest): Promise<ReadActivityResponse> {
    return this.request("readActivity", request);
  }

  async readObservations(request: ReadObservationsRequest): Promise<ReadObservationsResponse> {
    return this.request("readObservations", request);
  }

  async readFacts(request: ReadFactsRequest): Promise<ReadFactsResponse> {
    return this.request("readFacts", request);
  }

  async readIntents(request: ReadIntentsRequest): Promise<ReadIntentsResponse> {
    return this.request("readIntents", request);
  }

  async readEffects(request: ReadEffectsRequest): Promise<ReadEffectsResponse> {
    return this.request("readEffects", request);
  }

  async readProvenance(request: ReadProvenanceRequest): Promise<ReadProvenanceResponse> {
    return this.request("readProvenance", request);
  }

  async readWorkviews(request: ReadWorkviewsRequest): Promise<ReadWorkviewsResponse> {
    return this.request("readWorkviews", request);
  }

  async readSchedules(request: ReadSchedulesRequest): Promise<ReadSchedulesResponse> {
    return this.request("readSchedules", request);
  }

  async readQueues(request: ReadQueuesRequest): Promise<ReadQueuesResponse> {
    return this.request("readQueues", request);
  }

  async readAgents(request: ReadAgentsRequest): Promise<ReadAgentsResponse> {
    return this.request("readAgents", request);
  }

  async inspectAgent(request: InspectAgentRequest): Promise<InspectAgentResponse> {
    return this.request("inspectAgent", request);
  }

  async readAgentSessions(request: ReadAgentSessionsRequest): Promise<ReadAgentSessionsResponse> {
    return this.request("readAgentSessions", request);
  }

  async startAgentSession(request: StartAgentSessionRequest): Promise<StartAgentSessionResponse> {
    return this.request("startAgentSession", request);
  }

  async readAgentTranscript(request: ReadAgentTranscriptRequest): Promise<ReadAgentTranscriptResponse> {
    return this.request("readAgentTranscript", request);
  }

  async sendAgentMessage(request: SendAgentMessageRequest): Promise<SendAgentMessageResponse> {
    return this.request("sendAgentMessage", request);
  }

  async readAgentTrace(request: ReadAgentTraceRequest): Promise<ReadAgentTraceResponse> {
    return this.request("readAgentTrace", request);
  }

  async readOntologySummary(request: ReadOntologySummaryRequest): Promise<ReadOntologySummaryResponse> {
    return this.request("readOntologySummary", request);
  }

  async readOntologyRelation(request: ReadOntologyRelationRequest): Promise<ReadOntologyRelationResponse> {
    return this.request("readOntologyRelation", request);
  }

  async readOntologySource(request: ReadOntologySourceRequest): Promise<ReadOntologySourceResponse> {
    return this.request("readOntologySource", request);
  }

  async readOntologyRuleGraph(request: ReadOntologyRuleGraphRequest): Promise<ReadOntologyRuleGraphResponse> {
    return this.request("readOntologyRuleGraph", request);
  }

  async readActivityViews(request: ReadActivityViewsRequest): Promise<ReadActivityViewsResponse> {
    return this.request("readActivityViews", request);
  }

  async saveActivityView(request: SaveActivityViewRequest): Promise<SaveActivityViewResponse> {
    return this.request("saveActivityView", request);
  }

  async deleteActivityView(request: DeleteActivityViewRequest): Promise<DeleteActivityViewResponse> {
    return this.request("deleteActivityView", request);
  }

  async readActivitySessionCatalog(request: ReadActivitySessionCatalogRequest): Promise<ReadActivitySessionCatalogResponse> {
    return this.request("readActivitySessionCatalog", request);
  }

  async readScheduleDetail(request: ReadScheduleDetailRequest): Promise<ReadScheduleDetailResponse> {
    return this.request("readScheduleDetail", request);
  }

  async readScheduleFires(request: ReadScheduleFiresRequest): Promise<ReadScheduleFiresResponse> {
    return this.request("readScheduleFires", request);
  }

  async previewSchedule(request: PreviewScheduleRequest): Promise<PreviewScheduleResponse> {
    return this.request("previewSchedule", request);
  }

  async createSchedule(request: CreateScheduleRequest): Promise<CreateScheduleResponse> {
    return this.request("createSchedule", request);
  }

  async updateSchedule(request: UpdateScheduleRequest): Promise<UpdateScheduleResponse> {
    return this.request("updateSchedule", request);
  }

  async pauseSchedule(request: PauseScheduleRequest): Promise<PauseScheduleResponse> {
    return this.request("pauseSchedule", request);
  }

  async resumeSchedule(request: ResumeScheduleRequest): Promise<ResumeScheduleResponse> {
    return this.request("resumeSchedule", request);
  }

  async triggerSchedule(request: TriggerScheduleRequest): Promise<TriggerScheduleResponse> {
    return this.request("triggerSchedule", request);
  }

  async removeSchedule(request: RemoveScheduleRequest): Promise<RemoveScheduleResponse> {
    return this.request("removeSchedule", request);
  }

  async readStorageUsage(request: ReadStorageUsageRequest): Promise<ReadStorageUsageResponse> {
    return this.request("readStorageUsage", request);
  }

  async readBlobInventory(request: ReadBlobInventoryRequest): Promise<ReadBlobInventoryResponse> {
    return this.request("readBlobInventory", request);
  }

  async inspectBlob(request: InspectBlobRequest): Promise<InspectBlobResponse> {
    return this.request("inspectBlob", request);
  }

  async downloadBlob(request: DownloadBlobRequest): Promise<DownloadBlobResponse> {
    return this.request("downloadBlob", request);
  }

  async uploadBlob(request: UploadBlobRequest): Promise<UploadBlobResponse> {
    return this.request("uploadBlob", request);
  }

  async reclaimBlobsDryRun(request: ReclaimBlobsDryRunRequest): Promise<ReclaimBlobsDryRunResponse> {
    return this.request("reclaimBlobsDryRun", request);
  }

  async reclaimBlobsConfirm(request: ReclaimBlobsConfirmRequest): Promise<ReclaimBlobsConfirmResponse> {
    return this.request("reclaimBlobsConfirm", request);
  }

  async readCommandCatalog(request: ReadCommandCatalogRequest): Promise<ReadCommandCatalogResponse> {
    return this.request("readCommandCatalog", request);
  }

  async startReplayRun(request: StartReplayRunRequest): Promise<StartReplayRunResponse> {
    return this.request("startReplayRun", request);
  }

  async pollReplayRun(request: PollReplayRunRequest): Promise<PollReplayRunResponse> {
    return this.request("pollReplayRun", request);
  }

  async previewWorkspaceExport(request: PreviewWorkspaceExportRequest): Promise<PreviewWorkspaceExportResponse> {
    return this.request("previewWorkspaceExport", request);
  }

  async garbageCollectDryRun(request: GarbageCollectDryRunRequest): Promise<GarbageCollectDryRunResponse> {
    return this.request("garbageCollectDryRun", request);
  }

  async garbageCollectConfirm(request: GarbageCollectConfirmRequest): Promise<GarbageCollectConfirmResponse> {
    return this.request("garbageCollectConfirm", request);
  }

  async readReconcileQueue(request: ReadReconcileQueueRequest): Promise<ReadReconcileQueueResponse> {
    return this.request("readReconcileQueue", request);
  }

  async previewReconcile(request: PreviewReconcileRequest): Promise<PreviewReconcileResponse> {
    return this.request("previewReconcile", request);
  }

  async commitReconcile(request: CommitReconcileRequest): Promise<CommitReconcileResponse> {
    return this.request("commitReconcile", request);
  }

  async readContradictions(request: ReadContradictionsRequest): Promise<ReadContradictionsResponse> {
    return this.request("readContradictions", request);
  }

  async previewContradictionResolution(request: PreviewContradictionResolutionRequest): Promise<PreviewContradictionResolutionResponse> {
    return this.request("previewContradictionResolution", request);
  }

  async commitContradictionResolution(request: CommitContradictionResolutionRequest): Promise<CommitContradictionResolutionResponse> {
    return this.request("commitContradictionResolution", request);
  }

  async readStudioSettings(request: ReadStudioSettingsRequest): Promise<ReadStudioSettingsResponse> {
    return this.request("readStudioSettings", request);
  }

  async updateStudioSettings(request: UpdateStudioSettingsRequest): Promise<UpdateStudioSettingsResponse> {
    return this.request("updateStudioSettings", request);
  }

  async updateTelemetryPreference(request: UpdateTelemetryPreferenceRequest): Promise<UpdateTelemetryPreferenceResponse> {
    return this.request("updateTelemetryPreference", request);
  }

  async previewObservationMapping(request: PreviewObservationMappingRequest): Promise<PreviewObservationMappingResponse> {
    return this.request("previewObservationMapping", request);
  }

  async exportWorkspace(request: ExportWorkspaceRequest): Promise<ExportWorkspaceResponse> {
    return this.request("exportWorkspace", request);
  }

  async readSecretsMetadata(request: ReadSecretsMetadataRequest): Promise<ReadSecretsMetadataResponse> {
    return this.request("readSecretsMetadata", request);
  }

  async readReadiness(request: ReadReadinessRequest): Promise<ReadReadinessResponse> {
    return this.request("readReadiness", request);
  }

  async readUsage(request: ReadUsageRequest): Promise<ReadUsageResponse> {
    return this.request("readUsage", request);
  }

  async readBillingOverview(request: ReadBillingOverviewRequest): Promise<ReadBillingOverviewResponse> {
    return this.request("readBillingOverview", request);
  }

  async queryCapabilityDiscovery(request: QueryCapabilityDiscoveryRequest): Promise<QueryCapabilityDiscoveryResponse> {
    return this.request("queryCapabilityDiscovery", request);
  }

  async queryListDeclared(request: QueryListDeclaredRequest): Promise<QueryListDeclaredResponse> {
    return this.request("queryListDeclared", request);
  }

  async queryExecuteNamed(request: QueryExecuteNamedRequest): Promise<QueryExecuteNamedResponse> {
    return this.request("queryExecuteNamed", request);
  }

  async queryExecuteAdhoc(request: QueryExecuteAdhocRequest): Promise<QueryExecuteAdhocResponse> {
    return this.request("queryExecuteAdhoc", request);
  }

  async queryExplain(request: QueryExplainRequest): Promise<QueryExplainResponse> {
    return this.request("queryExplain", request);
  }

  async queryContinueCursor(request: QueryContinueCursorRequest): Promise<QueryContinueCursorResponse> {
    return this.request("queryContinueCursor", request);
  }

  async querySupportWitness(request: QuerySupportWitnessRequest): Promise<QuerySupportWitnessResponse> {
    return this.request("querySupportWitness", request);
  }

  async queryAccessAuditRead(request: QueryAccessAuditReadRequest): Promise<QueryAccessAuditReadResponse> {
    return this.request("queryAccessAuditRead", request);
  }

  async queryHistory(request: QueryHistoryRequest): Promise<QueryHistoryResponse> {
    return this.request("queryHistory", request);
  }

  async queryContextManifest(request: QueryContextManifestRequest): Promise<QueryContextManifestResponse> {
    return this.request("queryContextManifest", request);
  }

  async queryAuditExport(request: QueryAuditExportRequest): Promise<QueryAuditExportResponse> {
    return this.request("queryAuditExport", request);
  }

  async queryRetainedAdhocRerun(request: QueryRetainedAdhocRerunRequest): Promise<QueryRetainedAdhocRerunResponse> {
    return this.request("queryRetainedAdhocRerun", request);
  }

  async queryBrowseRelation(request: QueryBrowseRelationRequest): Promise<QueryBrowseRelationResponse> {
    return this.request("queryBrowseRelation", request);
  }

  async querySaveOperatorQuery(request: QuerySaveOperatorQueryRequest): Promise<QuerySaveOperatorQueryResponse> {
    return this.request("querySaveOperatorQuery", request);
  }

  async queryDeleteOperatorQuery(request: QueryDeleteOperatorQueryRequest): Promise<QueryDeleteOperatorQueryResponse> {
    return this.request("queryDeleteOperatorQuery", request);
  }

  async queryExportSaved(request: QueryExportSavedRequest): Promise<QueryExportSavedResponse> {
    return this.request("queryExportSaved", request);
  }

  async mutateObservation(request: MutateObservationRequest): Promise<MutateObservationResponse> {
    return this.request("mutateObservation", request);
  }

  async promoteActivation(request: PromoteActivationRequest): Promise<PromoteActivationResponse> {
    return this.request("promoteActivation", request);
  }

  async rollbackActivation(request: RollbackActivationRequest): Promise<RollbackActivationResponse> {
    return this.request("rollbackActivation", request);
  }

  async upgradeRuntime(request: UpgradeRuntimeRequest): Promise<UpgradeRuntimeResponse> {
    return this.request("upgradeRuntime", request);
  }

  async manageSecretGrant(request: ManageSecretGrantRequest): Promise<ManageSecretGrantResponse> {
    return this.request("manageSecretGrant", request);
  }

  async supportSnapshot(request: SupportSnapshotRequest): Promise<SupportSnapshotResponse> {
    return this.request("supportSnapshot", request);
  }

}

function fillPathParams(path: string, params: WebStudioPathParams): string {
  return path.replace(/\{([^}]+)\}/g, (_match, key: string) => {
    const value = params[key];
    if (value === undefined) {
      throw new Error(`Missing Web Studio cloud API path parameter: ${key}`);
    }
    return encodeURIComponent(String(value));
  });
}
